// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.11.2
//   protoc               v5.26.1
// source: rtc/jobs.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import { RigEffectiveConfig } from "../atk/effective_config";
import { AutonomousActivityType, autonomousActivityTypeFromJSON, autonomousActivityTypeToJSON } from "../atk/enums";
import { JobType, jobTypeFromJSON, jobTypeToJSON } from "../atk/job_type";
import { ObstacleData } from "../farm/farm";
import { AbLine, LineString, Point, PolygonRing } from "../geo/geo";
import { Duration } from "../google/protobuf/duration";
import { Empty } from "../google/protobuf/empty";
import { Struct } from "../google/protobuf/struct";
import { Timestamp } from "../google/protobuf/timestamp";
import { ImplementDefinition } from "./implement";
import { ManeuverConfiguration } from "./maneuver_config";
import { PathPlanConfiguration } from "./path_plan";
import { TractorDefinition } from "./tractor";

export const protobufPackage = "carbon.rtc";

/** Unified State for all objects */
export enum State {
  STATE_UNSPECIFIED = 0,
  PENDING = 1,
  READY = 2,
  IN_PROGRESS = 3,
  COMPLETED = 4,
  CANCELLED = 5,
  PAUSED = 6,
  FAILED = 7,
  ACKNOWLEDGED = 8,
  NEW = 9,
  UNRECOGNIZED = -1,
}

export function stateFromJSON(object: any): State {
  switch (object) {
    case 0:
    case "STATE_UNSPECIFIED":
      return State.STATE_UNSPECIFIED;
    case 1:
    case "PENDING":
      return State.PENDING;
    case 2:
    case "READY":
      return State.READY;
    case 3:
    case "IN_PROGRESS":
      return State.IN_PROGRESS;
    case 4:
    case "COMPLETED":
      return State.COMPLETED;
    case 5:
    case "CANCELLED":
      return State.CANCELLED;
    case 6:
    case "PAUSED":
      return State.PAUSED;
    case 7:
    case "FAILED":
      return State.FAILED;
    case 8:
    case "ACKNOWLEDGED":
      return State.ACKNOWLEDGED;
    case 9:
    case "NEW":
      return State.NEW;
    case -1:
    case "UNRECOGNIZED":
    default:
      return State.UNRECOGNIZED;
  }
}

export function stateToJSON(object: State): string {
  switch (object) {
    case State.STATE_UNSPECIFIED:
      return "STATE_UNSPECIFIED";
    case State.PENDING:
      return "PENDING";
    case State.READY:
      return "READY";
    case State.IN_PROGRESS:
      return "IN_PROGRESS";
    case State.COMPLETED:
      return "COMPLETED";
    case State.CANCELLED:
      return "CANCELLED";
    case State.PAUSED:
      return "PAUSED";
    case State.FAILED:
      return "FAILED";
    case State.ACKNOWLEDGED:
      return "ACKNOWLEDGED";
    case State.NEW:
      return "NEW";
    case State.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum TaskDesignation {
  TASK_DESIGNATION_UNKNOWN = 0,
  TASK_DESIGNATION_SETUP = 1,
  TASK_DESIGNATION_WORK = 2,
  UNRECOGNIZED = -1,
}

export function taskDesignationFromJSON(object: any): TaskDesignation {
  switch (object) {
    case 0:
    case "TASK_DESIGNATION_UNKNOWN":
      return TaskDesignation.TASK_DESIGNATION_UNKNOWN;
    case 1:
    case "TASK_DESIGNATION_SETUP":
      return TaskDesignation.TASK_DESIGNATION_SETUP;
    case 2:
    case "TASK_DESIGNATION_WORK":
      return TaskDesignation.TASK_DESIGNATION_WORK;
    case -1:
    case "UNRECOGNIZED":
    default:
      return TaskDesignation.UNRECOGNIZED;
  }
}

export function taskDesignationToJSON(object: TaskDesignation): string {
  switch (object) {
    case TaskDesignation.TASK_DESIGNATION_UNKNOWN:
      return "TASK_DESIGNATION_UNKNOWN";
    case TaskDesignation.TASK_DESIGNATION_SETUP:
      return "TASK_DESIGNATION_SETUP";
    case TaskDesignation.TASK_DESIGNATION_WORK:
      return "TASK_DESIGNATION_WORK";
    case TaskDesignation.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum WaitToProceedReason {
  WAIT_TO_PROCEED_REASON_UNSPECIFIED = 0,
  WAIT_TO_PROCEED_REASON_CENTER_PIVOT_CROSSING = 1,
  UNRECOGNIZED = -1,
}

export function waitToProceedReasonFromJSON(object: any): WaitToProceedReason {
  switch (object) {
    case 0:
    case "WAIT_TO_PROCEED_REASON_UNSPECIFIED":
      return WaitToProceedReason.WAIT_TO_PROCEED_REASON_UNSPECIFIED;
    case 1:
    case "WAIT_TO_PROCEED_REASON_CENTER_PIVOT_CROSSING":
      return WaitToProceedReason.WAIT_TO_PROCEED_REASON_CENTER_PIVOT_CROSSING;
    case -1:
    case "UNRECOGNIZED":
    default:
      return WaitToProceedReason.UNRECOGNIZED;
  }
}

export function waitToProceedReasonToJSON(object: WaitToProceedReason): string {
  switch (object) {
    case WaitToProceedReason.WAIT_TO_PROCEED_REASON_UNSPECIFIED:
      return "WAIT_TO_PROCEED_REASON_UNSPECIFIED";
    case WaitToProceedReason.WAIT_TO_PROCEED_REASON_CENTER_PIVOT_CROSSING:
      return "WAIT_TO_PROCEED_REASON_CENTER_PIVOT_CROSSING";
    case WaitToProceedReason.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** A point on the rig to be used for task alignment and location reporting */
export enum RigPoint {
  RIG_POINT_UNSPECIFIED = 0,
  RIG_POINT_AXLE_FRONT = 1,
  RIG_POINT_IMPLEMENT_FRONT = 2,
  RIG_POINT_IMPLEMENT_REAR = 3,
  UNRECOGNIZED = -1,
}

export function rigPointFromJSON(object: any): RigPoint {
  switch (object) {
    case 0:
    case "RIG_POINT_UNSPECIFIED":
      return RigPoint.RIG_POINT_UNSPECIFIED;
    case 1:
    case "RIG_POINT_AXLE_FRONT":
      return RigPoint.RIG_POINT_AXLE_FRONT;
    case 2:
    case "RIG_POINT_IMPLEMENT_FRONT":
      return RigPoint.RIG_POINT_IMPLEMENT_FRONT;
    case 3:
    case "RIG_POINT_IMPLEMENT_REAR":
      return RigPoint.RIG_POINT_IMPLEMENT_REAR;
    case -1:
    case "UNRECOGNIZED":
    default:
      return RigPoint.UNRECOGNIZED;
  }
}

export function rigPointToJSON(object: RigPoint): string {
  switch (object) {
    case RigPoint.RIG_POINT_UNSPECIFIED:
      return "RIG_POINT_UNSPECIFIED";
    case RigPoint.RIG_POINT_AXLE_FRONT:
      return "RIG_POINT_AXLE_FRONT";
    case RigPoint.RIG_POINT_IMPLEMENT_FRONT:
      return "RIG_POINT_IMPLEMENT_FRONT";
    case RigPoint.RIG_POINT_IMPLEMENT_REAR:
      return "RIG_POINT_IMPLEMENT_REAR";
    case RigPoint.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum FollowMethod {
  FOLLOW_METHOD_UNSPECIFIED = 0,
  FOLLOW_METHOD_FURROW = 1,
  FOLLOW_METHOD_GPS = 2,
  UNRECOGNIZED = -1,
}

export function followMethodFromJSON(object: any): FollowMethod {
  switch (object) {
    case 0:
    case "FOLLOW_METHOD_UNSPECIFIED":
      return FollowMethod.FOLLOW_METHOD_UNSPECIFIED;
    case 1:
    case "FOLLOW_METHOD_FURROW":
      return FollowMethod.FOLLOW_METHOD_FURROW;
    case 2:
    case "FOLLOW_METHOD_GPS":
      return FollowMethod.FOLLOW_METHOD_GPS;
    case -1:
    case "UNRECOGNIZED":
    default:
      return FollowMethod.UNRECOGNIZED;
  }
}

export function followMethodToJSON(object: FollowMethod): string {
  switch (object) {
    case FollowMethod.FOLLOW_METHOD_UNSPECIFIED:
      return "FOLLOW_METHOD_UNSPECIFIED";
    case FollowMethod.FOLLOW_METHOD_FURROW:
      return "FOLLOW_METHOD_FURROW";
    case FollowMethod.FOLLOW_METHOD_GPS:
      return "FOLLOW_METHOD_GPS";
    case FollowMethod.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum GuidePathStatus {
  GUIDE_PATH_STATUS_UNSPECIFIED = 0,
  GUIDE_PATH_STATUS_OK = 1,
  /** GUIDE_PATH_STATUS_ERROR_EQUIPMENT - Invalid rig configuration */
  GUIDE_PATH_STATUS_ERROR_EQUIPMENT = 2,
  /** GUIDE_PATH_STATUS_ERROR_PATH_PLANNING - Failure in path planning service */
  GUIDE_PATH_STATUS_ERROR_PATH_PLANNING = 3,
  /** GUIDE_PATH_STATUS_ERROR_INTERNAL - Some other internal error */
  GUIDE_PATH_STATUS_ERROR_INTERNAL = 4,
  UNRECOGNIZED = -1,
}

export function guidePathStatusFromJSON(object: any): GuidePathStatus {
  switch (object) {
    case 0:
    case "GUIDE_PATH_STATUS_UNSPECIFIED":
      return GuidePathStatus.GUIDE_PATH_STATUS_UNSPECIFIED;
    case 1:
    case "GUIDE_PATH_STATUS_OK":
      return GuidePathStatus.GUIDE_PATH_STATUS_OK;
    case 2:
    case "GUIDE_PATH_STATUS_ERROR_EQUIPMENT":
      return GuidePathStatus.GUIDE_PATH_STATUS_ERROR_EQUIPMENT;
    case 3:
    case "GUIDE_PATH_STATUS_ERROR_PATH_PLANNING":
      return GuidePathStatus.GUIDE_PATH_STATUS_ERROR_PATH_PLANNING;
    case 4:
    case "GUIDE_PATH_STATUS_ERROR_INTERNAL":
      return GuidePathStatus.GUIDE_PATH_STATUS_ERROR_INTERNAL;
    case -1:
    case "UNRECOGNIZED":
    default:
      return GuidePathStatus.UNRECOGNIZED;
  }
}

export function guidePathStatusToJSON(object: GuidePathStatus): string {
  switch (object) {
    case GuidePathStatus.GUIDE_PATH_STATUS_UNSPECIFIED:
      return "GUIDE_PATH_STATUS_UNSPECIFIED";
    case GuidePathStatus.GUIDE_PATH_STATUS_OK:
      return "GUIDE_PATH_STATUS_OK";
    case GuidePathStatus.GUIDE_PATH_STATUS_ERROR_EQUIPMENT:
      return "GUIDE_PATH_STATUS_ERROR_EQUIPMENT";
    case GuidePathStatus.GUIDE_PATH_STATUS_ERROR_PATH_PLANNING:
      return "GUIDE_PATH_STATUS_ERROR_PATH_PLANNING";
    case GuidePathStatus.GUIDE_PATH_STATUS_ERROR_INTERNAL:
      return "GUIDE_PATH_STATUS_ERROR_INTERNAL";
    case GuidePathStatus.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum SpeedControl {
  SPEED_CONTROL_UNSPECIFIED = 0,
  USE_CONSTANT_SPEED = 1,
  REMOTE_OPERATOR_CONTROLLED = 2,
  IMPLEMENT_CONTROLLED = 3,
  CFG_DEFINED_DYNAMIC_CONSTANT = 4,
  CFG_DEFINED_DYNAMIC_WITH_MAX = 5,
  UNRECOGNIZED = -1,
}

export function speedControlFromJSON(object: any): SpeedControl {
  switch (object) {
    case 0:
    case "SPEED_CONTROL_UNSPECIFIED":
      return SpeedControl.SPEED_CONTROL_UNSPECIFIED;
    case 1:
    case "USE_CONSTANT_SPEED":
      return SpeedControl.USE_CONSTANT_SPEED;
    case 2:
    case "REMOTE_OPERATOR_CONTROLLED":
      return SpeedControl.REMOTE_OPERATOR_CONTROLLED;
    case 3:
    case "IMPLEMENT_CONTROLLED":
      return SpeedControl.IMPLEMENT_CONTROLLED;
    case 4:
    case "CFG_DEFINED_DYNAMIC_CONSTANT":
      return SpeedControl.CFG_DEFINED_DYNAMIC_CONSTANT;
    case 5:
    case "CFG_DEFINED_DYNAMIC_WITH_MAX":
      return SpeedControl.CFG_DEFINED_DYNAMIC_WITH_MAX;
    case -1:
    case "UNRECOGNIZED":
    default:
      return SpeedControl.UNRECOGNIZED;
  }
}

export function speedControlToJSON(object: SpeedControl): string {
  switch (object) {
    case SpeedControl.SPEED_CONTROL_UNSPECIFIED:
      return "SPEED_CONTROL_UNSPECIFIED";
    case SpeedControl.USE_CONSTANT_SPEED:
      return "USE_CONSTANT_SPEED";
    case SpeedControl.REMOTE_OPERATOR_CONTROLLED:
      return "REMOTE_OPERATOR_CONTROLLED";
    case SpeedControl.IMPLEMENT_CONTROLLED:
      return "IMPLEMENT_CONTROLLED";
    case SpeedControl.CFG_DEFINED_DYNAMIC_CONSTANT:
      return "CFG_DEFINED_DYNAMIC_CONSTANT";
    case SpeedControl.CFG_DEFINED_DYNAMIC_WITH_MAX:
      return "CFG_DEFINED_DYNAMIC_WITH_MAX";
    case SpeedControl.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum CfgDefinedSpeedName {
  SPEED_CFG_UNDEFINED = 0,
  SPEED_CFG_TOOL_SPEED = 1,
  SPEED_CFG_TRANSITION_SPEED = 2,
  SPEED_CFG_TRANSPORT_SPEED = 3,
  SPEED_CFG_ROW_TRAVERSAL_SPEED = 4,
  UNRECOGNIZED = -1,
}

export function cfgDefinedSpeedNameFromJSON(object: any): CfgDefinedSpeedName {
  switch (object) {
    case 0:
    case "SPEED_CFG_UNDEFINED":
      return CfgDefinedSpeedName.SPEED_CFG_UNDEFINED;
    case 1:
    case "SPEED_CFG_TOOL_SPEED":
      return CfgDefinedSpeedName.SPEED_CFG_TOOL_SPEED;
    case 2:
    case "SPEED_CFG_TRANSITION_SPEED":
      return CfgDefinedSpeedName.SPEED_CFG_TRANSITION_SPEED;
    case 3:
    case "SPEED_CFG_TRANSPORT_SPEED":
      return CfgDefinedSpeedName.SPEED_CFG_TRANSPORT_SPEED;
    case 4:
    case "SPEED_CFG_ROW_TRAVERSAL_SPEED":
      return CfgDefinedSpeedName.SPEED_CFG_ROW_TRAVERSAL_SPEED;
    case -1:
    case "UNRECOGNIZED":
    default:
      return CfgDefinedSpeedName.UNRECOGNIZED;
  }
}

export function cfgDefinedSpeedNameToJSON(object: CfgDefinedSpeedName): string {
  switch (object) {
    case CfgDefinedSpeedName.SPEED_CFG_UNDEFINED:
      return "SPEED_CFG_UNDEFINED";
    case CfgDefinedSpeedName.SPEED_CFG_TOOL_SPEED:
      return "SPEED_CFG_TOOL_SPEED";
    case CfgDefinedSpeedName.SPEED_CFG_TRANSITION_SPEED:
      return "SPEED_CFG_TRANSITION_SPEED";
    case CfgDefinedSpeedName.SPEED_CFG_TRANSPORT_SPEED:
      return "SPEED_CFG_TRANSPORT_SPEED";
    case CfgDefinedSpeedName.SPEED_CFG_ROW_TRAVERSAL_SPEED:
      return "SPEED_CFG_ROW_TRAVERSAL_SPEED";
    case CfgDefinedSpeedName.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum ChecklistAutomationCode {
  AUTOMATION_CODE_UNSPECIFIED = 0,
  AUTOMATION_CODE_NONE = 1,
  AUTOMATION_CODE_ENGINE_RUNNING = 2,
  UNRECOGNIZED = -1,
}

export function checklistAutomationCodeFromJSON(object: any): ChecklistAutomationCode {
  switch (object) {
    case 0:
    case "AUTOMATION_CODE_UNSPECIFIED":
      return ChecklistAutomationCode.AUTOMATION_CODE_UNSPECIFIED;
    case 1:
    case "AUTOMATION_CODE_NONE":
      return ChecklistAutomationCode.AUTOMATION_CODE_NONE;
    case 2:
    case "AUTOMATION_CODE_ENGINE_RUNNING":
      return ChecklistAutomationCode.AUTOMATION_CODE_ENGINE_RUNNING;
    case -1:
    case "UNRECOGNIZED":
    default:
      return ChecklistAutomationCode.UNRECOGNIZED;
  }
}

export function checklistAutomationCodeToJSON(object: ChecklistAutomationCode): string {
  switch (object) {
    case ChecklistAutomationCode.AUTOMATION_CODE_UNSPECIFIED:
      return "AUTOMATION_CODE_UNSPECIFIED";
    case ChecklistAutomationCode.AUTOMATION_CODE_NONE:
      return "AUTOMATION_CODE_NONE";
    case ChecklistAutomationCode.AUTOMATION_CODE_ENGINE_RUNNING:
      return "AUTOMATION_CODE_ENGINE_RUNNING";
    case ChecklistAutomationCode.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum InterventionCause {
  INTERVENTION_CAUSE_UNSPECIFIED = 0,
  SENSOR_TRIGGERED = 1,
  SAFETY_DRIVER_ACTION = 2,
  TRACTOR_REQUEST = 3,
  WATCHER_REQUEST = 4,
  USER_REQUEST = 5,
  BLIND_ZONE_CLEARANCE_REQUIRED = 6,
  UNRECOGNIZED = -1,
}

export function interventionCauseFromJSON(object: any): InterventionCause {
  switch (object) {
    case 0:
    case "INTERVENTION_CAUSE_UNSPECIFIED":
      return InterventionCause.INTERVENTION_CAUSE_UNSPECIFIED;
    case 1:
    case "SENSOR_TRIGGERED":
      return InterventionCause.SENSOR_TRIGGERED;
    case 2:
    case "SAFETY_DRIVER_ACTION":
      return InterventionCause.SAFETY_DRIVER_ACTION;
    case 3:
    case "TRACTOR_REQUEST":
      return InterventionCause.TRACTOR_REQUEST;
    case 4:
    case "WATCHER_REQUEST":
      return InterventionCause.WATCHER_REQUEST;
    case 5:
    case "USER_REQUEST":
      return InterventionCause.USER_REQUEST;
    case 6:
    case "BLIND_ZONE_CLEARANCE_REQUIRED":
      return InterventionCause.BLIND_ZONE_CLEARANCE_REQUIRED;
    case -1:
    case "UNRECOGNIZED":
    default:
      return InterventionCause.UNRECOGNIZED;
  }
}

export function interventionCauseToJSON(object: InterventionCause): string {
  switch (object) {
    case InterventionCause.INTERVENTION_CAUSE_UNSPECIFIED:
      return "INTERVENTION_CAUSE_UNSPECIFIED";
    case InterventionCause.SENSOR_TRIGGERED:
      return "SENSOR_TRIGGERED";
    case InterventionCause.SAFETY_DRIVER_ACTION:
      return "SAFETY_DRIVER_ACTION";
    case InterventionCause.TRACTOR_REQUEST:
      return "TRACTOR_REQUEST";
    case InterventionCause.WATCHER_REQUEST:
      return "WATCHER_REQUEST";
    case InterventionCause.USER_REQUEST:
      return "USER_REQUEST";
    case InterventionCause.BLIND_ZONE_CLEARANCE_REQUIRED:
      return "BLIND_ZONE_CLEARANCE_REQUIRED";
    case InterventionCause.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/**
 * Format of a path planner's opaque metadata, so callers can tell how to
 * interpret it without parsing it.
 */
export enum PathPlannerMetadataFormat {
  PATH_PLANNER_METADATA_FORMAT_UNSPECIFIED = 0,
  PATH_PLANNER_METADATA_FORMAT_CARBON_PLANNER_V1 = 1,
  UNRECOGNIZED = -1,
}

export function pathPlannerMetadataFormatFromJSON(object: any): PathPlannerMetadataFormat {
  switch (object) {
    case 0:
    case "PATH_PLANNER_METADATA_FORMAT_UNSPECIFIED":
      return PathPlannerMetadataFormat.PATH_PLANNER_METADATA_FORMAT_UNSPECIFIED;
    case 1:
    case "PATH_PLANNER_METADATA_FORMAT_CARBON_PLANNER_V1":
      return PathPlannerMetadataFormat.PATH_PLANNER_METADATA_FORMAT_CARBON_PLANNER_V1;
    case -1:
    case "UNRECOGNIZED":
    default:
      return PathPlannerMetadataFormat.UNRECOGNIZED;
  }
}

export function pathPlannerMetadataFormatToJSON(object: PathPlannerMetadataFormat): string {
  switch (object) {
    case PathPlannerMetadataFormat.PATH_PLANNER_METADATA_FORMAT_UNSPECIFIED:
      return "PATH_PLANNER_METADATA_FORMAT_UNSPECIFIED";
    case PathPlannerMetadataFormat.PATH_PLANNER_METADATA_FORMAT_CARBON_PLANNER_V1:
      return "PATH_PLANNER_METADATA_FORMAT_CARBON_PLANNER_V1";
    case PathPlannerMetadataFormat.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** Objective API */
export interface Objective {
  id: number;
  name: string;
  description: string;
  createdAt: string | undefined;
  updatedAt: string | undefined;
  estCompletionAt:
    | string
    | undefined;
  /** (0-100) */
  progressPercent: number;
  /** for ordering */
  priority: number;
  type: Objective_ObjectiveType;
  /**
   * dynamic/json to define, per objective info
   *  this is nice and flexible so for example laser weeding can be a row (start
   *  -> stop) but also be more.
   */
  data: { [key: string]: any } | undefined;
  assignment: ObjectiveAssignment | undefined;
  jobId: number;
  /** immutable 1-based index for display and cross-reference on comparable jobs */
  ordinal: number;
}

export enum Objective_ObjectiveType {
  OBJECTIVE_TYPE_UNSPECIFIED = 0,
  LASER_WEED_ROW = 1,
  GROUND_PREP_SECTION = 2,
  TRANSPORT = 3,
  MANEUVER = 4,
  IN_SEASON_ROW = 5,
  UNRECOGNIZED = -1,
}

export function objective_ObjectiveTypeFromJSON(object: any): Objective_ObjectiveType {
  switch (object) {
    case 0:
    case "OBJECTIVE_TYPE_UNSPECIFIED":
      return Objective_ObjectiveType.OBJECTIVE_TYPE_UNSPECIFIED;
    case 1:
    case "LASER_WEED_ROW":
      return Objective_ObjectiveType.LASER_WEED_ROW;
    case 2:
    case "GROUND_PREP_SECTION":
      return Objective_ObjectiveType.GROUND_PREP_SECTION;
    case 3:
    case "TRANSPORT":
      return Objective_ObjectiveType.TRANSPORT;
    case 4:
    case "MANEUVER":
      return Objective_ObjectiveType.MANEUVER;
    case 5:
    case "IN_SEASON_ROW":
      return Objective_ObjectiveType.IN_SEASON_ROW;
    case -1:
    case "UNRECOGNIZED":
    default:
      return Objective_ObjectiveType.UNRECOGNIZED;
  }
}

export function objective_ObjectiveTypeToJSON(object: Objective_ObjectiveType): string {
  switch (object) {
    case Objective_ObjectiveType.OBJECTIVE_TYPE_UNSPECIFIED:
      return "OBJECTIVE_TYPE_UNSPECIFIED";
    case Objective_ObjectiveType.LASER_WEED_ROW:
      return "LASER_WEED_ROW";
    case Objective_ObjectiveType.GROUND_PREP_SECTION:
      return "GROUND_PREP_SECTION";
    case Objective_ObjectiveType.TRANSPORT:
      return "TRANSPORT";
    case Objective_ObjectiveType.MANEUVER:
      return "MANEUVER";
    case Objective_ObjectiveType.IN_SEASON_ROW:
      return "IN_SEASON_ROW";
    case Objective_ObjectiveType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export interface LaserWeedRowObjectiveData {
  /**
   * use ordinal from objective instead
   *
   * @deprecated
   */
  rowNum: number;
  abLine:
    | AbLine
    | undefined;
  /** distance shifted from original position */
  shiftedM: number;
}

export interface InSeasonRowObjectiveData {
  path:
    | LineString
    | undefined;
  /** distance shifted from original position */
  shiftedM: number;
}

export interface CenterPivotRange {
  /** currently the pointDef id of the pivot's center point */
  pivotId: string;
  center: Point | undefined;
  minHeading: number;
  maxHeading: number;
}

export interface GroundPrepSectionObjectiveData {
  /**
   * use ordinal from objective instead
   *
   * @deprecated
   */
  sectionNum: number;
  boundary: PolygonRing | undefined;
  pivotRanges: CenterPivotRange[];
  centroid: Point | undefined;
}

export interface TransportObjectiveData {
  path: LineString | undefined;
}

export interface ManeuverObjectiveData {
  robotSerial: string;
}

export interface LambdaPathPlannerRequest {
  groundPrepReq?: GroundPrepPathPlannerRequest | undefined;
  drawPathManeuverReq?: DrawPathManeuverPathPlannerRequest | undefined;
  eortaReq?: EORTAPathPlannerRequest | undefined;
}

export interface LambdaPathPlannerResponse {
  groundPrepResp?: GroundPrepPathPlannerResponse | undefined;
  drawPathManeuverResp?: DrawPathManeuverPathPlannerResponse | undefined;
  eortaResp?:
    | EORTAPathPlannerResponse
    | undefined;
  /** version signature of the path planner that produced this response */
  pathPlannerVersion?: string | undefined;
}

export interface GroundPrepPathPlannerRequest {
  config: GroundPrepJobConfiguration | undefined;
  boundary: PolygonRing | undefined;
  exportVizData: boolean;
  obstacles: GroundPrepObstacle[];
  subSection?: GroundPrepSubSection | undefined;
  effectiveConfig: RigEffectiveConfig | undefined;
}

export interface GroundPrepPathPlannerResponse {
  fieldBoundary: PolygonRing | undefined;
  rowBoundary: PolygonRing | undefined;
  tasks: Task[];
}

export interface DrawPathManeuverPathPlannerRequest {
  maneuverConfig: ManeuverConfiguration | undefined;
  inputLine: LineString | undefined;
}

export interface DrawPathManeuverPathPlannerResponse {
  task: Task | undefined;
}

export interface EORTAPathPlannerRequest {
  /** field boundary for outside turns */
  innerBoundary:
    | PolygonRing
    | undefined;
  /** outer boundary of EORTA area */
  outerBoundary: PolygonRing | undefined;
  exportVizData: boolean;
  obstacles: GroundPrepObstacle[];
  effectiveConfig: RigEffectiveConfig | undefined;
  startingPose: RigPose | undefined;
  endingPose: RigPose | undefined;
}

export interface EORTAPathPlannerResponse {
  task: Task | undefined;
}

export interface GroundPrepObstacle {
  boundary: PolygonRing | undefined;
  bufferMeters: number;
  data: ObstacleData | undefined;
}

export interface GroundPrepSubSection {
  /** point at which a split line rotates about */
  pivots: Point[];
  /** heading of the split lines */
  headingDeg: number;
  /** any point that is only within the sub */
  reference: Point | undefined;
}

export interface ObjectiveList {
  objectives: Objective[];
}

export interface ListObjectivesResponse {
  pageToken: string;
  objectives: Objective[];
}

export interface PivotRiskObjectivesResponse {
  /** Objectives at risk now but not in the future */
  decreasingRiskObjectives: Objective[];
  /** Objectives at risk in the future */
  increasingRiskObjectives: Objective[];
  previousPivotPositions: LineString[];
  currentPivotPositions: LineString[];
  futurePivotPositions: LineString[];
}

export interface GetNextActiveObjectiveRequest {
  objectiveId: number;
  expiresAt:
    | string
    | undefined;
  /**
   * Last-seen job assignment; 0 is not a valid job_id and signifies no job.
   * Presence of this field opts the client into job-aware long-polling: job
   * assignment changes wake the poll and the response includes the job, even
   * when no objective is assigned yet, so the robot always knows its job_id.
   * Old clients never set this field and keep the legacy behavior exactly.
   */
  jobId?:
    | number
    | undefined;
  /** Assignment version from the last response; echo it back unchanged. */
  updatedAt: string | undefined;
}

export interface GetNextActiveObjectiveResponse {
  objective:
    | Objective
    | undefined;
  /** Checklist expiry. */
  expiresAt?:
    | string
    | undefined;
  /**
   * Job the robot is assigned to, if any. Set only for job-aware requests
   * (job_id present); may be set with no objective. Job.objectives is left
   * empty to keep the payload small.
   */
  job:
    | Job
    | undefined;
  /**
   * Versions the assignment (job or checklist changes) and determines whether
   * the robot should resync; echo it back in the next request. Set only for
   * job-aware requests.
   */
  updatedAt: string | undefined;
}

export interface AutoCompleteObjectivesRequest {
  robotSerials: string[];
  lookbackWindow: Duration | undefined;
}

/** Objective Assignments API */
export interface ObjectiveAssignment {
  id: number;
  objectiveId: number;
  robotSerial: string;
  createdAt: string | undefined;
  updatedAt: string | undefined;
  priority?: number | undefined;
}

export interface ObjectiveAssignmentList {
  assignments: ObjectiveAssignment[];
}

export interface ListObjectiveAssignmentsResponse {
  pageToken: string;
  assignments: ObjectiveAssignment[];
}

export interface AssignNextObjectiveRequest {
  jobId: number;
  robotSerial: string;
}

/** Robot Whitelist API */
export interface RobotWhitelistEntry {
  robotSerial: string;
}

export interface RobotWhitelist {
  entries: RobotWhitelistEntry[];
}

export interface TaskMetadata {
  designation: TaskDesignation;
  activityType: AutonomousActivityType;
}

/** Task API */
export interface Task {
  id: number;
  name: string;
  createdAt: string | undefined;
  startedAt: string | undefined;
  updatedAt: string | undefined;
  endedAt: string | undefined;
  expectedDuration: Duration | undefined;
  statusInfo: string;
  expectedTractorState: TractorState[];
  state: State;
  priority: number;
  objectiveId: number;
  jobId: number;
  startLocation: Point | undefined;
  startHeading: number;
  endLocation: Point | undefined;
  endHeading: number;
  manuallyAssisted: boolean;
  progressUpdatedAt: string | undefined;
  progressLocation: Point | undefined;
  progressHeading: number;
  progressPath?: LineString | undefined;
  metadata: TaskMetadata | undefined;
  sequenceNumber?: number | undefined;
  parentTaskId?:
    | number
    | undefined;
  /** core structural task types */
  sequence?: SequenceTask | undefined;
  manual?:
    | ManualTask
    | undefined;
  /** tasks with specific automations available */
  goToAndFace?: GoToAndFaceTask | undefined;
  followPath?: FollowPathTask | undefined;
  getOnPath?: GetOnPathTask | undefined;
  tractorState?: SetTractorStateTask | undefined;
  laserWeed?: LaserWeedTask | undefined;
  stopAutonomy?: StopAutonomyTask | undefined;
  goToReversiblePath?: GoToReversiblePathTask | undefined;
  moveCenterPivot?: MoveCenterPivotTask | undefined;
  verifyCenterPivot?: VerifyCenterPivotTask | undefined;
  waitToProceed?: WaitToProceedTask | undefined;
  followFurrow?: FollowFurrowTask | undefined;
  workRow?: WorkRowTask | undefined;
}

/**
 * A `StopAutonomyTask` is to signal completion, allowing the robot to exit
 * autonomy mode and do nothing.
 */
export interface StopAutonomyTask {
}

/**
 * A `WaitToProceedTask` breaks autonomy so the operator can confirm an
 * environmental condition (e.g. center pivot is clear) before proceeding.
 * Functionally treated like GoToAndFace: tractor ramps down, stops, and
 * waits for operator acknowledgment.
 */
export interface WaitToProceedTask {
  reason: WaitToProceedReason;
  point: Point | undefined;
  heading: number;
  tolerances: SpatialPathTolerance | undefined;
}

/** Location and orientation of a rig for a specific point on that rig */
export interface RigPose {
  location: RigPointLocation | undefined;
  heading: number;
}

export interface LaserWeedTask {
  path: LineString | undefined;
  pathIsReversible: boolean;
  weedingEnabled: boolean;
  thinningEnabled: boolean;
  tolerances:
    | SpatialPathTolerance
    | undefined;
  /** Point on rig to align with start of path */
  rigAlignmentPoint: RigPoint;
}

/**
 * A `WorkRowTask` is a task that works along a GPS path from start to end,
 * used for in-season row-based operations like dammer-diking or cultivation.
 */
export interface WorkRowTask {
  path: LineString | undefined;
  pathIsReversible: boolean;
  followMethod: FollowMethod;
  speed: SpeedSetting | undefined;
  tolerances:
    | SpatialPathTolerance
    | undefined;
  /** Point on rig to align with start of path */
  rigAlignmentPoint: RigPoint;
}

/**
 * A `SequenceTask` requires completing all of its child tasks, in order, with
 * no overlap in time.
 */
export interface SequenceTask {
  items: Task[];
  /** If all tasks can't be completed without error, start over */
  atomic: boolean;
  /** All tasks should be dispatched to a robot in a single batch */
  batch: boolean;
}

/**
 * A `ManualTask` can only be completed by a human and will always require an
 * intervention request.
 */
export interface ManualTask {
  instructions: string;
}

/**
 * A `GoToAndFaceTask` requires that the robot move to a particular position
 * and face in a particular direction. For example, this might be used to line
 * up at the start of a row.
 */
export interface GoToAndFaceTask {
  point: Point | undefined;
  heading: number;
  tolerances: SpatialPathTolerance | undefined;
}

/**
 * A `MoveCenterPivotTask` requires that the center pivot be moved so that it
 * sits anywhere between the specified min and max headings. This is necessary
 * to ensure that the center pivot does not block the tractor's path in a
 * following task, for example when we are preparing to ground prep a section
 * of a circular field.
 */
export interface MoveCenterPivotTask {
  /** @deprecated */
  minHeading: number;
  /** @deprecated */
  maxHeading: number;
  pivotRange: CenterPivotRange | undefined;
}

/**
 * A `VerifyCenterPivotTask` requires verification that the center pivot is not
 * in the way of upcoming field operations. For example, after the center pivot
 * has has been moved, a human may be required to give the all-clear.
 */
export interface VerifyCenterPivotTask {
  /** @deprecated */
  minHeading: number;
  /** @deprecated */
  maxHeading: number;
  pivotRange: CenterPivotRange | undefined;
}

/**
 * A `GoToReversiblePathTask` requires that the robot move to one end of a path,
 * facing the other end of the first path segment. This is useful for lining
 * up at either end of a row (whichever is most convenient), or the start of a
 * more complex path like a ground prep pass. If guide path is provided, the
 * robot will follow it at the specified speed.
 */
export interface GoToReversiblePathTask {
  path: LineString | undefined;
  tolerances: SpatialPathTolerance | undefined;
  guidePath?: LineString | undefined;
  guidePathSpeed: SpeedSetting | undefined;
  guidePathStatus: GuidePathStatus;
  guidePathErrorDetails: string;
}

export interface FollowPathTask {
  /** @deprecated */
  path: LineString | undefined;
  speed: SpeedSetting | undefined;
  tolerances:
    | SpatialPathTolerance
    | undefined;
  /** @deprecated */
  speedOnCompletionMph?: number | undefined;
  completionSpeed?:
    | SpeedSetting
    | undefined;
  /** Paths that specific point(s) on the rig should follow */
  paths: RigPointPath[];
}

export interface FollowFurrowTask {
  path: LineString | undefined;
  speed: SpeedSetting | undefined;
  tolerances: SpatialPathTolerance | undefined;
}

/**
 * A `GetOnPathTask` requires that the robot position itself on a path,
 * aligned in the direction of the path. It can be positioned anywhere along
 * the path - it need not be near the start point. It must have a cross-track
 * error and heading error below the limits specified in `tolerances`. Note
 * that `tolerances.distance` is ignored as that specifies maximum distance
 * from the path start point, which we are not concerned with.
 */
export interface GetOnPathTask {
  path: LineString | undefined;
  tolerances: SpatialPathTolerance | undefined;
}

export interface SpeedSetting {
  constantMph: number;
  speedControl: SpeedControl;
  cfgDefinedSpeed: CfgDefinedSpeedName;
}

export interface SetTractorStateTask {
  state: TractorState[];
  validate: boolean;
  expectedPosition?: Point | undefined;
}

export interface TractorState {
  gear?: TractorState_Gear | undefined;
  hitch?: HitchState | undefined;
  llImplementState?: LLImpState | undefined;
}

export enum TractorState_Gear {
  GEAR_UNSPECIFIED = 0,
  PARK = 1,
  REVERSE = 2,
  NEUTRAL = 3,
  FORWARD = 4,
  POWERZERO = 5,
  UNRECOGNIZED = -1,
}

export function tractorState_GearFromJSON(object: any): TractorState_Gear {
  switch (object) {
    case 0:
    case "GEAR_UNSPECIFIED":
      return TractorState_Gear.GEAR_UNSPECIFIED;
    case 1:
    case "PARK":
      return TractorState_Gear.PARK;
    case 2:
    case "REVERSE":
      return TractorState_Gear.REVERSE;
    case 3:
    case "NEUTRAL":
      return TractorState_Gear.NEUTRAL;
    case 4:
    case "FORWARD":
      return TractorState_Gear.FORWARD;
    case 5:
    case "POWERZERO":
      return TractorState_Gear.POWERZERO;
    case -1:
    case "UNRECOGNIZED":
    default:
      return TractorState_Gear.UNRECOGNIZED;
  }
}

export function tractorState_GearToJSON(object: TractorState_Gear): string {
  switch (object) {
    case TractorState_Gear.GEAR_UNSPECIFIED:
      return "GEAR_UNSPECIFIED";
    case TractorState_Gear.PARK:
      return "PARK";
    case TractorState_Gear.REVERSE:
      return "REVERSE";
    case TractorState_Gear.NEUTRAL:
      return "NEUTRAL";
    case TractorState_Gear.FORWARD:
      return "FORWARD";
    case TractorState_Gear.POWERZERO:
      return "POWERZERO";
    case TractorState_Gear.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export interface HitchState {
  command?:
    | HitchState_HitchCommand
    | undefined;
  /** Target position, between 0.0 (fully lowered) and 1.0 (fully raised). */
  position?: number | undefined;
}

export enum HitchState_HitchCommand {
  HITCH_COMMAND_UNSPECIFIED = 0,
  RAISED = 1,
  LOWERED = 2,
  UNRECOGNIZED = -1,
}

export function hitchState_HitchCommandFromJSON(object: any): HitchState_HitchCommand {
  switch (object) {
    case 0:
    case "HITCH_COMMAND_UNSPECIFIED":
      return HitchState_HitchCommand.HITCH_COMMAND_UNSPECIFIED;
    case 1:
    case "RAISED":
      return HitchState_HitchCommand.RAISED;
    case 2:
    case "LOWERED":
      return HitchState_HitchCommand.LOWERED;
    case -1:
    case "UNRECOGNIZED":
    default:
      return HitchState_HitchCommand.UNRECOGNIZED;
  }
}

export function hitchState_HitchCommandToJSON(object: HitchState_HitchCommand): string {
  switch (object) {
    case HitchState_HitchCommand.HITCH_COMMAND_UNSPECIFIED:
      return "HITCH_COMMAND_UNSPECIFIED";
    case HitchState_HitchCommand.RAISED:
      return "RAISED";
    case HitchState_HitchCommand.LOWERED:
      return "LOWERED";
    case HitchState_HitchCommand.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export interface LLImpState {
  lifted?: Empty | undefined;
  lowered?: Empty | undefined;
}

export interface TaskList {
  tasks: Task[];
}

export interface ListTasksResponse {
  pageToken: string;
  tasks: Task[];
}

/**
 * SpatialPathTolerance is a set of tolerance values used to evaluate geo
 * spatial criteria based on location and/or heading.
 */
export interface SpatialPathTolerance {
  heading: number;
  crosstrack: number;
  distance: number;
  continuousCrosstrack: number;
}

/** Jobs API */
export interface Job {
  id: number;
  name: string;
  createdAt: string | undefined;
  startedAt: string | undefined;
  updatedAt: string | undefined;
  endedAt: string | undefined;
  objectives: Objective[];
  state: State;
  type: JobType;
  workOrderId?:
    | number
    | undefined;
  /** Farm ID per Portal, typically a 12-character alphanumeric string. */
  farmId: string;
  fieldId: string;
  acreage: number;
  /** Customer ID per Portal, typically a UUID. */
  customerId: string;
  priority: number;
  robotWhitelist: RobotWhitelist | undefined;
  progressPercent: number;
  estCompletionAt: string | undefined;
  dryRun: boolean;
  creationFailed: boolean;
  creationError: string;
  config?:
    | JobConfiguration
    | undefined;
  /** Auth0 user ID who created the job */
  createdBy: string;
  /** Auth0 user ID who last modified the job */
  updatedBy: string;
  /** Set of activity types used in any of this job's tasks */
  activityTypes: AutonomousActivityType[];
  /** Source and version of the tool that produced this job's path plan */
  pathPlannerSource?:
    | string
    | undefined;
  /** e.g., "1.23.4" */
  pathPlannerVersion?: string | undefined;
}

/**
 * Opaque metadata the path planner provided when the job was created,
 * stored but not parsed by the jobs service and returned via a separate
 * endpoint so as to not bloat the job response for all other callers.
 */
export interface JobPathPlannerMetadata {
  jobId: number;
  metadata: { [key: string]: any } | undefined;
  metadataFormat: PathPlannerMetadataFormat;
}

export interface JobMetrics {
  jobId: number;
  updatedAt:
    | string
    | undefined;
  /** Basic job metrics */
  readyAt: string | undefined;
  startedAt: string | undefined;
  endedAt:
    | string
    | undefined;
  /** wall-clock job time */
  totalTime:
    | Duration
    | undefined;
  /** time in the READY state */
  waitingTime:
    | Duration
    | undefined;
  /** time in the IN_PROGRESS state */
  activeTime:
    | Duration
    | undefined;
  /** # of robots working on the job */
  numRobots: number;
  /** Total working/idle times (totals for all tasks and robots) */
  workingTime: Duration | undefined;
  workingTimeManual: Duration | undefined;
  workingTimeAuto: Duration | undefined;
  idleTime:
    | Duration
    | undefined;
  /** Per-robot average working/idle times (time / num_robots) */
  avgWorkingTime: Duration | undefined;
  avgWorkingTimeManual: Duration | undefined;
  avgWorkingTimeAuto: Duration | undefined;
  avgIdleTime:
    | Duration
    | undefined;
  /** Per-robot time percentages (avg time / active or working_time) */
  avgWorkingTimePercent: number;
  avgWorkingTimeManualPercent: number;
  avgWorkingTimeAutoPercent: number;
  avgActiveTimeManualPercent: number;
  avgActiveTimeAutoPercent: number;
  avgIdleTimePercent: number;
  /** Intervention metrics */
  totalInterventions: number;
  /** total_interventions / active_time */
  ivsPerActiveHour: number;
  /** total_interventions / working_time_auto */
  ivsPerAutoHour: number;
  /** Intervention lifecycle total durations { NEW -> IN_PROGRESS -> COMPLETED } */
  totalIvTime:
    | Duration
    | undefined;
  /** NEW -> IN_PROGRESS */
  ivWaitingTime:
    | Duration
    | undefined;
  /** IN_PROGRESS -> COMPLETED */
  ivHandlingTime:
    | Duration
    | undefined;
  /** Per-robot average intervention times (time / num_robots) */
  avgIvTime: Duration | undefined;
  avgIvWaitingTime: Duration | undefined;
  avgIvHandlingTime:
    | Duration
    | undefined;
  /** Per-robot intervention percentages (avg_time / active_time) */
  avgIvTimePercent: number;
  avgIvWaitingTimePercent: number;
  avgIvHandlingTimePercent: number;
  /** Job progress metrics */
  progressPercent: number;
  totalAcres: number;
  completedAcres: number;
  acresPerActiveHour: number;
  estCompletionAt: string | undefined;
}

export interface GroundPrepJobConfiguration {
  updatedAt: string | undefined;
  pathPlan:
    | PathPlanConfiguration
    | undefined;
  /** @deprecated */
  tractorDefinition?:
    | TractorDefinition
    | undefined;
  /** @deprecated */
  implementDefinition?: ImplementDefinition | undefined;
  entryPoint?: Point | undefined;
  exitPoint?:
    | Point
    | undefined;
  /** uuid */
  rigId: string;
  /** uuid */
  rigSnapshotId: string;
  rigChanged?: boolean | undefined;
  headlandBufferM?: number | undefined;
}

export interface LaserWeedJobConfiguration {
  updatedAt: string | undefined;
  rowSpacingM: number;
  rowTraversalSpeedMS?: number | undefined;
  transitionSpeedMS?: number | undefined;
}

export interface TransportJobConfiguration {
  updatedAt:
    | string
    | undefined;
  /** id of path zone in farm */
  pathId: string;
  transportSpeedMS: number;
}

export interface InSeasonJobConfiguration {
  updatedAt:
    | string
    | undefined;
  /** id of planting path zone in farm */
  pathId: string;
  rowTraversalSpeedMS?: number | undefined;
  transitionSpeedMS?: number | undefined;
  toolSpeedMS?:
    | number
    | undefined;
  /** calculated from extracted rows */
  rowSpacingM?: number | undefined;
}

export interface JobConfiguration {
  jobId: number;
  groundPrep?: GroundPrepJobConfiguration | undefined;
  laserWeed?: LaserWeedJobConfiguration | undefined;
  transport?: TransportJobConfiguration | undefined;
  inSeason?: InSeasonJobConfiguration | undefined;
}

export interface GetNextJobConfigurationRequest {
  jobId: number;
  updatedAt: string | undefined;
}

export interface GetNextJobConfigurationResponse {
  configuration: JobConfiguration | undefined;
}

export interface CreateJobRequest {
  type: JobType;
  name: string;
  farmId: string;
  fieldId: string;
  customerId: string;
  priority: number;
  generateObjectives: boolean;
  dryRun: boolean;
  groundPrep?: GroundPrepJobConfiguration | undefined;
  laserWeed?: LaserWeedJobConfiguration | undefined;
  transport?: TransportJobConfiguration | undefined;
  inSeason?: InSeasonJobConfiguration | undefined;
}

export interface CreateJobsRequest {
  jobRequests: CreateJobRequest[];
}

export interface CloneJobRequest {
  name: string;
}

export interface CloneJobResponse {
  job: Job | undefined;
}

export interface JobList {
  jobs: Job[];
}

export interface ListJobsResponse {
  pageToken: string;
  jobs: Job[];
}

export interface JobState {
  state: State;
}

export interface RobotJobAssignment {
  jobId: number;
}

/**
 * Robot API - using JobRobot naming to avoid conflicts with robot
 * messages associated with other services, like portal and locator.
 */
export interface JobRobot {
  robotSerial: string;
  createdAt: string | undefined;
  updatedAt:
    | string
    | undefined;
  /** Last time the robot contacted the jobs service. */
  lastSeen:
    | string
    | undefined;
  /** Active objective and assigned job, 0 when the robot has neither. */
  objectiveId: number;
  jobId: number;
}

/** Robots that have contacted the jobs service */
export interface ListJobRobotsResponse {
  pageToken: string;
  robots: JobRobot[];
}

/** Work Orders APIs */
export interface WorkOrder {
  id: number;
  name: string;
  scheduledAt: string | undefined;
  durationMinutes: number;
  jobs: Job[];
  state: State;
}

export interface WorkOrderList {
  workOrders: WorkOrder[];
}

export interface ListWorkOrdersResponse {
  pageToken: string;
  workOrders: WorkOrder[];
}

/** Startup Checklist APIs */
export interface ChecklistDefinition {
  id: number;
  createdAt: string | undefined;
  updatedAt: string | undefined;
  content: ChecklistContent | undefined;
  items: ChecklistItemDefinition[];
}

export interface ChecklistContent {
  name: string;
  description: string;
}

export interface ChecklistDefinitionList {
  checklistDefinitions: ChecklistDefinition[];
}

export interface ListChecklistDefinitionsResponse {
  pageToken: string;
  checklistDefinitions: ChecklistDefinition[];
}

export interface ChecklistItemDefinition {
  id: number;
  createdAt: string | undefined;
  updatedAt: string | undefined;
  checklistDefinitionId: number;
  content: ChecklistItemContent | undefined;
}

export interface ChecklistItemContent {
  translationKey: string;
  label: string;
  automationCode: ChecklistAutomationCode;
  position: number;
}

export interface ChecklistItemDefinitionList {
  itemDefinitions: ChecklistItemDefinition[];
}

export interface Checklist {
  id: number;
  robotSerial: string;
  createdAt: string | undefined;
  updatedAt: string | undefined;
  content: ChecklistContent | undefined;
  completedAt:
    | string
    | undefined;
  /** Auth0 user ID */
  completedBy: string;
  items: ChecklistItem[];
  fieldId: string;
  validDuration?: Duration | undefined;
  expiresAt?:
    | string
    | undefined;
  /** not expired or otherwise invalidated */
  valid: boolean;
  /** Auth0 user ID */
  createdBy: string;
}

export interface CreateChecklistRequest {
  checklistDefinitionId: number;
  robotSerial: string;
  fieldId: string;
  validDuration?: Duration | undefined;
}

export interface ChecklistList {
  checklists: Checklist[];
}

export interface ListChecklistsResponse {
  pageToken: string;
  checklists: Checklist[];
}

export interface ChecklistItem {
  id: number;
  checklistId: number;
  createdAt: string | undefined;
  updatedAt: string | undefined;
  content: ChecklistItemContent | undefined;
  checkedAt:
    | string
    | undefined;
  /** Auth0 user ID */
  checkedBy: string;
  checked: boolean;
}

export interface CreateChecklistExemptionRequest {
  fieldId: string;
  validDuration?: Duration | undefined;
}

export interface ChecklistExemption {
  robotSerial: string;
  fieldId: string;
  validDuration: Duration | undefined;
  createdAt:
    | string
    | undefined;
  /** Auth0 user ID */
  createdBy: string;
  expiresAt:
    | string
    | undefined;
  /** not expired or otherwise invalidated */
  valid: boolean;
}

/** Intervention APIs */
export interface Intervention {
  id: number;
  taskId: number;
  qualification: string;
  description: string;
  state: State;
  robotSerial: string;
  jobId: number;
  cause: InterventionCause;
  priority: number;
  assignment: InterventionAssignment | undefined;
  createdAt: string | undefined;
  updatedAt: string | undefined;
  diagnosticMessage: string;
}

export interface InterventionList {
  intervention: Intervention[];
}

export interface InterventionAssignment {
  userId: string;
  assignedAt: string | undefined;
}

export interface ListInterventionsRequest {
  pageSize: number;
  pageToken: string;
  robotSerials: string;
  assigedUserIds: string;
  assigned: boolean;
  taskIds: string;
  jobIds: string;
  causes: string;
  states: string;
}

export interface ListInterventionsResponse {
  pageToken: string;
  interventions: Intervention[];
}

export interface CreateInterventionRequest {
  intervention: Intervention | undefined;
}

export interface CreateInterventionResponse {
  intervention: Intervention | undefined;
}

export interface GetActiveTaskRequest {
  currentLocation: Point | undefined;
}

export interface GetActiveTaskResponse {
  task: Task | undefined;
}

export interface GetTaskRequest {
  taskId: number;
}

export interface GetTaskResponse {
  task: Task | undefined;
}

/** GPS location of a specific point on a rig (front axle, implement front, etc.) */
export interface RigPointLocation {
  rigPoint: RigPoint;
  location: Point | undefined;
}

/** GPS travel path defined for a specific point on the rig */
export interface RigPointPath {
  rigPoint: RigPoint;
  path: LineString | undefined;
}

export interface UpdateTaskRequest {
  taskId: number;
  state?: State | undefined;
  startedAt?:
    | string
    | undefined;
  /**
   * use start_locations
   *
   * @deprecated
   */
  startLocation?: Point | undefined;
  startHeading?: number | undefined;
  endedAt?:
    | string
    | undefined;
  /**
   * use end_locations
   *
   * @deprecated
   */
  endLocation?: Point | undefined;
  endHeading?: number | undefined;
  statusInfo?: string | undefined;
  progressUpdatedAt?:
    | string
    | undefined;
  /**
   * use progress_locations
   *
   * @deprecated
   */
  progressLocation?: Point | undefined;
  progressHeading?: number | undefined;
  progressLocations: RigPointLocation[];
  startLocations: RigPointLocation[];
  endLocations: RigPointLocation[];
}

export interface UpdateTaskResponse {
  task: Task | undefined;
}

export interface TaskState {
  state: State;
}

export interface StartManualTaskRequest {
  /** tractor front axle */
  startLocation: Point | undefined;
  startHeading?: number | undefined;
}

export interface StopManualTaskRequest {
  /** tractor front axle */
  endLocation: Point | undefined;
  endHeading?: number | undefined;
}

export interface CreateEnterRowTaskRequest {
  /** tractor front axle */
  tractorLocation: Point | undefined;
  tractorHeading: number;
}

export interface CreateExitRowTaskRequest {
  /** tractor front axle */
  tractorLocation: Point | undefined;
  tractorHeading: number;
}

export interface CreateFollowPathTaskRequest {
  robotSerial: string;
  path: LineString | undefined;
  speedMS: number;
}

export interface CalibrateLaserWeedObjectiveRequest {
  /** shift left(-) or right(+) */
  shiftM?:
    | number
    | undefined;
  /** align with robot's current location */
  robotSerial?: string | undefined;
}

export interface CalibrateLaserWeedJobRequest {
  objectiveId: number;
  /** shift left(-) or right(+) */
  shiftM?:
    | number
    | undefined;
  /** align with robot's location history */
  robotSerial?:
    | string
    | undefined;
  /** write back to farm structure */
  updatePlantingHeading: boolean;
}

export interface ChecklistInvalidationRequest {
}

export interface ChecklistInvalidationResponse {
}

/**
 * A ground prep job planned outside the jobs service (POST /v1/jobs/planned).
 * Each sequence becomes one objective, in order; the jobs service matches it
 * to a field section and adds that section's center pivot verification tasks.
 */
export interface CreatePlannedJobRequest {
  job: CreateJobRequest | undefined;
  sequences: SequenceTask[];
  /** Source and version of the tool that produced this plan */
  pathPlannerSource?:
    | string
    | undefined;
  /** e.g., "1.23.4" */
  pathPlannerVersion?:
    | string
    | undefined;
  /**
   * Any metadata the planner wants to associate with the job,
   * stored but not parsed by the jobs service
   */
  pathPlannerMetadata: { [key: string]: any } | undefined;
  pathPlannerMetadataFormat: PathPlannerMetadataFormat;
}

/**
 * A new plan for a job created by CreatePlannedJob. Replaces the job's
 * objectives and tasks, planner source and version, and planner metadata.
 */
export interface UpdatePlannedJobRequest {
  sequences: SequenceTask[];
  pathPlannerSource?: string | undefined;
  pathPlannerVersion?: string | undefined;
  pathPlannerMetadata: { [key: string]: any } | undefined;
  pathPlannerMetadataFormat: PathPlannerMetadataFormat;
}

function createBaseObjective(): Objective {
  return {
    id: 0,
    name: "",
    description: "",
    createdAt: undefined,
    updatedAt: undefined,
    estCompletionAt: undefined,
    progressPercent: 0,
    priority: 0,
    type: 0,
    data: undefined,
    assignment: undefined,
    jobId: 0,
    ordinal: 0,
  };
}

export const Objective: MessageFns<Objective> = {
  encode(message: Objective, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== 0) {
      writer.uint32(8).uint64(message.id);
    }
    if (message.name !== "") {
      writer.uint32(18).string(message.name);
    }
    if (message.description !== "") {
      writer.uint32(26).string(message.description);
    }
    if (message.createdAt !== undefined) {
      Timestamp.encode(toTimestamp(message.createdAt), writer.uint32(82).fork()).join();
    }
    if (message.updatedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.updatedAt), writer.uint32(90).fork()).join();
    }
    if (message.estCompletionAt !== undefined) {
      Timestamp.encode(toTimestamp(message.estCompletionAt), writer.uint32(106).fork()).join();
    }
    if (message.progressPercent !== 0) {
      writer.uint32(32).int32(message.progressPercent);
    }
    if (message.priority !== 0) {
      writer.uint32(40).int32(message.priority);
    }
    if (message.type !== 0) {
      writer.uint32(48).int32(message.type);
    }
    if (message.data !== undefined) {
      Struct.encode(Struct.wrap(message.data), writer.uint32(58).fork()).join();
    }
    if (message.assignment !== undefined) {
      ObjectiveAssignment.encode(message.assignment, writer.uint32(66).fork()).join();
    }
    if (message.jobId !== 0) {
      writer.uint32(72).uint64(message.jobId);
    }
    if (message.ordinal !== 0) {
      writer.uint32(96).uint32(message.ordinal);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Objective {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseObjective();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.id = longToNumber(reader.uint64());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.description = reader.string();
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.createdAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.updatedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 13: {
          if (tag !== 106) {
            break;
          }

          message.estCompletionAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.progressPercent = reader.int32();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.priority = reader.int32();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.type = reader.int32() as any;
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.data = Struct.unwrap(Struct.decode(reader, reader.uint32()));
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.assignment = ObjectiveAssignment.decode(reader, reader.uint32());
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.jobId = longToNumber(reader.uint64());
          continue;
        }
        case 12: {
          if (tag !== 96) {
            break;
          }

          message.ordinal = reader.uint32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Objective {
    return {
      id: isSet(object.id) ? globalThis.Number(object.id) : 0,
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      description: isSet(object.description) ? globalThis.String(object.description) : "",
      createdAt: isSet(object.createdAt)
        ? globalThis.String(object.createdAt)
        : isSet(object.created_at)
        ? globalThis.String(object.created_at)
        : undefined,
      updatedAt: isSet(object.updatedAt)
        ? globalThis.String(object.updatedAt)
        : isSet(object.updated_at)
        ? globalThis.String(object.updated_at)
        : undefined,
      estCompletionAt: isSet(object.estCompletionAt)
        ? globalThis.String(object.estCompletionAt)
        : isSet(object.est_completion_at)
        ? globalThis.String(object.est_completion_at)
        : undefined,
      progressPercent: isSet(object.progressPercent)
        ? globalThis.Number(object.progressPercent)
        : isSet(object.progress_percent)
        ? globalThis.Number(object.progress_percent)
        : 0,
      priority: isSet(object.priority) ? globalThis.Number(object.priority) : 0,
      type: isSet(object.type) ? objective_ObjectiveTypeFromJSON(object.type) : 0,
      data: isObject(object.data) ? object.data : undefined,
      assignment: isSet(object.assignment) ? ObjectiveAssignment.fromJSON(object.assignment) : undefined,
      jobId: isSet(object.jobId)
        ? globalThis.Number(object.jobId)
        : isSet(object.job_id)
        ? globalThis.Number(object.job_id)
        : 0,
      ordinal: isSet(object.ordinal) ? globalThis.Number(object.ordinal) : 0,
    };
  },

  toJSON(message: Objective): unknown {
    const obj: any = {};
    if (message.id !== 0) {
      obj.id = Math.round(message.id);
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.description !== "") {
      obj.description = message.description;
    }
    if (message.createdAt !== undefined) {
      obj.createdAt = message.createdAt;
    }
    if (message.updatedAt !== undefined) {
      obj.updatedAt = message.updatedAt;
    }
    if (message.estCompletionAt !== undefined) {
      obj.estCompletionAt = message.estCompletionAt;
    }
    if (message.progressPercent !== 0) {
      obj.progressPercent = Math.round(message.progressPercent);
    }
    if (message.priority !== 0) {
      obj.priority = Math.round(message.priority);
    }
    if (message.type !== 0) {
      obj.type = objective_ObjectiveTypeToJSON(message.type);
    }
    if (message.data !== undefined) {
      obj.data = message.data;
    }
    if (message.assignment !== undefined) {
      obj.assignment = ObjectiveAssignment.toJSON(message.assignment);
    }
    if (message.jobId !== 0) {
      obj.jobId = Math.round(message.jobId);
    }
    if (message.ordinal !== 0) {
      obj.ordinal = Math.round(message.ordinal);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Objective>, I>>(base?: I): Objective {
    return Objective.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Objective>, I>>(object: I): Objective {
    const message = createBaseObjective();
    message.id = object.id ?? 0;
    message.name = object.name ?? "";
    message.description = object.description ?? "";
    message.createdAt = object.createdAt ?? undefined;
    message.updatedAt = object.updatedAt ?? undefined;
    message.estCompletionAt = object.estCompletionAt ?? undefined;
    message.progressPercent = object.progressPercent ?? 0;
    message.priority = object.priority ?? 0;
    message.type = object.type ?? 0;
    message.data = object.data ?? undefined;
    message.assignment = (object.assignment !== undefined && object.assignment !== null)
      ? ObjectiveAssignment.fromPartial(object.assignment)
      : undefined;
    message.jobId = object.jobId ?? 0;
    message.ordinal = object.ordinal ?? 0;
    return message;
  },
};

function createBaseLaserWeedRowObjectiveData(): LaserWeedRowObjectiveData {
  return { rowNum: 0, abLine: undefined, shiftedM: 0 };
}

export const LaserWeedRowObjectiveData: MessageFns<LaserWeedRowObjectiveData> = {
  encode(message: LaserWeedRowObjectiveData, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.rowNum !== 0) {
      writer.uint32(8).uint32(message.rowNum);
    }
    if (message.abLine !== undefined) {
      AbLine.encode(message.abLine, writer.uint32(18).fork()).join();
    }
    if (message.shiftedM !== 0) {
      writer.uint32(25).double(message.shiftedM);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): LaserWeedRowObjectiveData {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseLaserWeedRowObjectiveData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.rowNum = reader.uint32();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.abLine = AbLine.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 25) {
            break;
          }

          message.shiftedM = reader.double();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): LaserWeedRowObjectiveData {
    return {
      rowNum: isSet(object.rowNum)
        ? globalThis.Number(object.rowNum)
        : isSet(object.row_num)
        ? globalThis.Number(object.row_num)
        : 0,
      abLine: isSet(object.abLine)
        ? AbLine.fromJSON(object.abLine)
        : isSet(object.ab_line)
        ? AbLine.fromJSON(object.ab_line)
        : undefined,
      shiftedM: isSet(object.shiftedM)
        ? globalThis.Number(object.shiftedM)
        : isSet(object.shifted_m)
        ? globalThis.Number(object.shifted_m)
        : 0,
    };
  },

  toJSON(message: LaserWeedRowObjectiveData): unknown {
    const obj: any = {};
    if (message.rowNum !== 0) {
      obj.rowNum = Math.round(message.rowNum);
    }
    if (message.abLine !== undefined) {
      obj.abLine = AbLine.toJSON(message.abLine);
    }
    if (message.shiftedM !== 0) {
      obj.shiftedM = message.shiftedM;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<LaserWeedRowObjectiveData>, I>>(base?: I): LaserWeedRowObjectiveData {
    return LaserWeedRowObjectiveData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<LaserWeedRowObjectiveData>, I>>(object: I): LaserWeedRowObjectiveData {
    const message = createBaseLaserWeedRowObjectiveData();
    message.rowNum = object.rowNum ?? 0;
    message.abLine = (object.abLine !== undefined && object.abLine !== null)
      ? AbLine.fromPartial(object.abLine)
      : undefined;
    message.shiftedM = object.shiftedM ?? 0;
    return message;
  },
};

function createBaseInSeasonRowObjectiveData(): InSeasonRowObjectiveData {
  return { path: undefined, shiftedM: 0 };
}

export const InSeasonRowObjectiveData: MessageFns<InSeasonRowObjectiveData> = {
  encode(message: InSeasonRowObjectiveData, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.path !== undefined) {
      LineString.encode(message.path, writer.uint32(10).fork()).join();
    }
    if (message.shiftedM !== 0) {
      writer.uint32(17).double(message.shiftedM);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): InSeasonRowObjectiveData {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseInSeasonRowObjectiveData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.path = LineString.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 17) {
            break;
          }

          message.shiftedM = reader.double();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): InSeasonRowObjectiveData {
    return {
      path: isSet(object.path) ? LineString.fromJSON(object.path) : undefined,
      shiftedM: isSet(object.shiftedM)
        ? globalThis.Number(object.shiftedM)
        : isSet(object.shifted_m)
        ? globalThis.Number(object.shifted_m)
        : 0,
    };
  },

  toJSON(message: InSeasonRowObjectiveData): unknown {
    const obj: any = {};
    if (message.path !== undefined) {
      obj.path = LineString.toJSON(message.path);
    }
    if (message.shiftedM !== 0) {
      obj.shiftedM = message.shiftedM;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<InSeasonRowObjectiveData>, I>>(base?: I): InSeasonRowObjectiveData {
    return InSeasonRowObjectiveData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<InSeasonRowObjectiveData>, I>>(object: I): InSeasonRowObjectiveData {
    const message = createBaseInSeasonRowObjectiveData();
    message.path = (object.path !== undefined && object.path !== null)
      ? LineString.fromPartial(object.path)
      : undefined;
    message.shiftedM = object.shiftedM ?? 0;
    return message;
  },
};

function createBaseCenterPivotRange(): CenterPivotRange {
  return { pivotId: "", center: undefined, minHeading: 0, maxHeading: 0 };
}

export const CenterPivotRange: MessageFns<CenterPivotRange> = {
  encode(message: CenterPivotRange, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.pivotId !== "") {
      writer.uint32(10).string(message.pivotId);
    }
    if (message.center !== undefined) {
      Point.encode(message.center, writer.uint32(18).fork()).join();
    }
    if (message.minHeading !== 0) {
      writer.uint32(25).double(message.minHeading);
    }
    if (message.maxHeading !== 0) {
      writer.uint32(33).double(message.maxHeading);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CenterPivotRange {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCenterPivotRange();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.pivotId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.center = Point.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 25) {
            break;
          }

          message.minHeading = reader.double();
          continue;
        }
        case 4: {
          if (tag !== 33) {
            break;
          }

          message.maxHeading = reader.double();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CenterPivotRange {
    return {
      pivotId: isSet(object.pivotId)
        ? globalThis.String(object.pivotId)
        : isSet(object.pivot_id)
        ? globalThis.String(object.pivot_id)
        : "",
      center: isSet(object.center) ? Point.fromJSON(object.center) : undefined,
      minHeading: isSet(object.minHeading)
        ? globalThis.Number(object.minHeading)
        : isSet(object.min_heading)
        ? globalThis.Number(object.min_heading)
        : 0,
      maxHeading: isSet(object.maxHeading)
        ? globalThis.Number(object.maxHeading)
        : isSet(object.max_heading)
        ? globalThis.Number(object.max_heading)
        : 0,
    };
  },

  toJSON(message: CenterPivotRange): unknown {
    const obj: any = {};
    if (message.pivotId !== "") {
      obj.pivotId = message.pivotId;
    }
    if (message.center !== undefined) {
      obj.center = Point.toJSON(message.center);
    }
    if (message.minHeading !== 0) {
      obj.minHeading = message.minHeading;
    }
    if (message.maxHeading !== 0) {
      obj.maxHeading = message.maxHeading;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CenterPivotRange>, I>>(base?: I): CenterPivotRange {
    return CenterPivotRange.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CenterPivotRange>, I>>(object: I): CenterPivotRange {
    const message = createBaseCenterPivotRange();
    message.pivotId = object.pivotId ?? "";
    message.center = (object.center !== undefined && object.center !== null)
      ? Point.fromPartial(object.center)
      : undefined;
    message.minHeading = object.minHeading ?? 0;
    message.maxHeading = object.maxHeading ?? 0;
    return message;
  },
};

function createBaseGroundPrepSectionObjectiveData(): GroundPrepSectionObjectiveData {
  return { sectionNum: 0, boundary: undefined, pivotRanges: [], centroid: undefined };
}

export const GroundPrepSectionObjectiveData: MessageFns<GroundPrepSectionObjectiveData> = {
  encode(message: GroundPrepSectionObjectiveData, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.sectionNum !== 0) {
      writer.uint32(8).uint32(message.sectionNum);
    }
    if (message.boundary !== undefined) {
      PolygonRing.encode(message.boundary, writer.uint32(18).fork()).join();
    }
    for (const v of message.pivotRanges) {
      CenterPivotRange.encode(v!, writer.uint32(26).fork()).join();
    }
    if (message.centroid !== undefined) {
      Point.encode(message.centroid, writer.uint32(34).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GroundPrepSectionObjectiveData {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGroundPrepSectionObjectiveData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.sectionNum = reader.uint32();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.boundary = PolygonRing.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.pivotRanges.push(CenterPivotRange.decode(reader, reader.uint32()));
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.centroid = Point.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GroundPrepSectionObjectiveData {
    return {
      sectionNum: isSet(object.sectionNum)
        ? globalThis.Number(object.sectionNum)
        : isSet(object.section_num)
        ? globalThis.Number(object.section_num)
        : 0,
      boundary: isSet(object.boundary) ? PolygonRing.fromJSON(object.boundary) : undefined,
      pivotRanges: globalThis.Array.isArray(object?.pivotRanges)
        ? object.pivotRanges.map((e: any) => CenterPivotRange.fromJSON(e))
        : globalThis.Array.isArray(object?.pivot_ranges)
        ? object.pivot_ranges.map((e: any) => CenterPivotRange.fromJSON(e))
        : [],
      centroid: isSet(object.centroid) ? Point.fromJSON(object.centroid) : undefined,
    };
  },

  toJSON(message: GroundPrepSectionObjectiveData): unknown {
    const obj: any = {};
    if (message.sectionNum !== 0) {
      obj.sectionNum = Math.round(message.sectionNum);
    }
    if (message.boundary !== undefined) {
      obj.boundary = PolygonRing.toJSON(message.boundary);
    }
    if (message.pivotRanges?.length) {
      obj.pivotRanges = message.pivotRanges.map((e) => CenterPivotRange.toJSON(e));
    }
    if (message.centroid !== undefined) {
      obj.centroid = Point.toJSON(message.centroid);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GroundPrepSectionObjectiveData>, I>>(base?: I): GroundPrepSectionObjectiveData {
    return GroundPrepSectionObjectiveData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GroundPrepSectionObjectiveData>, I>>(
    object: I,
  ): GroundPrepSectionObjectiveData {
    const message = createBaseGroundPrepSectionObjectiveData();
    message.sectionNum = object.sectionNum ?? 0;
    message.boundary = (object.boundary !== undefined && object.boundary !== null)
      ? PolygonRing.fromPartial(object.boundary)
      : undefined;
    message.pivotRanges = object.pivotRanges?.map((e) => CenterPivotRange.fromPartial(e)) || [];
    message.centroid = (object.centroid !== undefined && object.centroid !== null)
      ? Point.fromPartial(object.centroid)
      : undefined;
    return message;
  },
};

function createBaseTransportObjectiveData(): TransportObjectiveData {
  return { path: undefined };
}

export const TransportObjectiveData: MessageFns<TransportObjectiveData> = {
  encode(message: TransportObjectiveData, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.path !== undefined) {
      LineString.encode(message.path, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TransportObjectiveData {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTransportObjectiveData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.path = LineString.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TransportObjectiveData {
    return { path: isSet(object.path) ? LineString.fromJSON(object.path) : undefined };
  },

  toJSON(message: TransportObjectiveData): unknown {
    const obj: any = {};
    if (message.path !== undefined) {
      obj.path = LineString.toJSON(message.path);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<TransportObjectiveData>, I>>(base?: I): TransportObjectiveData {
    return TransportObjectiveData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TransportObjectiveData>, I>>(object: I): TransportObjectiveData {
    const message = createBaseTransportObjectiveData();
    message.path = (object.path !== undefined && object.path !== null)
      ? LineString.fromPartial(object.path)
      : undefined;
    return message;
  },
};

function createBaseManeuverObjectiveData(): ManeuverObjectiveData {
  return { robotSerial: "" };
}

export const ManeuverObjectiveData: MessageFns<ManeuverObjectiveData> = {
  encode(message: ManeuverObjectiveData, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.robotSerial !== "") {
      writer.uint32(10).string(message.robotSerial);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ManeuverObjectiveData {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseManeuverObjectiveData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.robotSerial = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ManeuverObjectiveData {
    return {
      robotSerial: isSet(object.robotSerial)
        ? globalThis.String(object.robotSerial)
        : isSet(object.robot_serial)
        ? globalThis.String(object.robot_serial)
        : "",
    };
  },

  toJSON(message: ManeuverObjectiveData): unknown {
    const obj: any = {};
    if (message.robotSerial !== "") {
      obj.robotSerial = message.robotSerial;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ManeuverObjectiveData>, I>>(base?: I): ManeuverObjectiveData {
    return ManeuverObjectiveData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ManeuverObjectiveData>, I>>(object: I): ManeuverObjectiveData {
    const message = createBaseManeuverObjectiveData();
    message.robotSerial = object.robotSerial ?? "";
    return message;
  },
};

function createBaseLambdaPathPlannerRequest(): LambdaPathPlannerRequest {
  return { groundPrepReq: undefined, drawPathManeuverReq: undefined, eortaReq: undefined };
}

export const LambdaPathPlannerRequest: MessageFns<LambdaPathPlannerRequest> = {
  encode(message: LambdaPathPlannerRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.groundPrepReq !== undefined) {
      GroundPrepPathPlannerRequest.encode(message.groundPrepReq, writer.uint32(10).fork()).join();
    }
    if (message.drawPathManeuverReq !== undefined) {
      DrawPathManeuverPathPlannerRequest.encode(message.drawPathManeuverReq, writer.uint32(18).fork()).join();
    }
    if (message.eortaReq !== undefined) {
      EORTAPathPlannerRequest.encode(message.eortaReq, writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): LambdaPathPlannerRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseLambdaPathPlannerRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.groundPrepReq = GroundPrepPathPlannerRequest.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.drawPathManeuverReq = DrawPathManeuverPathPlannerRequest.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.eortaReq = EORTAPathPlannerRequest.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): LambdaPathPlannerRequest {
    return {
      groundPrepReq: isSet(object.groundPrepReq)
        ? GroundPrepPathPlannerRequest.fromJSON(object.groundPrepReq)
        : isSet(object.ground_prep_req)
        ? GroundPrepPathPlannerRequest.fromJSON(object.ground_prep_req)
        : undefined,
      drawPathManeuverReq: isSet(object.drawPathManeuverReq)
        ? DrawPathManeuverPathPlannerRequest.fromJSON(object.drawPathManeuverReq)
        : isSet(object.draw_path_maneuver_req)
        ? DrawPathManeuverPathPlannerRequest.fromJSON(object.draw_path_maneuver_req)
        : undefined,
      eortaReq: isSet(object.eortaReq)
        ? EORTAPathPlannerRequest.fromJSON(object.eortaReq)
        : isSet(object.eorta_req)
        ? EORTAPathPlannerRequest.fromJSON(object.eorta_req)
        : undefined,
    };
  },

  toJSON(message: LambdaPathPlannerRequest): unknown {
    const obj: any = {};
    if (message.groundPrepReq !== undefined) {
      obj.groundPrepReq = GroundPrepPathPlannerRequest.toJSON(message.groundPrepReq);
    }
    if (message.drawPathManeuverReq !== undefined) {
      obj.drawPathManeuverReq = DrawPathManeuverPathPlannerRequest.toJSON(message.drawPathManeuverReq);
    }
    if (message.eortaReq !== undefined) {
      obj.eortaReq = EORTAPathPlannerRequest.toJSON(message.eortaReq);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<LambdaPathPlannerRequest>, I>>(base?: I): LambdaPathPlannerRequest {
    return LambdaPathPlannerRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<LambdaPathPlannerRequest>, I>>(object: I): LambdaPathPlannerRequest {
    const message = createBaseLambdaPathPlannerRequest();
    message.groundPrepReq = (object.groundPrepReq !== undefined && object.groundPrepReq !== null)
      ? GroundPrepPathPlannerRequest.fromPartial(object.groundPrepReq)
      : undefined;
    message.drawPathManeuverReq = (object.drawPathManeuverReq !== undefined && object.drawPathManeuverReq !== null)
      ? DrawPathManeuverPathPlannerRequest.fromPartial(object.drawPathManeuverReq)
      : undefined;
    message.eortaReq = (object.eortaReq !== undefined && object.eortaReq !== null)
      ? EORTAPathPlannerRequest.fromPartial(object.eortaReq)
      : undefined;
    return message;
  },
};

function createBaseLambdaPathPlannerResponse(): LambdaPathPlannerResponse {
  return {
    groundPrepResp: undefined,
    drawPathManeuverResp: undefined,
    eortaResp: undefined,
    pathPlannerVersion: undefined,
  };
}

export const LambdaPathPlannerResponse: MessageFns<LambdaPathPlannerResponse> = {
  encode(message: LambdaPathPlannerResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.groundPrepResp !== undefined) {
      GroundPrepPathPlannerResponse.encode(message.groundPrepResp, writer.uint32(10).fork()).join();
    }
    if (message.drawPathManeuverResp !== undefined) {
      DrawPathManeuverPathPlannerResponse.encode(message.drawPathManeuverResp, writer.uint32(18).fork()).join();
    }
    if (message.eortaResp !== undefined) {
      EORTAPathPlannerResponse.encode(message.eortaResp, writer.uint32(26).fork()).join();
    }
    if (message.pathPlannerVersion !== undefined) {
      writer.uint32(34).string(message.pathPlannerVersion);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): LambdaPathPlannerResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseLambdaPathPlannerResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.groundPrepResp = GroundPrepPathPlannerResponse.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.drawPathManeuverResp = DrawPathManeuverPathPlannerResponse.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.eortaResp = EORTAPathPlannerResponse.decode(reader, reader.uint32());
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.pathPlannerVersion = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): LambdaPathPlannerResponse {
    return {
      groundPrepResp: isSet(object.groundPrepResp)
        ? GroundPrepPathPlannerResponse.fromJSON(object.groundPrepResp)
        : isSet(object.ground_prep_resp)
        ? GroundPrepPathPlannerResponse.fromJSON(object.ground_prep_resp)
        : undefined,
      drawPathManeuverResp: isSet(object.drawPathManeuverResp)
        ? DrawPathManeuverPathPlannerResponse.fromJSON(object.drawPathManeuverResp)
        : isSet(object.draw_path_maneuver_resp)
        ? DrawPathManeuverPathPlannerResponse.fromJSON(object.draw_path_maneuver_resp)
        : undefined,
      eortaResp: isSet(object.eortaResp)
        ? EORTAPathPlannerResponse.fromJSON(object.eortaResp)
        : isSet(object.eorta_resp)
        ? EORTAPathPlannerResponse.fromJSON(object.eorta_resp)
        : undefined,
      pathPlannerVersion: isSet(object.pathPlannerVersion)
        ? globalThis.String(object.pathPlannerVersion)
        : isSet(object.path_planner_version)
        ? globalThis.String(object.path_planner_version)
        : undefined,
    };
  },

  toJSON(message: LambdaPathPlannerResponse): unknown {
    const obj: any = {};
    if (message.groundPrepResp !== undefined) {
      obj.groundPrepResp = GroundPrepPathPlannerResponse.toJSON(message.groundPrepResp);
    }
    if (message.drawPathManeuverResp !== undefined) {
      obj.drawPathManeuverResp = DrawPathManeuverPathPlannerResponse.toJSON(message.drawPathManeuverResp);
    }
    if (message.eortaResp !== undefined) {
      obj.eortaResp = EORTAPathPlannerResponse.toJSON(message.eortaResp);
    }
    if (message.pathPlannerVersion !== undefined) {
      obj.pathPlannerVersion = message.pathPlannerVersion;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<LambdaPathPlannerResponse>, I>>(base?: I): LambdaPathPlannerResponse {
    return LambdaPathPlannerResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<LambdaPathPlannerResponse>, I>>(object: I): LambdaPathPlannerResponse {
    const message = createBaseLambdaPathPlannerResponse();
    message.groundPrepResp = (object.groundPrepResp !== undefined && object.groundPrepResp !== null)
      ? GroundPrepPathPlannerResponse.fromPartial(object.groundPrepResp)
      : undefined;
    message.drawPathManeuverResp = (object.drawPathManeuverResp !== undefined && object.drawPathManeuverResp !== null)
      ? DrawPathManeuverPathPlannerResponse.fromPartial(object.drawPathManeuverResp)
      : undefined;
    message.eortaResp = (object.eortaResp !== undefined && object.eortaResp !== null)
      ? EORTAPathPlannerResponse.fromPartial(object.eortaResp)
      : undefined;
    message.pathPlannerVersion = object.pathPlannerVersion ?? undefined;
    return message;
  },
};

function createBaseGroundPrepPathPlannerRequest(): GroundPrepPathPlannerRequest {
  return {
    config: undefined,
    boundary: undefined,
    exportVizData: false,
    obstacles: [],
    subSection: undefined,
    effectiveConfig: undefined,
  };
}

export const GroundPrepPathPlannerRequest: MessageFns<GroundPrepPathPlannerRequest> = {
  encode(message: GroundPrepPathPlannerRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.config !== undefined) {
      GroundPrepJobConfiguration.encode(message.config, writer.uint32(10).fork()).join();
    }
    if (message.boundary !== undefined) {
      PolygonRing.encode(message.boundary, writer.uint32(18).fork()).join();
    }
    if (message.exportVizData !== false) {
      writer.uint32(24).bool(message.exportVizData);
    }
    for (const v of message.obstacles) {
      GroundPrepObstacle.encode(v!, writer.uint32(34).fork()).join();
    }
    if (message.subSection !== undefined) {
      GroundPrepSubSection.encode(message.subSection, writer.uint32(42).fork()).join();
    }
    if (message.effectiveConfig !== undefined) {
      RigEffectiveConfig.encode(message.effectiveConfig, writer.uint32(50).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GroundPrepPathPlannerRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGroundPrepPathPlannerRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.config = GroundPrepJobConfiguration.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.boundary = PolygonRing.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.exportVizData = reader.bool();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.obstacles.push(GroundPrepObstacle.decode(reader, reader.uint32()));
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.subSection = GroundPrepSubSection.decode(reader, reader.uint32());
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.effectiveConfig = RigEffectiveConfig.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GroundPrepPathPlannerRequest {
    return {
      config: isSet(object.config) ? GroundPrepJobConfiguration.fromJSON(object.config) : undefined,
      boundary: isSet(object.boundary) ? PolygonRing.fromJSON(object.boundary) : undefined,
      exportVizData: isSet(object.exportVizData)
        ? globalThis.Boolean(object.exportVizData)
        : isSet(object.export_viz_data)
        ? globalThis.Boolean(object.export_viz_data)
        : false,
      obstacles: globalThis.Array.isArray(object?.obstacles)
        ? object.obstacles.map((e: any) => GroundPrepObstacle.fromJSON(e))
        : [],
      subSection: isSet(object.subSection)
        ? GroundPrepSubSection.fromJSON(object.subSection)
        : isSet(object.sub_section)
        ? GroundPrepSubSection.fromJSON(object.sub_section)
        : undefined,
      effectiveConfig: isSet(object.effectiveConfig)
        ? RigEffectiveConfig.fromJSON(object.effectiveConfig)
        : isSet(object.effective_config)
        ? RigEffectiveConfig.fromJSON(object.effective_config)
        : undefined,
    };
  },

  toJSON(message: GroundPrepPathPlannerRequest): unknown {
    const obj: any = {};
    if (message.config !== undefined) {
      obj.config = GroundPrepJobConfiguration.toJSON(message.config);
    }
    if (message.boundary !== undefined) {
      obj.boundary = PolygonRing.toJSON(message.boundary);
    }
    if (message.exportVizData !== false) {
      obj.exportVizData = message.exportVizData;
    }
    if (message.obstacles?.length) {
      obj.obstacles = message.obstacles.map((e) => GroundPrepObstacle.toJSON(e));
    }
    if (message.subSection !== undefined) {
      obj.subSection = GroundPrepSubSection.toJSON(message.subSection);
    }
    if (message.effectiveConfig !== undefined) {
      obj.effectiveConfig = RigEffectiveConfig.toJSON(message.effectiveConfig);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GroundPrepPathPlannerRequest>, I>>(base?: I): GroundPrepPathPlannerRequest {
    return GroundPrepPathPlannerRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GroundPrepPathPlannerRequest>, I>>(object: I): GroundPrepPathPlannerRequest {
    const message = createBaseGroundPrepPathPlannerRequest();
    message.config = (object.config !== undefined && object.config !== null)
      ? GroundPrepJobConfiguration.fromPartial(object.config)
      : undefined;
    message.boundary = (object.boundary !== undefined && object.boundary !== null)
      ? PolygonRing.fromPartial(object.boundary)
      : undefined;
    message.exportVizData = object.exportVizData ?? false;
    message.obstacles = object.obstacles?.map((e) => GroundPrepObstacle.fromPartial(e)) || [];
    message.subSection = (object.subSection !== undefined && object.subSection !== null)
      ? GroundPrepSubSection.fromPartial(object.subSection)
      : undefined;
    message.effectiveConfig = (object.effectiveConfig !== undefined && object.effectiveConfig !== null)
      ? RigEffectiveConfig.fromPartial(object.effectiveConfig)
      : undefined;
    return message;
  },
};

function createBaseGroundPrepPathPlannerResponse(): GroundPrepPathPlannerResponse {
  return { fieldBoundary: undefined, rowBoundary: undefined, tasks: [] };
}

export const GroundPrepPathPlannerResponse: MessageFns<GroundPrepPathPlannerResponse> = {
  encode(message: GroundPrepPathPlannerResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fieldBoundary !== undefined) {
      PolygonRing.encode(message.fieldBoundary, writer.uint32(18).fork()).join();
    }
    if (message.rowBoundary !== undefined) {
      PolygonRing.encode(message.rowBoundary, writer.uint32(26).fork()).join();
    }
    for (const v of message.tasks) {
      Task.encode(v!, writer.uint32(34).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GroundPrepPathPlannerResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGroundPrepPathPlannerResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.fieldBoundary = PolygonRing.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.rowBoundary = PolygonRing.decode(reader, reader.uint32());
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.tasks.push(Task.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GroundPrepPathPlannerResponse {
    return {
      fieldBoundary: isSet(object.fieldBoundary)
        ? PolygonRing.fromJSON(object.fieldBoundary)
        : isSet(object.field_boundary)
        ? PolygonRing.fromJSON(object.field_boundary)
        : undefined,
      rowBoundary: isSet(object.rowBoundary)
        ? PolygonRing.fromJSON(object.rowBoundary)
        : isSet(object.row_boundary)
        ? PolygonRing.fromJSON(object.row_boundary)
        : undefined,
      tasks: globalThis.Array.isArray(object?.tasks) ? object.tasks.map((e: any) => Task.fromJSON(e)) : [],
    };
  },

  toJSON(message: GroundPrepPathPlannerResponse): unknown {
    const obj: any = {};
    if (message.fieldBoundary !== undefined) {
      obj.fieldBoundary = PolygonRing.toJSON(message.fieldBoundary);
    }
    if (message.rowBoundary !== undefined) {
      obj.rowBoundary = PolygonRing.toJSON(message.rowBoundary);
    }
    if (message.tasks?.length) {
      obj.tasks = message.tasks.map((e) => Task.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GroundPrepPathPlannerResponse>, I>>(base?: I): GroundPrepPathPlannerResponse {
    return GroundPrepPathPlannerResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GroundPrepPathPlannerResponse>, I>>(
    object: I,
  ): GroundPrepPathPlannerResponse {
    const message = createBaseGroundPrepPathPlannerResponse();
    message.fieldBoundary = (object.fieldBoundary !== undefined && object.fieldBoundary !== null)
      ? PolygonRing.fromPartial(object.fieldBoundary)
      : undefined;
    message.rowBoundary = (object.rowBoundary !== undefined && object.rowBoundary !== null)
      ? PolygonRing.fromPartial(object.rowBoundary)
      : undefined;
    message.tasks = object.tasks?.map((e) => Task.fromPartial(e)) || [];
    return message;
  },
};

function createBaseDrawPathManeuverPathPlannerRequest(): DrawPathManeuverPathPlannerRequest {
  return { maneuverConfig: undefined, inputLine: undefined };
}

export const DrawPathManeuverPathPlannerRequest: MessageFns<DrawPathManeuverPathPlannerRequest> = {
  encode(message: DrawPathManeuverPathPlannerRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.maneuverConfig !== undefined) {
      ManeuverConfiguration.encode(message.maneuverConfig, writer.uint32(10).fork()).join();
    }
    if (message.inputLine !== undefined) {
      LineString.encode(message.inputLine, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DrawPathManeuverPathPlannerRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDrawPathManeuverPathPlannerRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.maneuverConfig = ManeuverConfiguration.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.inputLine = LineString.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DrawPathManeuverPathPlannerRequest {
    return {
      maneuverConfig: isSet(object.maneuverConfig)
        ? ManeuverConfiguration.fromJSON(object.maneuverConfig)
        : isSet(object.maneuver_config)
        ? ManeuverConfiguration.fromJSON(object.maneuver_config)
        : undefined,
      inputLine: isSet(object.inputLine)
        ? LineString.fromJSON(object.inputLine)
        : isSet(object.input_line)
        ? LineString.fromJSON(object.input_line)
        : undefined,
    };
  },

  toJSON(message: DrawPathManeuverPathPlannerRequest): unknown {
    const obj: any = {};
    if (message.maneuverConfig !== undefined) {
      obj.maneuverConfig = ManeuverConfiguration.toJSON(message.maneuverConfig);
    }
    if (message.inputLine !== undefined) {
      obj.inputLine = LineString.toJSON(message.inputLine);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DrawPathManeuverPathPlannerRequest>, I>>(
    base?: I,
  ): DrawPathManeuverPathPlannerRequest {
    return DrawPathManeuverPathPlannerRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DrawPathManeuverPathPlannerRequest>, I>>(
    object: I,
  ): DrawPathManeuverPathPlannerRequest {
    const message = createBaseDrawPathManeuverPathPlannerRequest();
    message.maneuverConfig = (object.maneuverConfig !== undefined && object.maneuverConfig !== null)
      ? ManeuverConfiguration.fromPartial(object.maneuverConfig)
      : undefined;
    message.inputLine = (object.inputLine !== undefined && object.inputLine !== null)
      ? LineString.fromPartial(object.inputLine)
      : undefined;
    return message;
  },
};

function createBaseDrawPathManeuverPathPlannerResponse(): DrawPathManeuverPathPlannerResponse {
  return { task: undefined };
}

export const DrawPathManeuverPathPlannerResponse: MessageFns<DrawPathManeuverPathPlannerResponse> = {
  encode(message: DrawPathManeuverPathPlannerResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.task !== undefined) {
      Task.encode(message.task, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DrawPathManeuverPathPlannerResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDrawPathManeuverPathPlannerResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.task = Task.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DrawPathManeuverPathPlannerResponse {
    return { task: isSet(object.task) ? Task.fromJSON(object.task) : undefined };
  },

  toJSON(message: DrawPathManeuverPathPlannerResponse): unknown {
    const obj: any = {};
    if (message.task !== undefined) {
      obj.task = Task.toJSON(message.task);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DrawPathManeuverPathPlannerResponse>, I>>(
    base?: I,
  ): DrawPathManeuverPathPlannerResponse {
    return DrawPathManeuverPathPlannerResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DrawPathManeuverPathPlannerResponse>, I>>(
    object: I,
  ): DrawPathManeuverPathPlannerResponse {
    const message = createBaseDrawPathManeuverPathPlannerResponse();
    message.task = (object.task !== undefined && object.task !== null) ? Task.fromPartial(object.task) : undefined;
    return message;
  },
};

function createBaseEORTAPathPlannerRequest(): EORTAPathPlannerRequest {
  return {
    innerBoundary: undefined,
    outerBoundary: undefined,
    exportVizData: false,
    obstacles: [],
    effectiveConfig: undefined,
    startingPose: undefined,
    endingPose: undefined,
  };
}

export const EORTAPathPlannerRequest: MessageFns<EORTAPathPlannerRequest> = {
  encode(message: EORTAPathPlannerRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.innerBoundary !== undefined) {
      PolygonRing.encode(message.innerBoundary, writer.uint32(10).fork()).join();
    }
    if (message.outerBoundary !== undefined) {
      PolygonRing.encode(message.outerBoundary, writer.uint32(18).fork()).join();
    }
    if (message.exportVizData !== false) {
      writer.uint32(24).bool(message.exportVizData);
    }
    for (const v of message.obstacles) {
      GroundPrepObstacle.encode(v!, writer.uint32(34).fork()).join();
    }
    if (message.effectiveConfig !== undefined) {
      RigEffectiveConfig.encode(message.effectiveConfig, writer.uint32(42).fork()).join();
    }
    if (message.startingPose !== undefined) {
      RigPose.encode(message.startingPose, writer.uint32(50).fork()).join();
    }
    if (message.endingPose !== undefined) {
      RigPose.encode(message.endingPose, writer.uint32(58).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): EORTAPathPlannerRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseEORTAPathPlannerRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.innerBoundary = PolygonRing.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.outerBoundary = PolygonRing.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.exportVizData = reader.bool();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.obstacles.push(GroundPrepObstacle.decode(reader, reader.uint32()));
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.effectiveConfig = RigEffectiveConfig.decode(reader, reader.uint32());
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.startingPose = RigPose.decode(reader, reader.uint32());
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.endingPose = RigPose.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): EORTAPathPlannerRequest {
    return {
      innerBoundary: isSet(object.innerBoundary)
        ? PolygonRing.fromJSON(object.innerBoundary)
        : isSet(object.inner_boundary)
        ? PolygonRing.fromJSON(object.inner_boundary)
        : undefined,
      outerBoundary: isSet(object.outerBoundary)
        ? PolygonRing.fromJSON(object.outerBoundary)
        : isSet(object.outer_boundary)
        ? PolygonRing.fromJSON(object.outer_boundary)
        : undefined,
      exportVizData: isSet(object.exportVizData)
        ? globalThis.Boolean(object.exportVizData)
        : isSet(object.export_viz_data)
        ? globalThis.Boolean(object.export_viz_data)
        : false,
      obstacles: globalThis.Array.isArray(object?.obstacles)
        ? object.obstacles.map((e: any) => GroundPrepObstacle.fromJSON(e))
        : [],
      effectiveConfig: isSet(object.effectiveConfig)
        ? RigEffectiveConfig.fromJSON(object.effectiveConfig)
        : isSet(object.effective_config)
        ? RigEffectiveConfig.fromJSON(object.effective_config)
        : undefined,
      startingPose: isSet(object.startingPose)
        ? RigPose.fromJSON(object.startingPose)
        : isSet(object.starting_pose)
        ? RigPose.fromJSON(object.starting_pose)
        : undefined,
      endingPose: isSet(object.endingPose)
        ? RigPose.fromJSON(object.endingPose)
        : isSet(object.ending_pose)
        ? RigPose.fromJSON(object.ending_pose)
        : undefined,
    };
  },

  toJSON(message: EORTAPathPlannerRequest): unknown {
    const obj: any = {};
    if (message.innerBoundary !== undefined) {
      obj.innerBoundary = PolygonRing.toJSON(message.innerBoundary);
    }
    if (message.outerBoundary !== undefined) {
      obj.outerBoundary = PolygonRing.toJSON(message.outerBoundary);
    }
    if (message.exportVizData !== false) {
      obj.exportVizData = message.exportVizData;
    }
    if (message.obstacles?.length) {
      obj.obstacles = message.obstacles.map((e) => GroundPrepObstacle.toJSON(e));
    }
    if (message.effectiveConfig !== undefined) {
      obj.effectiveConfig = RigEffectiveConfig.toJSON(message.effectiveConfig);
    }
    if (message.startingPose !== undefined) {
      obj.startingPose = RigPose.toJSON(message.startingPose);
    }
    if (message.endingPose !== undefined) {
      obj.endingPose = RigPose.toJSON(message.endingPose);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<EORTAPathPlannerRequest>, I>>(base?: I): EORTAPathPlannerRequest {
    return EORTAPathPlannerRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<EORTAPathPlannerRequest>, I>>(object: I): EORTAPathPlannerRequest {
    const message = createBaseEORTAPathPlannerRequest();
    message.innerBoundary = (object.innerBoundary !== undefined && object.innerBoundary !== null)
      ? PolygonRing.fromPartial(object.innerBoundary)
      : undefined;
    message.outerBoundary = (object.outerBoundary !== undefined && object.outerBoundary !== null)
      ? PolygonRing.fromPartial(object.outerBoundary)
      : undefined;
    message.exportVizData = object.exportVizData ?? false;
    message.obstacles = object.obstacles?.map((e) => GroundPrepObstacle.fromPartial(e)) || [];
    message.effectiveConfig = (object.effectiveConfig !== undefined && object.effectiveConfig !== null)
      ? RigEffectiveConfig.fromPartial(object.effectiveConfig)
      : undefined;
    message.startingPose = (object.startingPose !== undefined && object.startingPose !== null)
      ? RigPose.fromPartial(object.startingPose)
      : undefined;
    message.endingPose = (object.endingPose !== undefined && object.endingPose !== null)
      ? RigPose.fromPartial(object.endingPose)
      : undefined;
    return message;
  },
};

function createBaseEORTAPathPlannerResponse(): EORTAPathPlannerResponse {
  return { task: undefined };
}

export const EORTAPathPlannerResponse: MessageFns<EORTAPathPlannerResponse> = {
  encode(message: EORTAPathPlannerResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.task !== undefined) {
      Task.encode(message.task, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): EORTAPathPlannerResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseEORTAPathPlannerResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.task = Task.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): EORTAPathPlannerResponse {
    return { task: isSet(object.task) ? Task.fromJSON(object.task) : undefined };
  },

  toJSON(message: EORTAPathPlannerResponse): unknown {
    const obj: any = {};
    if (message.task !== undefined) {
      obj.task = Task.toJSON(message.task);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<EORTAPathPlannerResponse>, I>>(base?: I): EORTAPathPlannerResponse {
    return EORTAPathPlannerResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<EORTAPathPlannerResponse>, I>>(object: I): EORTAPathPlannerResponse {
    const message = createBaseEORTAPathPlannerResponse();
    message.task = (object.task !== undefined && object.task !== null) ? Task.fromPartial(object.task) : undefined;
    return message;
  },
};

function createBaseGroundPrepObstacle(): GroundPrepObstacle {
  return { boundary: undefined, bufferMeters: 0, data: undefined };
}

export const GroundPrepObstacle: MessageFns<GroundPrepObstacle> = {
  encode(message: GroundPrepObstacle, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.boundary !== undefined) {
      PolygonRing.encode(message.boundary, writer.uint32(10).fork()).join();
    }
    if (message.bufferMeters !== 0) {
      writer.uint32(17).double(message.bufferMeters);
    }
    if (message.data !== undefined) {
      ObstacleData.encode(message.data, writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GroundPrepObstacle {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGroundPrepObstacle();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.boundary = PolygonRing.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 17) {
            break;
          }

          message.bufferMeters = reader.double();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.data = ObstacleData.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GroundPrepObstacle {
    return {
      boundary: isSet(object.boundary) ? PolygonRing.fromJSON(object.boundary) : undefined,
      bufferMeters: isSet(object.bufferMeters)
        ? globalThis.Number(object.bufferMeters)
        : isSet(object.buffer_meters)
        ? globalThis.Number(object.buffer_meters)
        : 0,
      data: isSet(object.data) ? ObstacleData.fromJSON(object.data) : undefined,
    };
  },

  toJSON(message: GroundPrepObstacle): unknown {
    const obj: any = {};
    if (message.boundary !== undefined) {
      obj.boundary = PolygonRing.toJSON(message.boundary);
    }
    if (message.bufferMeters !== 0) {
      obj.bufferMeters = message.bufferMeters;
    }
    if (message.data !== undefined) {
      obj.data = ObstacleData.toJSON(message.data);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GroundPrepObstacle>, I>>(base?: I): GroundPrepObstacle {
    return GroundPrepObstacle.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GroundPrepObstacle>, I>>(object: I): GroundPrepObstacle {
    const message = createBaseGroundPrepObstacle();
    message.boundary = (object.boundary !== undefined && object.boundary !== null)
      ? PolygonRing.fromPartial(object.boundary)
      : undefined;
    message.bufferMeters = object.bufferMeters ?? 0;
    message.data = (object.data !== undefined && object.data !== null)
      ? ObstacleData.fromPartial(object.data)
      : undefined;
    return message;
  },
};

function createBaseGroundPrepSubSection(): GroundPrepSubSection {
  return { pivots: [], headingDeg: 0, reference: undefined };
}

export const GroundPrepSubSection: MessageFns<GroundPrepSubSection> = {
  encode(message: GroundPrepSubSection, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.pivots) {
      Point.encode(v!, writer.uint32(10).fork()).join();
    }
    if (message.headingDeg !== 0) {
      writer.uint32(17).double(message.headingDeg);
    }
    if (message.reference !== undefined) {
      Point.encode(message.reference, writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GroundPrepSubSection {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGroundPrepSubSection();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.pivots.push(Point.decode(reader, reader.uint32()));
          continue;
        }
        case 2: {
          if (tag !== 17) {
            break;
          }

          message.headingDeg = reader.double();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.reference = Point.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GroundPrepSubSection {
    return {
      pivots: globalThis.Array.isArray(object?.pivots) ? object.pivots.map((e: any) => Point.fromJSON(e)) : [],
      headingDeg: isSet(object.headingDeg)
        ? globalThis.Number(object.headingDeg)
        : isSet(object.heading_deg)
        ? globalThis.Number(object.heading_deg)
        : 0,
      reference: isSet(object.reference) ? Point.fromJSON(object.reference) : undefined,
    };
  },

  toJSON(message: GroundPrepSubSection): unknown {
    const obj: any = {};
    if (message.pivots?.length) {
      obj.pivots = message.pivots.map((e) => Point.toJSON(e));
    }
    if (message.headingDeg !== 0) {
      obj.headingDeg = message.headingDeg;
    }
    if (message.reference !== undefined) {
      obj.reference = Point.toJSON(message.reference);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GroundPrepSubSection>, I>>(base?: I): GroundPrepSubSection {
    return GroundPrepSubSection.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GroundPrepSubSection>, I>>(object: I): GroundPrepSubSection {
    const message = createBaseGroundPrepSubSection();
    message.pivots = object.pivots?.map((e) => Point.fromPartial(e)) || [];
    message.headingDeg = object.headingDeg ?? 0;
    message.reference = (object.reference !== undefined && object.reference !== null)
      ? Point.fromPartial(object.reference)
      : undefined;
    return message;
  },
};

function createBaseObjectiveList(): ObjectiveList {
  return { objectives: [] };
}

export const ObjectiveList: MessageFns<ObjectiveList> = {
  encode(message: ObjectiveList, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.objectives) {
      Objective.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ObjectiveList {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseObjectiveList();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.objectives.push(Objective.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ObjectiveList {
    return {
      objectives: globalThis.Array.isArray(object?.objectives)
        ? object.objectives.map((e: any) => Objective.fromJSON(e))
        : [],
    };
  },

  toJSON(message: ObjectiveList): unknown {
    const obj: any = {};
    if (message.objectives?.length) {
      obj.objectives = message.objectives.map((e) => Objective.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ObjectiveList>, I>>(base?: I): ObjectiveList {
    return ObjectiveList.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ObjectiveList>, I>>(object: I): ObjectiveList {
    const message = createBaseObjectiveList();
    message.objectives = object.objectives?.map((e) => Objective.fromPartial(e)) || [];
    return message;
  },
};

function createBaseListObjectivesResponse(): ListObjectivesResponse {
  return { pageToken: "", objectives: [] };
}

export const ListObjectivesResponse: MessageFns<ListObjectivesResponse> = {
  encode(message: ListObjectivesResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.pageToken !== "") {
      writer.uint32(10).string(message.pageToken);
    }
    for (const v of message.objectives) {
      Objective.encode(v!, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ListObjectivesResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseListObjectivesResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.pageToken = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.objectives.push(Objective.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ListObjectivesResponse {
    return {
      pageToken: isSet(object.pageToken)
        ? globalThis.String(object.pageToken)
        : isSet(object.page_token)
        ? globalThis.String(object.page_token)
        : "",
      objectives: globalThis.Array.isArray(object?.objectives)
        ? object.objectives.map((e: any) => Objective.fromJSON(e))
        : [],
    };
  },

  toJSON(message: ListObjectivesResponse): unknown {
    const obj: any = {};
    if (message.pageToken !== "") {
      obj.pageToken = message.pageToken;
    }
    if (message.objectives?.length) {
      obj.objectives = message.objectives.map((e) => Objective.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ListObjectivesResponse>, I>>(base?: I): ListObjectivesResponse {
    return ListObjectivesResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ListObjectivesResponse>, I>>(object: I): ListObjectivesResponse {
    const message = createBaseListObjectivesResponse();
    message.pageToken = object.pageToken ?? "";
    message.objectives = object.objectives?.map((e) => Objective.fromPartial(e)) || [];
    return message;
  },
};

function createBasePivotRiskObjectivesResponse(): PivotRiskObjectivesResponse {
  return {
    decreasingRiskObjectives: [],
    increasingRiskObjectives: [],
    previousPivotPositions: [],
    currentPivotPositions: [],
    futurePivotPositions: [],
  };
}

export const PivotRiskObjectivesResponse: MessageFns<PivotRiskObjectivesResponse> = {
  encode(message: PivotRiskObjectivesResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.decreasingRiskObjectives) {
      Objective.encode(v!, writer.uint32(10).fork()).join();
    }
    for (const v of message.increasingRiskObjectives) {
      Objective.encode(v!, writer.uint32(18).fork()).join();
    }
    for (const v of message.previousPivotPositions) {
      LineString.encode(v!, writer.uint32(26).fork()).join();
    }
    for (const v of message.currentPivotPositions) {
      LineString.encode(v!, writer.uint32(34).fork()).join();
    }
    for (const v of message.futurePivotPositions) {
      LineString.encode(v!, writer.uint32(42).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PivotRiskObjectivesResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePivotRiskObjectivesResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.decreasingRiskObjectives.push(Objective.decode(reader, reader.uint32()));
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.increasingRiskObjectives.push(Objective.decode(reader, reader.uint32()));
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.previousPivotPositions.push(LineString.decode(reader, reader.uint32()));
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.currentPivotPositions.push(LineString.decode(reader, reader.uint32()));
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.futurePivotPositions.push(LineString.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PivotRiskObjectivesResponse {
    return {
      decreasingRiskObjectives: globalThis.Array.isArray(object?.decreasingRiskObjectives)
        ? object.decreasingRiskObjectives.map((e: any) => Objective.fromJSON(e))
        : [],
      increasingRiskObjectives: globalThis.Array.isArray(object?.increasingRiskObjectives)
        ? object.increasingRiskObjectives.map((e: any) => Objective.fromJSON(e))
        : [],
      previousPivotPositions: globalThis.Array.isArray(object?.previousPivotPositions)
        ? object.previousPivotPositions.map((e: any) => LineString.fromJSON(e))
        : [],
      currentPivotPositions: globalThis.Array.isArray(object?.currentPivotPositions)
        ? object.currentPivotPositions.map((e: any) => LineString.fromJSON(e))
        : [],
      futurePivotPositions: globalThis.Array.isArray(object?.futurePivotPositions)
        ? object.futurePivotPositions.map((e: any) => LineString.fromJSON(e))
        : [],
    };
  },

  toJSON(message: PivotRiskObjectivesResponse): unknown {
    const obj: any = {};
    if (message.decreasingRiskObjectives?.length) {
      obj.decreasingRiskObjectives = message.decreasingRiskObjectives.map((e) => Objective.toJSON(e));
    }
    if (message.increasingRiskObjectives?.length) {
      obj.increasingRiskObjectives = message.increasingRiskObjectives.map((e) => Objective.toJSON(e));
    }
    if (message.previousPivotPositions?.length) {
      obj.previousPivotPositions = message.previousPivotPositions.map((e) => LineString.toJSON(e));
    }
    if (message.currentPivotPositions?.length) {
      obj.currentPivotPositions = message.currentPivotPositions.map((e) => LineString.toJSON(e));
    }
    if (message.futurePivotPositions?.length) {
      obj.futurePivotPositions = message.futurePivotPositions.map((e) => LineString.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PivotRiskObjectivesResponse>, I>>(base?: I): PivotRiskObjectivesResponse {
    return PivotRiskObjectivesResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PivotRiskObjectivesResponse>, I>>(object: I): PivotRiskObjectivesResponse {
    const message = createBasePivotRiskObjectivesResponse();
    message.decreasingRiskObjectives = object.decreasingRiskObjectives?.map((e) => Objective.fromPartial(e)) || [];
    message.increasingRiskObjectives = object.increasingRiskObjectives?.map((e) => Objective.fromPartial(e)) || [];
    message.previousPivotPositions = object.previousPivotPositions?.map((e) => LineString.fromPartial(e)) || [];
    message.currentPivotPositions = object.currentPivotPositions?.map((e) => LineString.fromPartial(e)) || [];
    message.futurePivotPositions = object.futurePivotPositions?.map((e) => LineString.fromPartial(e)) || [];
    return message;
  },
};

function createBaseGetNextActiveObjectiveRequest(): GetNextActiveObjectiveRequest {
  return { objectiveId: 0, expiresAt: undefined, jobId: undefined, updatedAt: undefined };
}

export const GetNextActiveObjectiveRequest: MessageFns<GetNextActiveObjectiveRequest> = {
  encode(message: GetNextActiveObjectiveRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.objectiveId !== 0) {
      writer.uint32(8).uint64(message.objectiveId);
    }
    if (message.expiresAt !== undefined) {
      Timestamp.encode(toTimestamp(message.expiresAt), writer.uint32(18).fork()).join();
    }
    if (message.jobId !== undefined) {
      writer.uint32(24).uint64(message.jobId);
    }
    if (message.updatedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.updatedAt), writer.uint32(34).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetNextActiveObjectiveRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetNextActiveObjectiveRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.objectiveId = longToNumber(reader.uint64());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.expiresAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.jobId = longToNumber(reader.uint64());
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.updatedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetNextActiveObjectiveRequest {
    return {
      objectiveId: isSet(object.objectiveId)
        ? globalThis.Number(object.objectiveId)
        : isSet(object.objective_id)
        ? globalThis.Number(object.objective_id)
        : 0,
      expiresAt: isSet(object.expiresAt)
        ? globalThis.String(object.expiresAt)
        : isSet(object.expires_at)
        ? globalThis.String(object.expires_at)
        : undefined,
      jobId: isSet(object.jobId)
        ? globalThis.Number(object.jobId)
        : isSet(object.job_id)
        ? globalThis.Number(object.job_id)
        : undefined,
      updatedAt: isSet(object.updatedAt)
        ? globalThis.String(object.updatedAt)
        : isSet(object.updated_at)
        ? globalThis.String(object.updated_at)
        : undefined,
    };
  },

  toJSON(message: GetNextActiveObjectiveRequest): unknown {
    const obj: any = {};
    if (message.objectiveId !== 0) {
      obj.objectiveId = Math.round(message.objectiveId);
    }
    if (message.expiresAt !== undefined) {
      obj.expiresAt = message.expiresAt;
    }
    if (message.jobId !== undefined) {
      obj.jobId = Math.round(message.jobId);
    }
    if (message.updatedAt !== undefined) {
      obj.updatedAt = message.updatedAt;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetNextActiveObjectiveRequest>, I>>(base?: I): GetNextActiveObjectiveRequest {
    return GetNextActiveObjectiveRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetNextActiveObjectiveRequest>, I>>(
    object: I,
  ): GetNextActiveObjectiveRequest {
    const message = createBaseGetNextActiveObjectiveRequest();
    message.objectiveId = object.objectiveId ?? 0;
    message.expiresAt = object.expiresAt ?? undefined;
    message.jobId = object.jobId ?? undefined;
    message.updatedAt = object.updatedAt ?? undefined;
    return message;
  },
};

function createBaseGetNextActiveObjectiveResponse(): GetNextActiveObjectiveResponse {
  return { objective: undefined, expiresAt: undefined, job: undefined, updatedAt: undefined };
}

export const GetNextActiveObjectiveResponse: MessageFns<GetNextActiveObjectiveResponse> = {
  encode(message: GetNextActiveObjectiveResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.objective !== undefined) {
      Objective.encode(message.objective, writer.uint32(18).fork()).join();
    }
    if (message.expiresAt !== undefined) {
      Timestamp.encode(toTimestamp(message.expiresAt), writer.uint32(26).fork()).join();
    }
    if (message.job !== undefined) {
      Job.encode(message.job, writer.uint32(34).fork()).join();
    }
    if (message.updatedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.updatedAt), writer.uint32(42).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetNextActiveObjectiveResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetNextActiveObjectiveResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.objective = Objective.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.expiresAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.job = Job.decode(reader, reader.uint32());
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.updatedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetNextActiveObjectiveResponse {
    return {
      objective: isSet(object.objective) ? Objective.fromJSON(object.objective) : undefined,
      expiresAt: isSet(object.expiresAt)
        ? globalThis.String(object.expiresAt)
        : isSet(object.expires_at)
        ? globalThis.String(object.expires_at)
        : undefined,
      job: isSet(object.job) ? Job.fromJSON(object.job) : undefined,
      updatedAt: isSet(object.updatedAt)
        ? globalThis.String(object.updatedAt)
        : isSet(object.updated_at)
        ? globalThis.String(object.updated_at)
        : undefined,
    };
  },

  toJSON(message: GetNextActiveObjectiveResponse): unknown {
    const obj: any = {};
    if (message.objective !== undefined) {
      obj.objective = Objective.toJSON(message.objective);
    }
    if (message.expiresAt !== undefined) {
      obj.expiresAt = message.expiresAt;
    }
    if (message.job !== undefined) {
      obj.job = Job.toJSON(message.job);
    }
    if (message.updatedAt !== undefined) {
      obj.updatedAt = message.updatedAt;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetNextActiveObjectiveResponse>, I>>(base?: I): GetNextActiveObjectiveResponse {
    return GetNextActiveObjectiveResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetNextActiveObjectiveResponse>, I>>(
    object: I,
  ): GetNextActiveObjectiveResponse {
    const message = createBaseGetNextActiveObjectiveResponse();
    message.objective = (object.objective !== undefined && object.objective !== null)
      ? Objective.fromPartial(object.objective)
      : undefined;
    message.expiresAt = object.expiresAt ?? undefined;
    message.job = (object.job !== undefined && object.job !== null) ? Job.fromPartial(object.job) : undefined;
    message.updatedAt = object.updatedAt ?? undefined;
    return message;
  },
};

function createBaseAutoCompleteObjectivesRequest(): AutoCompleteObjectivesRequest {
  return { robotSerials: [], lookbackWindow: undefined };
}

export const AutoCompleteObjectivesRequest: MessageFns<AutoCompleteObjectivesRequest> = {
  encode(message: AutoCompleteObjectivesRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.robotSerials) {
      writer.uint32(10).string(v!);
    }
    if (message.lookbackWindow !== undefined) {
      Duration.encode(message.lookbackWindow, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AutoCompleteObjectivesRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAutoCompleteObjectivesRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.robotSerials.push(reader.string());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.lookbackWindow = Duration.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AutoCompleteObjectivesRequest {
    return {
      robotSerials: globalThis.Array.isArray(object?.robotSerials)
        ? object.robotSerials.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.robot_serials)
        ? object.robot_serials.map((e: any) => globalThis.String(e))
        : [],
      lookbackWindow: isSet(object.lookbackWindow)
        ? Duration.fromJSON(object.lookbackWindow)
        : isSet(object.lookback_window)
        ? Duration.fromJSON(object.lookback_window)
        : undefined,
    };
  },

  toJSON(message: AutoCompleteObjectivesRequest): unknown {
    const obj: any = {};
    if (message.robotSerials?.length) {
      obj.robotSerials = message.robotSerials;
    }
    if (message.lookbackWindow !== undefined) {
      obj.lookbackWindow = Duration.toJSON(message.lookbackWindow);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AutoCompleteObjectivesRequest>, I>>(base?: I): AutoCompleteObjectivesRequest {
    return AutoCompleteObjectivesRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AutoCompleteObjectivesRequest>, I>>(
    object: I,
  ): AutoCompleteObjectivesRequest {
    const message = createBaseAutoCompleteObjectivesRequest();
    message.robotSerials = object.robotSerials?.map((e) => e) || [];
    message.lookbackWindow = (object.lookbackWindow !== undefined && object.lookbackWindow !== null)
      ? Duration.fromPartial(object.lookbackWindow)
      : undefined;
    return message;
  },
};

function createBaseObjectiveAssignment(): ObjectiveAssignment {
  return { id: 0, objectiveId: 0, robotSerial: "", createdAt: undefined, updatedAt: undefined, priority: undefined };
}

export const ObjectiveAssignment: MessageFns<ObjectiveAssignment> = {
  encode(message: ObjectiveAssignment, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== 0) {
      writer.uint32(8).uint64(message.id);
    }
    if (message.objectiveId !== 0) {
      writer.uint32(16).uint64(message.objectiveId);
    }
    if (message.robotSerial !== "") {
      writer.uint32(26).string(message.robotSerial);
    }
    if (message.createdAt !== undefined) {
      Timestamp.encode(toTimestamp(message.createdAt), writer.uint32(34).fork()).join();
    }
    if (message.updatedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.updatedAt), writer.uint32(42).fork()).join();
    }
    if (message.priority !== undefined) {
      writer.uint32(48).int32(message.priority);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ObjectiveAssignment {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseObjectiveAssignment();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.id = longToNumber(reader.uint64());
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.objectiveId = longToNumber(reader.uint64());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.robotSerial = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.createdAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.updatedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.priority = reader.int32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ObjectiveAssignment {
    return {
      id: isSet(object.id) ? globalThis.Number(object.id) : 0,
      objectiveId: isSet(object.objectiveId)
        ? globalThis.Number(object.objectiveId)
        : isSet(object.objective_id)
        ? globalThis.Number(object.objective_id)
        : 0,
      robotSerial: isSet(object.robotSerial)
        ? globalThis.String(object.robotSerial)
        : isSet(object.robot_serial)
        ? globalThis.String(object.robot_serial)
        : "",
      createdAt: isSet(object.createdAt)
        ? globalThis.String(object.createdAt)
        : isSet(object.created_at)
        ? globalThis.String(object.created_at)
        : undefined,
      updatedAt: isSet(object.updatedAt)
        ? globalThis.String(object.updatedAt)
        : isSet(object.updated_at)
        ? globalThis.String(object.updated_at)
        : undefined,
      priority: isSet(object.priority) ? globalThis.Number(object.priority) : undefined,
    };
  },

  toJSON(message: ObjectiveAssignment): unknown {
    const obj: any = {};
    if (message.id !== 0) {
      obj.id = Math.round(message.id);
    }
    if (message.objectiveId !== 0) {
      obj.objectiveId = Math.round(message.objectiveId);
    }
    if (message.robotSerial !== "") {
      obj.robotSerial = message.robotSerial;
    }
    if (message.createdAt !== undefined) {
      obj.createdAt = message.createdAt;
    }
    if (message.updatedAt !== undefined) {
      obj.updatedAt = message.updatedAt;
    }
    if (message.priority !== undefined) {
      obj.priority = Math.round(message.priority);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ObjectiveAssignment>, I>>(base?: I): ObjectiveAssignment {
    return ObjectiveAssignment.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ObjectiveAssignment>, I>>(object: I): ObjectiveAssignment {
    const message = createBaseObjectiveAssignment();
    message.id = object.id ?? 0;
    message.objectiveId = object.objectiveId ?? 0;
    message.robotSerial = object.robotSerial ?? "";
    message.createdAt = object.createdAt ?? undefined;
    message.updatedAt = object.updatedAt ?? undefined;
    message.priority = object.priority ?? undefined;
    return message;
  },
};

function createBaseObjectiveAssignmentList(): ObjectiveAssignmentList {
  return { assignments: [] };
}

export const ObjectiveAssignmentList: MessageFns<ObjectiveAssignmentList> = {
  encode(message: ObjectiveAssignmentList, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.assignments) {
      ObjectiveAssignment.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ObjectiveAssignmentList {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseObjectiveAssignmentList();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.assignments.push(ObjectiveAssignment.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ObjectiveAssignmentList {
    return {
      assignments: globalThis.Array.isArray(object?.assignments)
        ? object.assignments.map((e: any) => ObjectiveAssignment.fromJSON(e))
        : [],
    };
  },

  toJSON(message: ObjectiveAssignmentList): unknown {
    const obj: any = {};
    if (message.assignments?.length) {
      obj.assignments = message.assignments.map((e) => ObjectiveAssignment.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ObjectiveAssignmentList>, I>>(base?: I): ObjectiveAssignmentList {
    return ObjectiveAssignmentList.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ObjectiveAssignmentList>, I>>(object: I): ObjectiveAssignmentList {
    const message = createBaseObjectiveAssignmentList();
    message.assignments = object.assignments?.map((e) => ObjectiveAssignment.fromPartial(e)) || [];
    return message;
  },
};

function createBaseListObjectiveAssignmentsResponse(): ListObjectiveAssignmentsResponse {
  return { pageToken: "", assignments: [] };
}

export const ListObjectiveAssignmentsResponse: MessageFns<ListObjectiveAssignmentsResponse> = {
  encode(message: ListObjectiveAssignmentsResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.pageToken !== "") {
      writer.uint32(10).string(message.pageToken);
    }
    for (const v of message.assignments) {
      ObjectiveAssignment.encode(v!, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ListObjectiveAssignmentsResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseListObjectiveAssignmentsResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.pageToken = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.assignments.push(ObjectiveAssignment.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ListObjectiveAssignmentsResponse {
    return {
      pageToken: isSet(object.pageToken)
        ? globalThis.String(object.pageToken)
        : isSet(object.page_token)
        ? globalThis.String(object.page_token)
        : "",
      assignments: globalThis.Array.isArray(object?.assignments)
        ? object.assignments.map((e: any) => ObjectiveAssignment.fromJSON(e))
        : [],
    };
  },

  toJSON(message: ListObjectiveAssignmentsResponse): unknown {
    const obj: any = {};
    if (message.pageToken !== "") {
      obj.pageToken = message.pageToken;
    }
    if (message.assignments?.length) {
      obj.assignments = message.assignments.map((e) => ObjectiveAssignment.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ListObjectiveAssignmentsResponse>, I>>(
    base?: I,
  ): ListObjectiveAssignmentsResponse {
    return ListObjectiveAssignmentsResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ListObjectiveAssignmentsResponse>, I>>(
    object: I,
  ): ListObjectiveAssignmentsResponse {
    const message = createBaseListObjectiveAssignmentsResponse();
    message.pageToken = object.pageToken ?? "";
    message.assignments = object.assignments?.map((e) => ObjectiveAssignment.fromPartial(e)) || [];
    return message;
  },
};

function createBaseAssignNextObjectiveRequest(): AssignNextObjectiveRequest {
  return { jobId: 0, robotSerial: "" };
}

export const AssignNextObjectiveRequest: MessageFns<AssignNextObjectiveRequest> = {
  encode(message: AssignNextObjectiveRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.jobId !== 0) {
      writer.uint32(8).uint64(message.jobId);
    }
    if (message.robotSerial !== "") {
      writer.uint32(18).string(message.robotSerial);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AssignNextObjectiveRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAssignNextObjectiveRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.jobId = longToNumber(reader.uint64());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.robotSerial = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AssignNextObjectiveRequest {
    return {
      jobId: isSet(object.jobId)
        ? globalThis.Number(object.jobId)
        : isSet(object.job_id)
        ? globalThis.Number(object.job_id)
        : 0,
      robotSerial: isSet(object.robotSerial)
        ? globalThis.String(object.robotSerial)
        : isSet(object.robot_serial)
        ? globalThis.String(object.robot_serial)
        : "",
    };
  },

  toJSON(message: AssignNextObjectiveRequest): unknown {
    const obj: any = {};
    if (message.jobId !== 0) {
      obj.jobId = Math.round(message.jobId);
    }
    if (message.robotSerial !== "") {
      obj.robotSerial = message.robotSerial;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AssignNextObjectiveRequest>, I>>(base?: I): AssignNextObjectiveRequest {
    return AssignNextObjectiveRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AssignNextObjectiveRequest>, I>>(object: I): AssignNextObjectiveRequest {
    const message = createBaseAssignNextObjectiveRequest();
    message.jobId = object.jobId ?? 0;
    message.robotSerial = object.robotSerial ?? "";
    return message;
  },
};

function createBaseRobotWhitelistEntry(): RobotWhitelistEntry {
  return { robotSerial: "" };
}

export const RobotWhitelistEntry: MessageFns<RobotWhitelistEntry> = {
  encode(message: RobotWhitelistEntry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.robotSerial !== "") {
      writer.uint32(10).string(message.robotSerial);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RobotWhitelistEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRobotWhitelistEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.robotSerial = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RobotWhitelistEntry {
    return {
      robotSerial: isSet(object.robotSerial)
        ? globalThis.String(object.robotSerial)
        : isSet(object.robot_serial)
        ? globalThis.String(object.robot_serial)
        : "",
    };
  },

  toJSON(message: RobotWhitelistEntry): unknown {
    const obj: any = {};
    if (message.robotSerial !== "") {
      obj.robotSerial = message.robotSerial;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<RobotWhitelistEntry>, I>>(base?: I): RobotWhitelistEntry {
    return RobotWhitelistEntry.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<RobotWhitelistEntry>, I>>(object: I): RobotWhitelistEntry {
    const message = createBaseRobotWhitelistEntry();
    message.robotSerial = object.robotSerial ?? "";
    return message;
  },
};

function createBaseRobotWhitelist(): RobotWhitelist {
  return { entries: [] };
}

export const RobotWhitelist: MessageFns<RobotWhitelist> = {
  encode(message: RobotWhitelist, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.entries) {
      RobotWhitelistEntry.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RobotWhitelist {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRobotWhitelist();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.entries.push(RobotWhitelistEntry.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RobotWhitelist {
    return {
      entries: globalThis.Array.isArray(object?.entries)
        ? object.entries.map((e: any) => RobotWhitelistEntry.fromJSON(e))
        : [],
    };
  },

  toJSON(message: RobotWhitelist): unknown {
    const obj: any = {};
    if (message.entries?.length) {
      obj.entries = message.entries.map((e) => RobotWhitelistEntry.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<RobotWhitelist>, I>>(base?: I): RobotWhitelist {
    return RobotWhitelist.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<RobotWhitelist>, I>>(object: I): RobotWhitelist {
    const message = createBaseRobotWhitelist();
    message.entries = object.entries?.map((e) => RobotWhitelistEntry.fromPartial(e)) || [];
    return message;
  },
};

function createBaseTaskMetadata(): TaskMetadata {
  return { designation: 0, activityType: 0 };
}

export const TaskMetadata: MessageFns<TaskMetadata> = {
  encode(message: TaskMetadata, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.designation !== 0) {
      writer.uint32(8).int32(message.designation);
    }
    if (message.activityType !== 0) {
      writer.uint32(16).int32(message.activityType);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TaskMetadata {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTaskMetadata();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.designation = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.activityType = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TaskMetadata {
    return {
      designation: isSet(object.designation) ? taskDesignationFromJSON(object.designation) : 0,
      activityType: isSet(object.activityType)
        ? autonomousActivityTypeFromJSON(object.activityType)
        : isSet(object.activity_type)
        ? autonomousActivityTypeFromJSON(object.activity_type)
        : 0,
    };
  },

  toJSON(message: TaskMetadata): unknown {
    const obj: any = {};
    if (message.designation !== 0) {
      obj.designation = taskDesignationToJSON(message.designation);
    }
    if (message.activityType !== 0) {
      obj.activityType = autonomousActivityTypeToJSON(message.activityType);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<TaskMetadata>, I>>(base?: I): TaskMetadata {
    return TaskMetadata.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TaskMetadata>, I>>(object: I): TaskMetadata {
    const message = createBaseTaskMetadata();
    message.designation = object.designation ?? 0;
    message.activityType = object.activityType ?? 0;
    return message;
  },
};

function createBaseTask(): Task {
  return {
    id: 0,
    name: "",
    createdAt: undefined,
    startedAt: undefined,
    updatedAt: undefined,
    endedAt: undefined,
    expectedDuration: undefined,
    statusInfo: "",
    expectedTractorState: [],
    state: 0,
    priority: 0,
    objectiveId: 0,
    jobId: 0,
    startLocation: undefined,
    startHeading: 0,
    endLocation: undefined,
    endHeading: 0,
    manuallyAssisted: false,
    progressUpdatedAt: undefined,
    progressLocation: undefined,
    progressHeading: 0,
    progressPath: undefined,
    metadata: undefined,
    sequenceNumber: undefined,
    parentTaskId: undefined,
    sequence: undefined,
    manual: undefined,
    goToAndFace: undefined,
    followPath: undefined,
    getOnPath: undefined,
    tractorState: undefined,
    laserWeed: undefined,
    stopAutonomy: undefined,
    goToReversiblePath: undefined,
    moveCenterPivot: undefined,
    verifyCenterPivot: undefined,
    waitToProceed: undefined,
    followFurrow: undefined,
    workRow: undefined,
  };
}

export const Task: MessageFns<Task> = {
  encode(message: Task, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== 0) {
      writer.uint32(8).uint64(message.id);
    }
    if (message.name !== "") {
      writer.uint32(18).string(message.name);
    }
    if (message.createdAt !== undefined) {
      Timestamp.encode(toTimestamp(message.createdAt), writer.uint32(266).fork()).join();
    }
    if (message.startedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.startedAt), writer.uint32(26).fork()).join();
    }
    if (message.updatedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.updatedAt), writer.uint32(274).fork()).join();
    }
    if (message.endedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.endedAt), writer.uint32(34).fork()).join();
    }
    if (message.expectedDuration !== undefined) {
      Duration.encode(message.expectedDuration, writer.uint32(42).fork()).join();
    }
    if (message.statusInfo !== "") {
      writer.uint32(50).string(message.statusInfo);
    }
    for (const v of message.expectedTractorState) {
      TractorState.encode(v!, writer.uint32(58).fork()).join();
    }
    if (message.state !== 0) {
      writer.uint32(64).int32(message.state);
    }
    if (message.priority !== 0) {
      writer.uint32(72).int32(message.priority);
    }
    if (message.objectiveId !== 0) {
      writer.uint32(128).uint64(message.objectiveId);
    }
    if (message.jobId !== 0) {
      writer.uint32(280).uint64(message.jobId);
    }
    if (message.startLocation !== undefined) {
      Point.encode(message.startLocation, writer.uint32(146).fork()).join();
    }
    if (message.startHeading !== 0) {
      writer.uint32(153).double(message.startHeading);
    }
    if (message.endLocation !== undefined) {
      Point.encode(message.endLocation, writer.uint32(162).fork()).join();
    }
    if (message.endHeading !== 0) {
      writer.uint32(169).double(message.endHeading);
    }
    if (message.manuallyAssisted !== false) {
      writer.uint32(184).bool(message.manuallyAssisted);
    }
    if (message.progressUpdatedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.progressUpdatedAt), writer.uint32(194).fork()).join();
    }
    if (message.progressLocation !== undefined) {
      Point.encode(message.progressLocation, writer.uint32(202).fork()).join();
    }
    if (message.progressHeading !== 0) {
      writer.uint32(209).double(message.progressHeading);
    }
    if (message.progressPath !== undefined) {
      LineString.encode(message.progressPath, writer.uint32(258).fork()).join();
    }
    if (message.metadata !== undefined) {
      TaskMetadata.encode(message.metadata, writer.uint32(234).fork()).join();
    }
    if (message.sequenceNumber !== undefined) {
      writer.uint32(240).uint64(message.sequenceNumber);
    }
    if (message.parentTaskId !== undefined) {
      writer.uint32(248).uint64(message.parentTaskId);
    }
    if (message.sequence !== undefined) {
      SequenceTask.encode(message.sequence, writer.uint32(82).fork()).join();
    }
    if (message.manual !== undefined) {
      ManualTask.encode(message.manual, writer.uint32(90).fork()).join();
    }
    if (message.goToAndFace !== undefined) {
      GoToAndFaceTask.encode(message.goToAndFace, writer.uint32(98).fork()).join();
    }
    if (message.followPath !== undefined) {
      FollowPathTask.encode(message.followPath, writer.uint32(106).fork()).join();
    }
    if (message.getOnPath !== undefined) {
      GetOnPathTask.encode(message.getOnPath, writer.uint32(290).fork()).join();
    }
    if (message.tractorState !== undefined) {
      SetTractorStateTask.encode(message.tractorState, writer.uint32(114).fork()).join();
    }
    if (message.laserWeed !== undefined) {
      LaserWeedTask.encode(message.laserWeed, writer.uint32(122).fork()).join();
    }
    if (message.stopAutonomy !== undefined) {
      StopAutonomyTask.encode(message.stopAutonomy, writer.uint32(138).fork()).join();
    }
    if (message.goToReversiblePath !== undefined) {
      GoToReversiblePathTask.encode(message.goToReversiblePath, writer.uint32(178).fork()).join();
    }
    if (message.moveCenterPivot !== undefined) {
      MoveCenterPivotTask.encode(message.moveCenterPivot, writer.uint32(218).fork()).join();
    }
    if (message.verifyCenterPivot !== undefined) {
      VerifyCenterPivotTask.encode(message.verifyCenterPivot, writer.uint32(226).fork()).join();
    }
    if (message.waitToProceed !== undefined) {
      WaitToProceedTask.encode(message.waitToProceed, writer.uint32(298).fork()).join();
    }
    if (message.followFurrow !== undefined) {
      FollowFurrowTask.encode(message.followFurrow, writer.uint32(306).fork()).join();
    }
    if (message.workRow !== undefined) {
      WorkRowTask.encode(message.workRow, writer.uint32(314).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Task {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTask();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.id = longToNumber(reader.uint64());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 33: {
          if (tag !== 266) {
            break;
          }

          message.createdAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.startedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 34: {
          if (tag !== 274) {
            break;
          }

          message.updatedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.endedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.expectedDuration = Duration.decode(reader, reader.uint32());
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.statusInfo = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.expectedTractorState.push(TractorState.decode(reader, reader.uint32()));
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.state = reader.int32() as any;
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.priority = reader.int32();
          continue;
        }
        case 16: {
          if (tag !== 128) {
            break;
          }

          message.objectiveId = longToNumber(reader.uint64());
          continue;
        }
        case 35: {
          if (tag !== 280) {
            break;
          }

          message.jobId = longToNumber(reader.uint64());
          continue;
        }
        case 18: {
          if (tag !== 146) {
            break;
          }

          message.startLocation = Point.decode(reader, reader.uint32());
          continue;
        }
        case 19: {
          if (tag !== 153) {
            break;
          }

          message.startHeading = reader.double();
          continue;
        }
        case 20: {
          if (tag !== 162) {
            break;
          }

          message.endLocation = Point.decode(reader, reader.uint32());
          continue;
        }
        case 21: {
          if (tag !== 169) {
            break;
          }

          message.endHeading = reader.double();
          continue;
        }
        case 23: {
          if (tag !== 184) {
            break;
          }

          message.manuallyAssisted = reader.bool();
          continue;
        }
        case 24: {
          if (tag !== 194) {
            break;
          }

          message.progressUpdatedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 25: {
          if (tag !== 202) {
            break;
          }

          message.progressLocation = Point.decode(reader, reader.uint32());
          continue;
        }
        case 26: {
          if (tag !== 209) {
            break;
          }

          message.progressHeading = reader.double();
          continue;
        }
        case 32: {
          if (tag !== 258) {
            break;
          }

          message.progressPath = LineString.decode(reader, reader.uint32());
          continue;
        }
        case 29: {
          if (tag !== 234) {
            break;
          }

          message.metadata = TaskMetadata.decode(reader, reader.uint32());
          continue;
        }
        case 30: {
          if (tag !== 240) {
            break;
          }

          message.sequenceNumber = longToNumber(reader.uint64());
          continue;
        }
        case 31: {
          if (tag !== 248) {
            break;
          }

          message.parentTaskId = longToNumber(reader.uint64());
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.sequence = SequenceTask.decode(reader, reader.uint32());
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.manual = ManualTask.decode(reader, reader.uint32());
          continue;
        }
        case 12: {
          if (tag !== 98) {
            break;
          }

          message.goToAndFace = GoToAndFaceTask.decode(reader, reader.uint32());
          continue;
        }
        case 13: {
          if (tag !== 106) {
            break;
          }

          message.followPath = FollowPathTask.decode(reader, reader.uint32());
          continue;
        }
        case 36: {
          if (tag !== 290) {
            break;
          }

          message.getOnPath = GetOnPathTask.decode(reader, reader.uint32());
          continue;
        }
        case 14: {
          if (tag !== 114) {
            break;
          }

          message.tractorState = SetTractorStateTask.decode(reader, reader.uint32());
          continue;
        }
        case 15: {
          if (tag !== 122) {
            break;
          }

          message.laserWeed = LaserWeedTask.decode(reader, reader.uint32());
          continue;
        }
        case 17: {
          if (tag !== 138) {
            break;
          }

          message.stopAutonomy = StopAutonomyTask.decode(reader, reader.uint32());
          continue;
        }
        case 22: {
          if (tag !== 178) {
            break;
          }

          message.goToReversiblePath = GoToReversiblePathTask.decode(reader, reader.uint32());
          continue;
        }
        case 27: {
          if (tag !== 218) {
            break;
          }

          message.moveCenterPivot = MoveCenterPivotTask.decode(reader, reader.uint32());
          continue;
        }
        case 28: {
          if (tag !== 226) {
            break;
          }

          message.verifyCenterPivot = VerifyCenterPivotTask.decode(reader, reader.uint32());
          continue;
        }
        case 37: {
          if (tag !== 298) {
            break;
          }

          message.waitToProceed = WaitToProceedTask.decode(reader, reader.uint32());
          continue;
        }
        case 38: {
          if (tag !== 306) {
            break;
          }

          message.followFurrow = FollowFurrowTask.decode(reader, reader.uint32());
          continue;
        }
        case 39: {
          if (tag !== 314) {
            break;
          }

          message.workRow = WorkRowTask.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Task {
    return {
      id: isSet(object.id) ? globalThis.Number(object.id) : 0,
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      createdAt: isSet(object.createdAt)
        ? globalThis.String(object.createdAt)
        : isSet(object.created_at)
        ? globalThis.String(object.created_at)
        : undefined,
      startedAt: isSet(object.startedAt)
        ? globalThis.String(object.startedAt)
        : isSet(object.started_at)
        ? globalThis.String(object.started_at)
        : undefined,
      updatedAt: isSet(object.updatedAt)
        ? globalThis.String(object.updatedAt)
        : isSet(object.updated_at)
        ? globalThis.String(object.updated_at)
        : undefined,
      endedAt: isSet(object.endedAt)
        ? globalThis.String(object.endedAt)
        : isSet(object.ended_at)
        ? globalThis.String(object.ended_at)
        : undefined,
      expectedDuration: isSet(object.expectedDuration)
        ? Duration.fromJSON(object.expectedDuration)
        : isSet(object.expected_duration)
        ? Duration.fromJSON(object.expected_duration)
        : undefined,
      statusInfo: isSet(object.statusInfo)
        ? globalThis.String(object.statusInfo)
        : isSet(object.status_info)
        ? globalThis.String(object.status_info)
        : "",
      expectedTractorState: globalThis.Array.isArray(object?.expectedTractorState)
        ? object.expectedTractorState.map((e: any) => TractorState.fromJSON(e))
        : globalThis.Array.isArray(object?.expected_tractor_state)
        ? object.expected_tractor_state.map((e: any) => TractorState.fromJSON(e))
        : [],
      state: isSet(object.state) ? stateFromJSON(object.state) : 0,
      priority: isSet(object.priority) ? globalThis.Number(object.priority) : 0,
      objectiveId: isSet(object.objectiveId)
        ? globalThis.Number(object.objectiveId)
        : isSet(object.objective_id)
        ? globalThis.Number(object.objective_id)
        : 0,
      jobId: isSet(object.jobId)
        ? globalThis.Number(object.jobId)
        : isSet(object.job_id)
        ? globalThis.Number(object.job_id)
        : 0,
      startLocation: isSet(object.startLocation)
        ? Point.fromJSON(object.startLocation)
        : isSet(object.start_location)
        ? Point.fromJSON(object.start_location)
        : undefined,
      startHeading: isSet(object.startHeading)
        ? globalThis.Number(object.startHeading)
        : isSet(object.start_heading)
        ? globalThis.Number(object.start_heading)
        : 0,
      endLocation: isSet(object.endLocation)
        ? Point.fromJSON(object.endLocation)
        : isSet(object.end_location)
        ? Point.fromJSON(object.end_location)
        : undefined,
      endHeading: isSet(object.endHeading)
        ? globalThis.Number(object.endHeading)
        : isSet(object.end_heading)
        ? globalThis.Number(object.end_heading)
        : 0,
      manuallyAssisted: isSet(object.manuallyAssisted)
        ? globalThis.Boolean(object.manuallyAssisted)
        : isSet(object.manually_assisted)
        ? globalThis.Boolean(object.manually_assisted)
        : false,
      progressUpdatedAt: isSet(object.progressUpdatedAt)
        ? globalThis.String(object.progressUpdatedAt)
        : isSet(object.progress_updated_at)
        ? globalThis.String(object.progress_updated_at)
        : undefined,
      progressLocation: isSet(object.progressLocation)
        ? Point.fromJSON(object.progressLocation)
        : isSet(object.progress_location)
        ? Point.fromJSON(object.progress_location)
        : undefined,
      progressHeading: isSet(object.progressHeading)
        ? globalThis.Number(object.progressHeading)
        : isSet(object.progress_heading)
        ? globalThis.Number(object.progress_heading)
        : 0,
      progressPath: isSet(object.progressPath)
        ? LineString.fromJSON(object.progressPath)
        : isSet(object.progress_path)
        ? LineString.fromJSON(object.progress_path)
        : undefined,
      metadata: isSet(object.metadata) ? TaskMetadata.fromJSON(object.metadata) : undefined,
      sequenceNumber: isSet(object.sequenceNumber)
        ? globalThis.Number(object.sequenceNumber)
        : isSet(object.sequence_number)
        ? globalThis.Number(object.sequence_number)
        : undefined,
      parentTaskId: isSet(object.parentTaskId)
        ? globalThis.Number(object.parentTaskId)
        : isSet(object.parent_task_id)
        ? globalThis.Number(object.parent_task_id)
        : undefined,
      sequence: isSet(object.sequence) ? SequenceTask.fromJSON(object.sequence) : undefined,
      manual: isSet(object.manual) ? ManualTask.fromJSON(object.manual) : undefined,
      goToAndFace: isSet(object.goToAndFace)
        ? GoToAndFaceTask.fromJSON(object.goToAndFace)
        : isSet(object.go_to_and_face)
        ? GoToAndFaceTask.fromJSON(object.go_to_and_face)
        : undefined,
      followPath: isSet(object.followPath)
        ? FollowPathTask.fromJSON(object.followPath)
        : isSet(object.follow_path)
        ? FollowPathTask.fromJSON(object.follow_path)
        : undefined,
      getOnPath: isSet(object.getOnPath)
        ? GetOnPathTask.fromJSON(object.getOnPath)
        : isSet(object.get_on_path)
        ? GetOnPathTask.fromJSON(object.get_on_path)
        : undefined,
      tractorState: isSet(object.tractorState)
        ? SetTractorStateTask.fromJSON(object.tractorState)
        : isSet(object.tractor_state)
        ? SetTractorStateTask.fromJSON(object.tractor_state)
        : undefined,
      laserWeed: isSet(object.laserWeed)
        ? LaserWeedTask.fromJSON(object.laserWeed)
        : isSet(object.laser_weed)
        ? LaserWeedTask.fromJSON(object.laser_weed)
        : undefined,
      stopAutonomy: isSet(object.stopAutonomy)
        ? StopAutonomyTask.fromJSON(object.stopAutonomy)
        : isSet(object.stop_autonomy)
        ? StopAutonomyTask.fromJSON(object.stop_autonomy)
        : undefined,
      goToReversiblePath: isSet(object.goToReversiblePath)
        ? GoToReversiblePathTask.fromJSON(object.goToReversiblePath)
        : isSet(object.go_to_reversible_path)
        ? GoToReversiblePathTask.fromJSON(object.go_to_reversible_path)
        : undefined,
      moveCenterPivot: isSet(object.moveCenterPivot)
        ? MoveCenterPivotTask.fromJSON(object.moveCenterPivot)
        : isSet(object.move_center_pivot)
        ? MoveCenterPivotTask.fromJSON(object.move_center_pivot)
        : undefined,
      verifyCenterPivot: isSet(object.verifyCenterPivot)
        ? VerifyCenterPivotTask.fromJSON(object.verifyCenterPivot)
        : isSet(object.verify_center_pivot)
        ? VerifyCenterPivotTask.fromJSON(object.verify_center_pivot)
        : undefined,
      waitToProceed: isSet(object.waitToProceed)
        ? WaitToProceedTask.fromJSON(object.waitToProceed)
        : isSet(object.wait_to_proceed)
        ? WaitToProceedTask.fromJSON(object.wait_to_proceed)
        : undefined,
      followFurrow: isSet(object.followFurrow)
        ? FollowFurrowTask.fromJSON(object.followFurrow)
        : isSet(object.follow_furrow)
        ? FollowFurrowTask.fromJSON(object.follow_furrow)
        : undefined,
      workRow: isSet(object.workRow)
        ? WorkRowTask.fromJSON(object.workRow)
        : isSet(object.work_row)
        ? WorkRowTask.fromJSON(object.work_row)
        : undefined,
    };
  },

  toJSON(message: Task): unknown {
    const obj: any = {};
    if (message.id !== 0) {
      obj.id = Math.round(message.id);
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.createdAt !== undefined) {
      obj.createdAt = message.createdAt;
    }
    if (message.startedAt !== undefined) {
      obj.startedAt = message.startedAt;
    }
    if (message.updatedAt !== undefined) {
      obj.updatedAt = message.updatedAt;
    }
    if (message.endedAt !== undefined) {
      obj.endedAt = message.endedAt;
    }
    if (message.expectedDuration !== undefined) {
      obj.expectedDuration = Duration.toJSON(message.expectedDuration);
    }
    if (message.statusInfo !== "") {
      obj.statusInfo = message.statusInfo;
    }
    if (message.expectedTractorState?.length) {
      obj.expectedTractorState = message.expectedTractorState.map((e) => TractorState.toJSON(e));
    }
    if (message.state !== 0) {
      obj.state = stateToJSON(message.state);
    }
    if (message.priority !== 0) {
      obj.priority = Math.round(message.priority);
    }
    if (message.objectiveId !== 0) {
      obj.objectiveId = Math.round(message.objectiveId);
    }
    if (message.jobId !== 0) {
      obj.jobId = Math.round(message.jobId);
    }
    if (message.startLocation !== undefined) {
      obj.startLocation = Point.toJSON(message.startLocation);
    }
    if (message.startHeading !== 0) {
      obj.startHeading = message.startHeading;
    }
    if (message.endLocation !== undefined) {
      obj.endLocation = Point.toJSON(message.endLocation);
    }
    if (message.endHeading !== 0) {
      obj.endHeading = message.endHeading;
    }
    if (message.manuallyAssisted !== false) {
      obj.manuallyAssisted = message.manuallyAssisted;
    }
    if (message.progressUpdatedAt !== undefined) {
      obj.progressUpdatedAt = message.progressUpdatedAt;
    }
    if (message.progressLocation !== undefined) {
      obj.progressLocation = Point.toJSON(message.progressLocation);
    }
    if (message.progressHeading !== 0) {
      obj.progressHeading = message.progressHeading;
    }
    if (message.progressPath !== undefined) {
      obj.progressPath = LineString.toJSON(message.progressPath);
    }
    if (message.metadata !== undefined) {
      obj.metadata = TaskMetadata.toJSON(message.metadata);
    }
    if (message.sequenceNumber !== undefined) {
      obj.sequenceNumber = Math.round(message.sequenceNumber);
    }
    if (message.parentTaskId !== undefined) {
      obj.parentTaskId = Math.round(message.parentTaskId);
    }
    if (message.sequence !== undefined) {
      obj.sequence = SequenceTask.toJSON(message.sequence);
    }
    if (message.manual !== undefined) {
      obj.manual = ManualTask.toJSON(message.manual);
    }
    if (message.goToAndFace !== undefined) {
      obj.goToAndFace = GoToAndFaceTask.toJSON(message.goToAndFace);
    }
    if (message.followPath !== undefined) {
      obj.followPath = FollowPathTask.toJSON(message.followPath);
    }
    if (message.getOnPath !== undefined) {
      obj.getOnPath = GetOnPathTask.toJSON(message.getOnPath);
    }
    if (message.tractorState !== undefined) {
      obj.tractorState = SetTractorStateTask.toJSON(message.tractorState);
    }
    if (message.laserWeed !== undefined) {
      obj.laserWeed = LaserWeedTask.toJSON(message.laserWeed);
    }
    if (message.stopAutonomy !== undefined) {
      obj.stopAutonomy = StopAutonomyTask.toJSON(message.stopAutonomy);
    }
    if (message.goToReversiblePath !== undefined) {
      obj.goToReversiblePath = GoToReversiblePathTask.toJSON(message.goToReversiblePath);
    }
    if (message.moveCenterPivot !== undefined) {
      obj.moveCenterPivot = MoveCenterPivotTask.toJSON(message.moveCenterPivot);
    }
    if (message.verifyCenterPivot !== undefined) {
      obj.verifyCenterPivot = VerifyCenterPivotTask.toJSON(message.verifyCenterPivot);
    }
    if (message.waitToProceed !== undefined) {
      obj.waitToProceed = WaitToProceedTask.toJSON(message.waitToProceed);
    }
    if (message.followFurrow !== undefined) {
      obj.followFurrow = FollowFurrowTask.toJSON(message.followFurrow);
    }
    if (message.workRow !== undefined) {
      obj.workRow = WorkRowTask.toJSON(message.workRow);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Task>, I>>(base?: I): Task {
    return Task.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Task>, I>>(object: I): Task {
    const message = createBaseTask();
    message.id = object.id ?? 0;
    message.name = object.name ?? "";
    message.createdAt = object.createdAt ?? undefined;
    message.startedAt = object.startedAt ?? undefined;
    message.updatedAt = object.updatedAt ?? undefined;
    message.endedAt = object.endedAt ?? undefined;
    message.expectedDuration = (object.expectedDuration !== undefined && object.expectedDuration !== null)
      ? Duration.fromPartial(object.expectedDuration)
      : undefined;
    message.statusInfo = object.statusInfo ?? "";
    message.expectedTractorState = object.expectedTractorState?.map((e) => TractorState.fromPartial(e)) || [];
    message.state = object.state ?? 0;
    message.priority = object.priority ?? 0;
    message.objectiveId = object.objectiveId ?? 0;
    message.jobId = object.jobId ?? 0;
    message.startLocation = (object.startLocation !== undefined && object.startLocation !== null)
      ? Point.fromPartial(object.startLocation)
      : undefined;
    message.startHeading = object.startHeading ?? 0;
    message.endLocation = (object.endLocation !== undefined && object.endLocation !== null)
      ? Point.fromPartial(object.endLocation)
      : undefined;
    message.endHeading = object.endHeading ?? 0;
    message.manuallyAssisted = object.manuallyAssisted ?? false;
    message.progressUpdatedAt = object.progressUpdatedAt ?? undefined;
    message.progressLocation = (object.progressLocation !== undefined && object.progressLocation !== null)
      ? Point.fromPartial(object.progressLocation)
      : undefined;
    message.progressHeading = object.progressHeading ?? 0;
    message.progressPath = (object.progressPath !== undefined && object.progressPath !== null)
      ? LineString.fromPartial(object.progressPath)
      : undefined;
    message.metadata = (object.metadata !== undefined && object.metadata !== null)
      ? TaskMetadata.fromPartial(object.metadata)
      : undefined;
    message.sequenceNumber = object.sequenceNumber ?? undefined;
    message.parentTaskId = object.parentTaskId ?? undefined;
    message.sequence = (object.sequence !== undefined && object.sequence !== null)
      ? SequenceTask.fromPartial(object.sequence)
      : undefined;
    message.manual = (object.manual !== undefined && object.manual !== null)
      ? ManualTask.fromPartial(object.manual)
      : undefined;
    message.goToAndFace = (object.goToAndFace !== undefined && object.goToAndFace !== null)
      ? GoToAndFaceTask.fromPartial(object.goToAndFace)
      : undefined;
    message.followPath = (object.followPath !== undefined && object.followPath !== null)
      ? FollowPathTask.fromPartial(object.followPath)
      : undefined;
    message.getOnPath = (object.getOnPath !== undefined && object.getOnPath !== null)
      ? GetOnPathTask.fromPartial(object.getOnPath)
      : undefined;
    message.tractorState = (object.tractorState !== undefined && object.tractorState !== null)
      ? SetTractorStateTask.fromPartial(object.tractorState)
      : undefined;
    message.laserWeed = (object.laserWeed !== undefined && object.laserWeed !== null)
      ? LaserWeedTask.fromPartial(object.laserWeed)
      : undefined;
    message.stopAutonomy = (object.stopAutonomy !== undefined && object.stopAutonomy !== null)
      ? StopAutonomyTask.fromPartial(object.stopAutonomy)
      : undefined;
    message.goToReversiblePath = (object.goToReversiblePath !== undefined && object.goToReversiblePath !== null)
      ? GoToReversiblePathTask.fromPartial(object.goToReversiblePath)
      : undefined;
    message.moveCenterPivot = (object.moveCenterPivot !== undefined && object.moveCenterPivot !== null)
      ? MoveCenterPivotTask.fromPartial(object.moveCenterPivot)
      : undefined;
    message.verifyCenterPivot = (object.verifyCenterPivot !== undefined && object.verifyCenterPivot !== null)
      ? VerifyCenterPivotTask.fromPartial(object.verifyCenterPivot)
      : undefined;
    message.waitToProceed = (object.waitToProceed !== undefined && object.waitToProceed !== null)
      ? WaitToProceedTask.fromPartial(object.waitToProceed)
      : undefined;
    message.followFurrow = (object.followFurrow !== undefined && object.followFurrow !== null)
      ? FollowFurrowTask.fromPartial(object.followFurrow)
      : undefined;
    message.workRow = (object.workRow !== undefined && object.workRow !== null)
      ? WorkRowTask.fromPartial(object.workRow)
      : undefined;
    return message;
  },
};

function createBaseStopAutonomyTask(): StopAutonomyTask {
  return {};
}

export const StopAutonomyTask: MessageFns<StopAutonomyTask> = {
  encode(_: StopAutonomyTask, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StopAutonomyTask {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStopAutonomyTask();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): StopAutonomyTask {
    return {};
  },

  toJSON(_: StopAutonomyTask): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<StopAutonomyTask>, I>>(base?: I): StopAutonomyTask {
    return StopAutonomyTask.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<StopAutonomyTask>, I>>(_: I): StopAutonomyTask {
    const message = createBaseStopAutonomyTask();
    return message;
  },
};

function createBaseWaitToProceedTask(): WaitToProceedTask {
  return { reason: 0, point: undefined, heading: 0, tolerances: undefined };
}

export const WaitToProceedTask: MessageFns<WaitToProceedTask> = {
  encode(message: WaitToProceedTask, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.reason !== 0) {
      writer.uint32(8).int32(message.reason);
    }
    if (message.point !== undefined) {
      Point.encode(message.point, writer.uint32(18).fork()).join();
    }
    if (message.heading !== 0) {
      writer.uint32(25).double(message.heading);
    }
    if (message.tolerances !== undefined) {
      SpatialPathTolerance.encode(message.tolerances, writer.uint32(34).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): WaitToProceedTask {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseWaitToProceedTask();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.reason = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.point = Point.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 25) {
            break;
          }

          message.heading = reader.double();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.tolerances = SpatialPathTolerance.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): WaitToProceedTask {
    return {
      reason: isSet(object.reason) ? waitToProceedReasonFromJSON(object.reason) : 0,
      point: isSet(object.point) ? Point.fromJSON(object.point) : undefined,
      heading: isSet(object.heading) ? globalThis.Number(object.heading) : 0,
      tolerances: isSet(object.tolerances) ? SpatialPathTolerance.fromJSON(object.tolerances) : undefined,
    };
  },

  toJSON(message: WaitToProceedTask): unknown {
    const obj: any = {};
    if (message.reason !== 0) {
      obj.reason = waitToProceedReasonToJSON(message.reason);
    }
    if (message.point !== undefined) {
      obj.point = Point.toJSON(message.point);
    }
    if (message.heading !== 0) {
      obj.heading = message.heading;
    }
    if (message.tolerances !== undefined) {
      obj.tolerances = SpatialPathTolerance.toJSON(message.tolerances);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<WaitToProceedTask>, I>>(base?: I): WaitToProceedTask {
    return WaitToProceedTask.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<WaitToProceedTask>, I>>(object: I): WaitToProceedTask {
    const message = createBaseWaitToProceedTask();
    message.reason = object.reason ?? 0;
    message.point = (object.point !== undefined && object.point !== null) ? Point.fromPartial(object.point) : undefined;
    message.heading = object.heading ?? 0;
    message.tolerances = (object.tolerances !== undefined && object.tolerances !== null)
      ? SpatialPathTolerance.fromPartial(object.tolerances)
      : undefined;
    return message;
  },
};

function createBaseRigPose(): RigPose {
  return { location: undefined, heading: 0 };
}

export const RigPose: MessageFns<RigPose> = {
  encode(message: RigPose, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.location !== undefined) {
      RigPointLocation.encode(message.location, writer.uint32(10).fork()).join();
    }
    if (message.heading !== 0) {
      writer.uint32(17).double(message.heading);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RigPose {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRigPose();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.location = RigPointLocation.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 17) {
            break;
          }

          message.heading = reader.double();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RigPose {
    return {
      location: isSet(object.location) ? RigPointLocation.fromJSON(object.location) : undefined,
      heading: isSet(object.heading) ? globalThis.Number(object.heading) : 0,
    };
  },

  toJSON(message: RigPose): unknown {
    const obj: any = {};
    if (message.location !== undefined) {
      obj.location = RigPointLocation.toJSON(message.location);
    }
    if (message.heading !== 0) {
      obj.heading = message.heading;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<RigPose>, I>>(base?: I): RigPose {
    return RigPose.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<RigPose>, I>>(object: I): RigPose {
    const message = createBaseRigPose();
    message.location = (object.location !== undefined && object.location !== null)
      ? RigPointLocation.fromPartial(object.location)
      : undefined;
    message.heading = object.heading ?? 0;
    return message;
  },
};

function createBaseLaserWeedTask(): LaserWeedTask {
  return {
    path: undefined,
    pathIsReversible: false,
    weedingEnabled: false,
    thinningEnabled: false,
    tolerances: undefined,
    rigAlignmentPoint: 0,
  };
}

export const LaserWeedTask: MessageFns<LaserWeedTask> = {
  encode(message: LaserWeedTask, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.path !== undefined) {
      LineString.encode(message.path, writer.uint32(10).fork()).join();
    }
    if (message.pathIsReversible !== false) {
      writer.uint32(16).bool(message.pathIsReversible);
    }
    if (message.weedingEnabled !== false) {
      writer.uint32(24).bool(message.weedingEnabled);
    }
    if (message.thinningEnabled !== false) {
      writer.uint32(32).bool(message.thinningEnabled);
    }
    if (message.tolerances !== undefined) {
      SpatialPathTolerance.encode(message.tolerances, writer.uint32(50).fork()).join();
    }
    if (message.rigAlignmentPoint !== 0) {
      writer.uint32(56).int32(message.rigAlignmentPoint);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): LaserWeedTask {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseLaserWeedTask();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.path = LineString.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.pathIsReversible = reader.bool();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.weedingEnabled = reader.bool();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.thinningEnabled = reader.bool();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.tolerances = SpatialPathTolerance.decode(reader, reader.uint32());
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.rigAlignmentPoint = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): LaserWeedTask {
    return {
      path: isSet(object.path) ? LineString.fromJSON(object.path) : undefined,
      pathIsReversible: isSet(object.pathIsReversible)
        ? globalThis.Boolean(object.pathIsReversible)
        : isSet(object.path_is_reversible)
        ? globalThis.Boolean(object.path_is_reversible)
        : false,
      weedingEnabled: isSet(object.weedingEnabled)
        ? globalThis.Boolean(object.weedingEnabled)
        : isSet(object.weeding_enabled)
        ? globalThis.Boolean(object.weeding_enabled)
        : false,
      thinningEnabled: isSet(object.thinningEnabled)
        ? globalThis.Boolean(object.thinningEnabled)
        : isSet(object.thinning_enabled)
        ? globalThis.Boolean(object.thinning_enabled)
        : false,
      tolerances: isSet(object.tolerances) ? SpatialPathTolerance.fromJSON(object.tolerances) : undefined,
      rigAlignmentPoint: isSet(object.rigAlignmentPoint)
        ? rigPointFromJSON(object.rigAlignmentPoint)
        : isSet(object.rig_alignment_point)
        ? rigPointFromJSON(object.rig_alignment_point)
        : 0,
    };
  },

  toJSON(message: LaserWeedTask): unknown {
    const obj: any = {};
    if (message.path !== undefined) {
      obj.path = LineString.toJSON(message.path);
    }
    if (message.pathIsReversible !== false) {
      obj.pathIsReversible = message.pathIsReversible;
    }
    if (message.weedingEnabled !== false) {
      obj.weedingEnabled = message.weedingEnabled;
    }
    if (message.thinningEnabled !== false) {
      obj.thinningEnabled = message.thinningEnabled;
    }
    if (message.tolerances !== undefined) {
      obj.tolerances = SpatialPathTolerance.toJSON(message.tolerances);
    }
    if (message.rigAlignmentPoint !== 0) {
      obj.rigAlignmentPoint = rigPointToJSON(message.rigAlignmentPoint);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<LaserWeedTask>, I>>(base?: I): LaserWeedTask {
    return LaserWeedTask.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<LaserWeedTask>, I>>(object: I): LaserWeedTask {
    const message = createBaseLaserWeedTask();
    message.path = (object.path !== undefined && object.path !== null)
      ? LineString.fromPartial(object.path)
      : undefined;
    message.pathIsReversible = object.pathIsReversible ?? false;
    message.weedingEnabled = object.weedingEnabled ?? false;
    message.thinningEnabled = object.thinningEnabled ?? false;
    message.tolerances = (object.tolerances !== undefined && object.tolerances !== null)
      ? SpatialPathTolerance.fromPartial(object.tolerances)
      : undefined;
    message.rigAlignmentPoint = object.rigAlignmentPoint ?? 0;
    return message;
  },
};

function createBaseWorkRowTask(): WorkRowTask {
  return {
    path: undefined,
    pathIsReversible: false,
    followMethod: 0,
    speed: undefined,
    tolerances: undefined,
    rigAlignmentPoint: 0,
  };
}

export const WorkRowTask: MessageFns<WorkRowTask> = {
  encode(message: WorkRowTask, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.path !== undefined) {
      LineString.encode(message.path, writer.uint32(10).fork()).join();
    }
    if (message.pathIsReversible !== false) {
      writer.uint32(16).bool(message.pathIsReversible);
    }
    if (message.followMethod !== 0) {
      writer.uint32(24).int32(message.followMethod);
    }
    if (message.speed !== undefined) {
      SpeedSetting.encode(message.speed, writer.uint32(34).fork()).join();
    }
    if (message.tolerances !== undefined) {
      SpatialPathTolerance.encode(message.tolerances, writer.uint32(42).fork()).join();
    }
    if (message.rigAlignmentPoint !== 0) {
      writer.uint32(48).int32(message.rigAlignmentPoint);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): WorkRowTask {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseWorkRowTask();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.path = LineString.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.pathIsReversible = reader.bool();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.followMethod = reader.int32() as any;
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.speed = SpeedSetting.decode(reader, reader.uint32());
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.tolerances = SpatialPathTolerance.decode(reader, reader.uint32());
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.rigAlignmentPoint = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): WorkRowTask {
    return {
      path: isSet(object.path) ? LineString.fromJSON(object.path) : undefined,
      pathIsReversible: isSet(object.pathIsReversible)
        ? globalThis.Boolean(object.pathIsReversible)
        : isSet(object.path_is_reversible)
        ? globalThis.Boolean(object.path_is_reversible)
        : false,
      followMethod: isSet(object.followMethod)
        ? followMethodFromJSON(object.followMethod)
        : isSet(object.follow_method)
        ? followMethodFromJSON(object.follow_method)
        : 0,
      speed: isSet(object.speed) ? SpeedSetting.fromJSON(object.speed) : undefined,
      tolerances: isSet(object.tolerances) ? SpatialPathTolerance.fromJSON(object.tolerances) : undefined,
      rigAlignmentPoint: isSet(object.rigAlignmentPoint)
        ? rigPointFromJSON(object.rigAlignmentPoint)
        : isSet(object.rig_alignment_point)
        ? rigPointFromJSON(object.rig_alignment_point)
        : 0,
    };
  },

  toJSON(message: WorkRowTask): unknown {
    const obj: any = {};
    if (message.path !== undefined) {
      obj.path = LineString.toJSON(message.path);
    }
    if (message.pathIsReversible !== false) {
      obj.pathIsReversible = message.pathIsReversible;
    }
    if (message.followMethod !== 0) {
      obj.followMethod = followMethodToJSON(message.followMethod);
    }
    if (message.speed !== undefined) {
      obj.speed = SpeedSetting.toJSON(message.speed);
    }
    if (message.tolerances !== undefined) {
      obj.tolerances = SpatialPathTolerance.toJSON(message.tolerances);
    }
    if (message.rigAlignmentPoint !== 0) {
      obj.rigAlignmentPoint = rigPointToJSON(message.rigAlignmentPoint);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<WorkRowTask>, I>>(base?: I): WorkRowTask {
    return WorkRowTask.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<WorkRowTask>, I>>(object: I): WorkRowTask {
    const message = createBaseWorkRowTask();
    message.path = (object.path !== undefined && object.path !== null)
      ? LineString.fromPartial(object.path)
      : undefined;
    message.pathIsReversible = object.pathIsReversible ?? false;
    message.followMethod = object.followMethod ?? 0;
    message.speed = (object.speed !== undefined && object.speed !== null)
      ? SpeedSetting.fromPartial(object.speed)
      : undefined;
    message.tolerances = (object.tolerances !== undefined && object.tolerances !== null)
      ? SpatialPathTolerance.fromPartial(object.tolerances)
      : undefined;
    message.rigAlignmentPoint = object.rigAlignmentPoint ?? 0;
    return message;
  },
};

function createBaseSequenceTask(): SequenceTask {
  return { items: [], atomic: false, batch: false };
}

export const SequenceTask: MessageFns<SequenceTask> = {
  encode(message: SequenceTask, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.items) {
      Task.encode(v!, writer.uint32(10).fork()).join();
    }
    if (message.atomic !== false) {
      writer.uint32(16).bool(message.atomic);
    }
    if (message.batch !== false) {
      writer.uint32(24).bool(message.batch);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SequenceTask {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSequenceTask();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.items.push(Task.decode(reader, reader.uint32()));
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.atomic = reader.bool();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.batch = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SequenceTask {
    return {
      items: globalThis.Array.isArray(object?.items) ? object.items.map((e: any) => Task.fromJSON(e)) : [],
      atomic: isSet(object.atomic) ? globalThis.Boolean(object.atomic) : false,
      batch: isSet(object.batch) ? globalThis.Boolean(object.batch) : false,
    };
  },

  toJSON(message: SequenceTask): unknown {
    const obj: any = {};
    if (message.items?.length) {
      obj.items = message.items.map((e) => Task.toJSON(e));
    }
    if (message.atomic !== false) {
      obj.atomic = message.atomic;
    }
    if (message.batch !== false) {
      obj.batch = message.batch;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SequenceTask>, I>>(base?: I): SequenceTask {
    return SequenceTask.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SequenceTask>, I>>(object: I): SequenceTask {
    const message = createBaseSequenceTask();
    message.items = object.items?.map((e) => Task.fromPartial(e)) || [];
    message.atomic = object.atomic ?? false;
    message.batch = object.batch ?? false;
    return message;
  },
};

function createBaseManualTask(): ManualTask {
  return { instructions: "" };
}

export const ManualTask: MessageFns<ManualTask> = {
  encode(message: ManualTask, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.instructions !== "") {
      writer.uint32(10).string(message.instructions);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ManualTask {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseManualTask();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.instructions = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ManualTask {
    return { instructions: isSet(object.instructions) ? globalThis.String(object.instructions) : "" };
  },

  toJSON(message: ManualTask): unknown {
    const obj: any = {};
    if (message.instructions !== "") {
      obj.instructions = message.instructions;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ManualTask>, I>>(base?: I): ManualTask {
    return ManualTask.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ManualTask>, I>>(object: I): ManualTask {
    const message = createBaseManualTask();
    message.instructions = object.instructions ?? "";
    return message;
  },
};

function createBaseGoToAndFaceTask(): GoToAndFaceTask {
  return { point: undefined, heading: 0, tolerances: undefined };
}

export const GoToAndFaceTask: MessageFns<GoToAndFaceTask> = {
  encode(message: GoToAndFaceTask, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.point !== undefined) {
      Point.encode(message.point, writer.uint32(10).fork()).join();
    }
    if (message.heading !== 0) {
      writer.uint32(17).double(message.heading);
    }
    if (message.tolerances !== undefined) {
      SpatialPathTolerance.encode(message.tolerances, writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GoToAndFaceTask {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGoToAndFaceTask();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.point = Point.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 17) {
            break;
          }

          message.heading = reader.double();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.tolerances = SpatialPathTolerance.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GoToAndFaceTask {
    return {
      point: isSet(object.point) ? Point.fromJSON(object.point) : undefined,
      heading: isSet(object.heading) ? globalThis.Number(object.heading) : 0,
      tolerances: isSet(object.tolerances) ? SpatialPathTolerance.fromJSON(object.tolerances) : undefined,
    };
  },

  toJSON(message: GoToAndFaceTask): unknown {
    const obj: any = {};
    if (message.point !== undefined) {
      obj.point = Point.toJSON(message.point);
    }
    if (message.heading !== 0) {
      obj.heading = message.heading;
    }
    if (message.tolerances !== undefined) {
      obj.tolerances = SpatialPathTolerance.toJSON(message.tolerances);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GoToAndFaceTask>, I>>(base?: I): GoToAndFaceTask {
    return GoToAndFaceTask.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GoToAndFaceTask>, I>>(object: I): GoToAndFaceTask {
    const message = createBaseGoToAndFaceTask();
    message.point = (object.point !== undefined && object.point !== null) ? Point.fromPartial(object.point) : undefined;
    message.heading = object.heading ?? 0;
    message.tolerances = (object.tolerances !== undefined && object.tolerances !== null)
      ? SpatialPathTolerance.fromPartial(object.tolerances)
      : undefined;
    return message;
  },
};

function createBaseMoveCenterPivotTask(): MoveCenterPivotTask {
  return { minHeading: 0, maxHeading: 0, pivotRange: undefined };
}

export const MoveCenterPivotTask: MessageFns<MoveCenterPivotTask> = {
  encode(message: MoveCenterPivotTask, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.minHeading !== 0) {
      writer.uint32(9).double(message.minHeading);
    }
    if (message.maxHeading !== 0) {
      writer.uint32(17).double(message.maxHeading);
    }
    if (message.pivotRange !== undefined) {
      CenterPivotRange.encode(message.pivotRange, writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): MoveCenterPivotTask {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMoveCenterPivotTask();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 9) {
            break;
          }

          message.minHeading = reader.double();
          continue;
        }
        case 2: {
          if (tag !== 17) {
            break;
          }

          message.maxHeading = reader.double();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.pivotRange = CenterPivotRange.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): MoveCenterPivotTask {
    return {
      minHeading: isSet(object.minHeading)
        ? globalThis.Number(object.minHeading)
        : isSet(object.min_heading)
        ? globalThis.Number(object.min_heading)
        : 0,
      maxHeading: isSet(object.maxHeading)
        ? globalThis.Number(object.maxHeading)
        : isSet(object.max_heading)
        ? globalThis.Number(object.max_heading)
        : 0,
      pivotRange: isSet(object.pivotRange)
        ? CenterPivotRange.fromJSON(object.pivotRange)
        : isSet(object.pivot_range)
        ? CenterPivotRange.fromJSON(object.pivot_range)
        : undefined,
    };
  },

  toJSON(message: MoveCenterPivotTask): unknown {
    const obj: any = {};
    if (message.minHeading !== 0) {
      obj.minHeading = message.minHeading;
    }
    if (message.maxHeading !== 0) {
      obj.maxHeading = message.maxHeading;
    }
    if (message.pivotRange !== undefined) {
      obj.pivotRange = CenterPivotRange.toJSON(message.pivotRange);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<MoveCenterPivotTask>, I>>(base?: I): MoveCenterPivotTask {
    return MoveCenterPivotTask.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<MoveCenterPivotTask>, I>>(object: I): MoveCenterPivotTask {
    const message = createBaseMoveCenterPivotTask();
    message.minHeading = object.minHeading ?? 0;
    message.maxHeading = object.maxHeading ?? 0;
    message.pivotRange = (object.pivotRange !== undefined && object.pivotRange !== null)
      ? CenterPivotRange.fromPartial(object.pivotRange)
      : undefined;
    return message;
  },
};

function createBaseVerifyCenterPivotTask(): VerifyCenterPivotTask {
  return { minHeading: 0, maxHeading: 0, pivotRange: undefined };
}

export const VerifyCenterPivotTask: MessageFns<VerifyCenterPivotTask> = {
  encode(message: VerifyCenterPivotTask, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.minHeading !== 0) {
      writer.uint32(9).double(message.minHeading);
    }
    if (message.maxHeading !== 0) {
      writer.uint32(17).double(message.maxHeading);
    }
    if (message.pivotRange !== undefined) {
      CenterPivotRange.encode(message.pivotRange, writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): VerifyCenterPivotTask {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseVerifyCenterPivotTask();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 9) {
            break;
          }

          message.minHeading = reader.double();
          continue;
        }
        case 2: {
          if (tag !== 17) {
            break;
          }

          message.maxHeading = reader.double();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.pivotRange = CenterPivotRange.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): VerifyCenterPivotTask {
    return {
      minHeading: isSet(object.minHeading)
        ? globalThis.Number(object.minHeading)
        : isSet(object.min_heading)
        ? globalThis.Number(object.min_heading)
        : 0,
      maxHeading: isSet(object.maxHeading)
        ? globalThis.Number(object.maxHeading)
        : isSet(object.max_heading)
        ? globalThis.Number(object.max_heading)
        : 0,
      pivotRange: isSet(object.pivotRange)
        ? CenterPivotRange.fromJSON(object.pivotRange)
        : isSet(object.pivot_range)
        ? CenterPivotRange.fromJSON(object.pivot_range)
        : undefined,
    };
  },

  toJSON(message: VerifyCenterPivotTask): unknown {
    const obj: any = {};
    if (message.minHeading !== 0) {
      obj.minHeading = message.minHeading;
    }
    if (message.maxHeading !== 0) {
      obj.maxHeading = message.maxHeading;
    }
    if (message.pivotRange !== undefined) {
      obj.pivotRange = CenterPivotRange.toJSON(message.pivotRange);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<VerifyCenterPivotTask>, I>>(base?: I): VerifyCenterPivotTask {
    return VerifyCenterPivotTask.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<VerifyCenterPivotTask>, I>>(object: I): VerifyCenterPivotTask {
    const message = createBaseVerifyCenterPivotTask();
    message.minHeading = object.minHeading ?? 0;
    message.maxHeading = object.maxHeading ?? 0;
    message.pivotRange = (object.pivotRange !== undefined && object.pivotRange !== null)
      ? CenterPivotRange.fromPartial(object.pivotRange)
      : undefined;
    return message;
  },
};

function createBaseGoToReversiblePathTask(): GoToReversiblePathTask {
  return {
    path: undefined,
    tolerances: undefined,
    guidePath: undefined,
    guidePathSpeed: undefined,
    guidePathStatus: 0,
    guidePathErrorDetails: "",
  };
}

export const GoToReversiblePathTask: MessageFns<GoToReversiblePathTask> = {
  encode(message: GoToReversiblePathTask, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.path !== undefined) {
      LineString.encode(message.path, writer.uint32(10).fork()).join();
    }
    if (message.tolerances !== undefined) {
      SpatialPathTolerance.encode(message.tolerances, writer.uint32(18).fork()).join();
    }
    if (message.guidePath !== undefined) {
      LineString.encode(message.guidePath, writer.uint32(26).fork()).join();
    }
    if (message.guidePathSpeed !== undefined) {
      SpeedSetting.encode(message.guidePathSpeed, writer.uint32(34).fork()).join();
    }
    if (message.guidePathStatus !== 0) {
      writer.uint32(40).int32(message.guidePathStatus);
    }
    if (message.guidePathErrorDetails !== "") {
      writer.uint32(50).string(message.guidePathErrorDetails);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GoToReversiblePathTask {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGoToReversiblePathTask();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.path = LineString.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.tolerances = SpatialPathTolerance.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.guidePath = LineString.decode(reader, reader.uint32());
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.guidePathSpeed = SpeedSetting.decode(reader, reader.uint32());
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.guidePathStatus = reader.int32() as any;
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.guidePathErrorDetails = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GoToReversiblePathTask {
    return {
      path: isSet(object.path) ? LineString.fromJSON(object.path) : undefined,
      tolerances: isSet(object.tolerances) ? SpatialPathTolerance.fromJSON(object.tolerances) : undefined,
      guidePath: isSet(object.guidePath)
        ? LineString.fromJSON(object.guidePath)
        : isSet(object.guide_path)
        ? LineString.fromJSON(object.guide_path)
        : undefined,
      guidePathSpeed: isSet(object.guidePathSpeed)
        ? SpeedSetting.fromJSON(object.guidePathSpeed)
        : isSet(object.guide_path_speed)
        ? SpeedSetting.fromJSON(object.guide_path_speed)
        : undefined,
      guidePathStatus: isSet(object.guidePathStatus)
        ? guidePathStatusFromJSON(object.guidePathStatus)
        : isSet(object.guide_path_status)
        ? guidePathStatusFromJSON(object.guide_path_status)
        : 0,
      guidePathErrorDetails: isSet(object.guidePathErrorDetails)
        ? globalThis.String(object.guidePathErrorDetails)
        : isSet(object.guide_path_error_details)
        ? globalThis.String(object.guide_path_error_details)
        : "",
    };
  },

  toJSON(message: GoToReversiblePathTask): unknown {
    const obj: any = {};
    if (message.path !== undefined) {
      obj.path = LineString.toJSON(message.path);
    }
    if (message.tolerances !== undefined) {
      obj.tolerances = SpatialPathTolerance.toJSON(message.tolerances);
    }
    if (message.guidePath !== undefined) {
      obj.guidePath = LineString.toJSON(message.guidePath);
    }
    if (message.guidePathSpeed !== undefined) {
      obj.guidePathSpeed = SpeedSetting.toJSON(message.guidePathSpeed);
    }
    if (message.guidePathStatus !== 0) {
      obj.guidePathStatus = guidePathStatusToJSON(message.guidePathStatus);
    }
    if (message.guidePathErrorDetails !== "") {
      obj.guidePathErrorDetails = message.guidePathErrorDetails;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GoToReversiblePathTask>, I>>(base?: I): GoToReversiblePathTask {
    return GoToReversiblePathTask.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GoToReversiblePathTask>, I>>(object: I): GoToReversiblePathTask {
    const message = createBaseGoToReversiblePathTask();
    message.path = (object.path !== undefined && object.path !== null)
      ? LineString.fromPartial(object.path)
      : undefined;
    message.tolerances = (object.tolerances !== undefined && object.tolerances !== null)
      ? SpatialPathTolerance.fromPartial(object.tolerances)
      : undefined;
    message.guidePath = (object.guidePath !== undefined && object.guidePath !== null)
      ? LineString.fromPartial(object.guidePath)
      : undefined;
    message.guidePathSpeed = (object.guidePathSpeed !== undefined && object.guidePathSpeed !== null)
      ? SpeedSetting.fromPartial(object.guidePathSpeed)
      : undefined;
    message.guidePathStatus = object.guidePathStatus ?? 0;
    message.guidePathErrorDetails = object.guidePathErrorDetails ?? "";
    return message;
  },
};

function createBaseFollowPathTask(): FollowPathTask {
  return {
    path: undefined,
    speed: undefined,
    tolerances: undefined,
    speedOnCompletionMph: undefined,
    completionSpeed: undefined,
    paths: [],
  };
}

export const FollowPathTask: MessageFns<FollowPathTask> = {
  encode(message: FollowPathTask, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.path !== undefined) {
      LineString.encode(message.path, writer.uint32(10).fork()).join();
    }
    if (message.speed !== undefined) {
      SpeedSetting.encode(message.speed, writer.uint32(18).fork()).join();
    }
    if (message.tolerances !== undefined) {
      SpatialPathTolerance.encode(message.tolerances, writer.uint32(34).fork()).join();
    }
    if (message.speedOnCompletionMph !== undefined) {
      writer.uint32(45).float(message.speedOnCompletionMph);
    }
    if (message.completionSpeed !== undefined) {
      SpeedSetting.encode(message.completionSpeed, writer.uint32(50).fork()).join();
    }
    for (const v of message.paths) {
      RigPointPath.encode(v!, writer.uint32(58).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): FollowPathTask {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseFollowPathTask();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.path = LineString.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.speed = SpeedSetting.decode(reader, reader.uint32());
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.tolerances = SpatialPathTolerance.decode(reader, reader.uint32());
          continue;
        }
        case 5: {
          if (tag !== 45) {
            break;
          }

          message.speedOnCompletionMph = reader.float();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.completionSpeed = SpeedSetting.decode(reader, reader.uint32());
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.paths.push(RigPointPath.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): FollowPathTask {
    return {
      path: isSet(object.path) ? LineString.fromJSON(object.path) : undefined,
      speed: isSet(object.speed) ? SpeedSetting.fromJSON(object.speed) : undefined,
      tolerances: isSet(object.tolerances) ? SpatialPathTolerance.fromJSON(object.tolerances) : undefined,
      speedOnCompletionMph: isSet(object.speedOnCompletionMph)
        ? globalThis.Number(object.speedOnCompletionMph)
        : isSet(object.speed_on_completion_mph)
        ? globalThis.Number(object.speed_on_completion_mph)
        : undefined,
      completionSpeed: isSet(object.completionSpeed)
        ? SpeedSetting.fromJSON(object.completionSpeed)
        : isSet(object.completion_speed)
        ? SpeedSetting.fromJSON(object.completion_speed)
        : undefined,
      paths: globalThis.Array.isArray(object?.paths) ? object.paths.map((e: any) => RigPointPath.fromJSON(e)) : [],
    };
  },

  toJSON(message: FollowPathTask): unknown {
    const obj: any = {};
    if (message.path !== undefined) {
      obj.path = LineString.toJSON(message.path);
    }
    if (message.speed !== undefined) {
      obj.speed = SpeedSetting.toJSON(message.speed);
    }
    if (message.tolerances !== undefined) {
      obj.tolerances = SpatialPathTolerance.toJSON(message.tolerances);
    }
    if (message.speedOnCompletionMph !== undefined) {
      obj.speedOnCompletionMph = message.speedOnCompletionMph;
    }
    if (message.completionSpeed !== undefined) {
      obj.completionSpeed = SpeedSetting.toJSON(message.completionSpeed);
    }
    if (message.paths?.length) {
      obj.paths = message.paths.map((e) => RigPointPath.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<FollowPathTask>, I>>(base?: I): FollowPathTask {
    return FollowPathTask.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<FollowPathTask>, I>>(object: I): FollowPathTask {
    const message = createBaseFollowPathTask();
    message.path = (object.path !== undefined && object.path !== null)
      ? LineString.fromPartial(object.path)
      : undefined;
    message.speed = (object.speed !== undefined && object.speed !== null)
      ? SpeedSetting.fromPartial(object.speed)
      : undefined;
    message.tolerances = (object.tolerances !== undefined && object.tolerances !== null)
      ? SpatialPathTolerance.fromPartial(object.tolerances)
      : undefined;
    message.speedOnCompletionMph = object.speedOnCompletionMph ?? undefined;
    message.completionSpeed = (object.completionSpeed !== undefined && object.completionSpeed !== null)
      ? SpeedSetting.fromPartial(object.completionSpeed)
      : undefined;
    message.paths = object.paths?.map((e) => RigPointPath.fromPartial(e)) || [];
    return message;
  },
};

function createBaseFollowFurrowTask(): FollowFurrowTask {
  return { path: undefined, speed: undefined, tolerances: undefined };
}

export const FollowFurrowTask: MessageFns<FollowFurrowTask> = {
  encode(message: FollowFurrowTask, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.path !== undefined) {
      LineString.encode(message.path, writer.uint32(10).fork()).join();
    }
    if (message.speed !== undefined) {
      SpeedSetting.encode(message.speed, writer.uint32(18).fork()).join();
    }
    if (message.tolerances !== undefined) {
      SpatialPathTolerance.encode(message.tolerances, writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): FollowFurrowTask {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseFollowFurrowTask();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.path = LineString.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.speed = SpeedSetting.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.tolerances = SpatialPathTolerance.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): FollowFurrowTask {
    return {
      path: isSet(object.path) ? LineString.fromJSON(object.path) : undefined,
      speed: isSet(object.speed) ? SpeedSetting.fromJSON(object.speed) : undefined,
      tolerances: isSet(object.tolerances) ? SpatialPathTolerance.fromJSON(object.tolerances) : undefined,
    };
  },

  toJSON(message: FollowFurrowTask): unknown {
    const obj: any = {};
    if (message.path !== undefined) {
      obj.path = LineString.toJSON(message.path);
    }
    if (message.speed !== undefined) {
      obj.speed = SpeedSetting.toJSON(message.speed);
    }
    if (message.tolerances !== undefined) {
      obj.tolerances = SpatialPathTolerance.toJSON(message.tolerances);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<FollowFurrowTask>, I>>(base?: I): FollowFurrowTask {
    return FollowFurrowTask.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<FollowFurrowTask>, I>>(object: I): FollowFurrowTask {
    const message = createBaseFollowFurrowTask();
    message.path = (object.path !== undefined && object.path !== null)
      ? LineString.fromPartial(object.path)
      : undefined;
    message.speed = (object.speed !== undefined && object.speed !== null)
      ? SpeedSetting.fromPartial(object.speed)
      : undefined;
    message.tolerances = (object.tolerances !== undefined && object.tolerances !== null)
      ? SpatialPathTolerance.fromPartial(object.tolerances)
      : undefined;
    return message;
  },
};

function createBaseGetOnPathTask(): GetOnPathTask {
  return { path: undefined, tolerances: undefined };
}

export const GetOnPathTask: MessageFns<GetOnPathTask> = {
  encode(message: GetOnPathTask, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.path !== undefined) {
      LineString.encode(message.path, writer.uint32(10).fork()).join();
    }
    if (message.tolerances !== undefined) {
      SpatialPathTolerance.encode(message.tolerances, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetOnPathTask {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetOnPathTask();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.path = LineString.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.tolerances = SpatialPathTolerance.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetOnPathTask {
    return {
      path: isSet(object.path) ? LineString.fromJSON(object.path) : undefined,
      tolerances: isSet(object.tolerances) ? SpatialPathTolerance.fromJSON(object.tolerances) : undefined,
    };
  },

  toJSON(message: GetOnPathTask): unknown {
    const obj: any = {};
    if (message.path !== undefined) {
      obj.path = LineString.toJSON(message.path);
    }
    if (message.tolerances !== undefined) {
      obj.tolerances = SpatialPathTolerance.toJSON(message.tolerances);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetOnPathTask>, I>>(base?: I): GetOnPathTask {
    return GetOnPathTask.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetOnPathTask>, I>>(object: I): GetOnPathTask {
    const message = createBaseGetOnPathTask();
    message.path = (object.path !== undefined && object.path !== null)
      ? LineString.fromPartial(object.path)
      : undefined;
    message.tolerances = (object.tolerances !== undefined && object.tolerances !== null)
      ? SpatialPathTolerance.fromPartial(object.tolerances)
      : undefined;
    return message;
  },
};

function createBaseSpeedSetting(): SpeedSetting {
  return { constantMph: 0, speedControl: 0, cfgDefinedSpeed: 0 };
}

export const SpeedSetting: MessageFns<SpeedSetting> = {
  encode(message: SpeedSetting, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.constantMph !== 0) {
      writer.uint32(9).double(message.constantMph);
    }
    if (message.speedControl !== 0) {
      writer.uint32(32).int32(message.speedControl);
    }
    if (message.cfgDefinedSpeed !== 0) {
      writer.uint32(40).int32(message.cfgDefinedSpeed);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SpeedSetting {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSpeedSetting();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 9) {
            break;
          }

          message.constantMph = reader.double();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.speedControl = reader.int32() as any;
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.cfgDefinedSpeed = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SpeedSetting {
    return {
      constantMph: isSet(object.constantMph)
        ? globalThis.Number(object.constantMph)
        : isSet(object.constant_mph)
        ? globalThis.Number(object.constant_mph)
        : 0,
      speedControl: isSet(object.speedControl)
        ? speedControlFromJSON(object.speedControl)
        : isSet(object.speed_control)
        ? speedControlFromJSON(object.speed_control)
        : 0,
      cfgDefinedSpeed: isSet(object.cfgDefinedSpeed)
        ? cfgDefinedSpeedNameFromJSON(object.cfgDefinedSpeed)
        : isSet(object.cfg_defined_speed)
        ? cfgDefinedSpeedNameFromJSON(object.cfg_defined_speed)
        : 0,
    };
  },

  toJSON(message: SpeedSetting): unknown {
    const obj: any = {};
    if (message.constantMph !== 0) {
      obj.constantMph = message.constantMph;
    }
    if (message.speedControl !== 0) {
      obj.speedControl = speedControlToJSON(message.speedControl);
    }
    if (message.cfgDefinedSpeed !== 0) {
      obj.cfgDefinedSpeed = cfgDefinedSpeedNameToJSON(message.cfgDefinedSpeed);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SpeedSetting>, I>>(base?: I): SpeedSetting {
    return SpeedSetting.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SpeedSetting>, I>>(object: I): SpeedSetting {
    const message = createBaseSpeedSetting();
    message.constantMph = object.constantMph ?? 0;
    message.speedControl = object.speedControl ?? 0;
    message.cfgDefinedSpeed = object.cfgDefinedSpeed ?? 0;
    return message;
  },
};

function createBaseSetTractorStateTask(): SetTractorStateTask {
  return { state: [], validate: false, expectedPosition: undefined };
}

export const SetTractorStateTask: MessageFns<SetTractorStateTask> = {
  encode(message: SetTractorStateTask, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.state) {
      TractorState.encode(v!, writer.uint32(10).fork()).join();
    }
    if (message.validate !== false) {
      writer.uint32(16).bool(message.validate);
    }
    if (message.expectedPosition !== undefined) {
      Point.encode(message.expectedPosition, writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SetTractorStateTask {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSetTractorStateTask();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.state.push(TractorState.decode(reader, reader.uint32()));
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.validate = reader.bool();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.expectedPosition = Point.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SetTractorStateTask {
    return {
      state: globalThis.Array.isArray(object?.state) ? object.state.map((e: any) => TractorState.fromJSON(e)) : [],
      validate: isSet(object.validate) ? globalThis.Boolean(object.validate) : false,
      expectedPosition: isSet(object.expectedPosition)
        ? Point.fromJSON(object.expectedPosition)
        : isSet(object.expected_position)
        ? Point.fromJSON(object.expected_position)
        : undefined,
    };
  },

  toJSON(message: SetTractorStateTask): unknown {
    const obj: any = {};
    if (message.state?.length) {
      obj.state = message.state.map((e) => TractorState.toJSON(e));
    }
    if (message.validate !== false) {
      obj.validate = message.validate;
    }
    if (message.expectedPosition !== undefined) {
      obj.expectedPosition = Point.toJSON(message.expectedPosition);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SetTractorStateTask>, I>>(base?: I): SetTractorStateTask {
    return SetTractorStateTask.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SetTractorStateTask>, I>>(object: I): SetTractorStateTask {
    const message = createBaseSetTractorStateTask();
    message.state = object.state?.map((e) => TractorState.fromPartial(e)) || [];
    message.validate = object.validate ?? false;
    message.expectedPosition = (object.expectedPosition !== undefined && object.expectedPosition !== null)
      ? Point.fromPartial(object.expectedPosition)
      : undefined;
    return message;
  },
};

function createBaseTractorState(): TractorState {
  return { gear: undefined, hitch: undefined, llImplementState: undefined };
}

export const TractorState: MessageFns<TractorState> = {
  encode(message: TractorState, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.gear !== undefined) {
      writer.uint32(8).int32(message.gear);
    }
    if (message.hitch !== undefined) {
      HitchState.encode(message.hitch, writer.uint32(18).fork()).join();
    }
    if (message.llImplementState !== undefined) {
      LLImpState.encode(message.llImplementState, writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TractorState {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTractorState();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.gear = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.hitch = HitchState.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.llImplementState = LLImpState.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TractorState {
    return {
      gear: isSet(object.gear) ? tractorState_GearFromJSON(object.gear) : undefined,
      hitch: isSet(object.hitch) ? HitchState.fromJSON(object.hitch) : undefined,
      llImplementState: isSet(object.llImplementState)
        ? LLImpState.fromJSON(object.llImplementState)
        : isSet(object.ll_implement_state)
        ? LLImpState.fromJSON(object.ll_implement_state)
        : undefined,
    };
  },

  toJSON(message: TractorState): unknown {
    const obj: any = {};
    if (message.gear !== undefined) {
      obj.gear = tractorState_GearToJSON(message.gear);
    }
    if (message.hitch !== undefined) {
      obj.hitch = HitchState.toJSON(message.hitch);
    }
    if (message.llImplementState !== undefined) {
      obj.llImplementState = LLImpState.toJSON(message.llImplementState);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<TractorState>, I>>(base?: I): TractorState {
    return TractorState.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TractorState>, I>>(object: I): TractorState {
    const message = createBaseTractorState();
    message.gear = object.gear ?? undefined;
    message.hitch = (object.hitch !== undefined && object.hitch !== null)
      ? HitchState.fromPartial(object.hitch)
      : undefined;
    message.llImplementState = (object.llImplementState !== undefined && object.llImplementState !== null)
      ? LLImpState.fromPartial(object.llImplementState)
      : undefined;
    return message;
  },
};

function createBaseHitchState(): HitchState {
  return { command: undefined, position: undefined };
}

export const HitchState: MessageFns<HitchState> = {
  encode(message: HitchState, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.command !== undefined) {
      writer.uint32(8).int32(message.command);
    }
    if (message.position !== undefined) {
      writer.uint32(17).double(message.position);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): HitchState {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseHitchState();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.command = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 17) {
            break;
          }

          message.position = reader.double();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): HitchState {
    return {
      command: isSet(object.command) ? hitchState_HitchCommandFromJSON(object.command) : undefined,
      position: isSet(object.position) ? globalThis.Number(object.position) : undefined,
    };
  },

  toJSON(message: HitchState): unknown {
    const obj: any = {};
    if (message.command !== undefined) {
      obj.command = hitchState_HitchCommandToJSON(message.command);
    }
    if (message.position !== undefined) {
      obj.position = message.position;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<HitchState>, I>>(base?: I): HitchState {
    return HitchState.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<HitchState>, I>>(object: I): HitchState {
    const message = createBaseHitchState();
    message.command = object.command ?? undefined;
    message.position = object.position ?? undefined;
    return message;
  },
};

function createBaseLLImpState(): LLImpState {
  return { lifted: undefined, lowered: undefined };
}

export const LLImpState: MessageFns<LLImpState> = {
  encode(message: LLImpState, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.lifted !== undefined) {
      Empty.encode(message.lifted, writer.uint32(10).fork()).join();
    }
    if (message.lowered !== undefined) {
      Empty.encode(message.lowered, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): LLImpState {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseLLImpState();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.lifted = Empty.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.lowered = Empty.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): LLImpState {
    return {
      lifted: isSet(object.lifted) ? Empty.fromJSON(object.lifted) : undefined,
      lowered: isSet(object.lowered) ? Empty.fromJSON(object.lowered) : undefined,
    };
  },

  toJSON(message: LLImpState): unknown {
    const obj: any = {};
    if (message.lifted !== undefined) {
      obj.lifted = Empty.toJSON(message.lifted);
    }
    if (message.lowered !== undefined) {
      obj.lowered = Empty.toJSON(message.lowered);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<LLImpState>, I>>(base?: I): LLImpState {
    return LLImpState.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<LLImpState>, I>>(object: I): LLImpState {
    const message = createBaseLLImpState();
    message.lifted = (object.lifted !== undefined && object.lifted !== null)
      ? Empty.fromPartial(object.lifted)
      : undefined;
    message.lowered = (object.lowered !== undefined && object.lowered !== null)
      ? Empty.fromPartial(object.lowered)
      : undefined;
    return message;
  },
};

function createBaseTaskList(): TaskList {
  return { tasks: [] };
}

export const TaskList: MessageFns<TaskList> = {
  encode(message: TaskList, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.tasks) {
      Task.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TaskList {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTaskList();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.tasks.push(Task.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TaskList {
    return { tasks: globalThis.Array.isArray(object?.tasks) ? object.tasks.map((e: any) => Task.fromJSON(e)) : [] };
  },

  toJSON(message: TaskList): unknown {
    const obj: any = {};
    if (message.tasks?.length) {
      obj.tasks = message.tasks.map((e) => Task.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<TaskList>, I>>(base?: I): TaskList {
    return TaskList.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TaskList>, I>>(object: I): TaskList {
    const message = createBaseTaskList();
    message.tasks = object.tasks?.map((e) => Task.fromPartial(e)) || [];
    return message;
  },
};

function createBaseListTasksResponse(): ListTasksResponse {
  return { pageToken: "", tasks: [] };
}

export const ListTasksResponse: MessageFns<ListTasksResponse> = {
  encode(message: ListTasksResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.pageToken !== "") {
      writer.uint32(10).string(message.pageToken);
    }
    for (const v of message.tasks) {
      Task.encode(v!, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ListTasksResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseListTasksResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.pageToken = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.tasks.push(Task.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ListTasksResponse {
    return {
      pageToken: isSet(object.pageToken)
        ? globalThis.String(object.pageToken)
        : isSet(object.page_token)
        ? globalThis.String(object.page_token)
        : "",
      tasks: globalThis.Array.isArray(object?.tasks) ? object.tasks.map((e: any) => Task.fromJSON(e)) : [],
    };
  },

  toJSON(message: ListTasksResponse): unknown {
    const obj: any = {};
    if (message.pageToken !== "") {
      obj.pageToken = message.pageToken;
    }
    if (message.tasks?.length) {
      obj.tasks = message.tasks.map((e) => Task.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ListTasksResponse>, I>>(base?: I): ListTasksResponse {
    return ListTasksResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ListTasksResponse>, I>>(object: I): ListTasksResponse {
    const message = createBaseListTasksResponse();
    message.pageToken = object.pageToken ?? "";
    message.tasks = object.tasks?.map((e) => Task.fromPartial(e)) || [];
    return message;
  },
};

function createBaseSpatialPathTolerance(): SpatialPathTolerance {
  return { heading: 0, crosstrack: 0, distance: 0, continuousCrosstrack: 0 };
}

export const SpatialPathTolerance: MessageFns<SpatialPathTolerance> = {
  encode(message: SpatialPathTolerance, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.heading !== 0) {
      writer.uint32(13).float(message.heading);
    }
    if (message.crosstrack !== 0) {
      writer.uint32(21).float(message.crosstrack);
    }
    if (message.distance !== 0) {
      writer.uint32(29).float(message.distance);
    }
    if (message.continuousCrosstrack !== 0) {
      writer.uint32(37).float(message.continuousCrosstrack);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SpatialPathTolerance {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSpatialPathTolerance();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 13) {
            break;
          }

          message.heading = reader.float();
          continue;
        }
        case 2: {
          if (tag !== 21) {
            break;
          }

          message.crosstrack = reader.float();
          continue;
        }
        case 3: {
          if (tag !== 29) {
            break;
          }

          message.distance = reader.float();
          continue;
        }
        case 4: {
          if (tag !== 37) {
            break;
          }

          message.continuousCrosstrack = reader.float();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SpatialPathTolerance {
    return {
      heading: isSet(object.heading) ? globalThis.Number(object.heading) : 0,
      crosstrack: isSet(object.crosstrack) ? globalThis.Number(object.crosstrack) : 0,
      distance: isSet(object.distance) ? globalThis.Number(object.distance) : 0,
      continuousCrosstrack: isSet(object.continuousCrosstrack)
        ? globalThis.Number(object.continuousCrosstrack)
        : isSet(object.continuous_crosstrack)
        ? globalThis.Number(object.continuous_crosstrack)
        : 0,
    };
  },

  toJSON(message: SpatialPathTolerance): unknown {
    const obj: any = {};
    if (message.heading !== 0) {
      obj.heading = message.heading;
    }
    if (message.crosstrack !== 0) {
      obj.crosstrack = message.crosstrack;
    }
    if (message.distance !== 0) {
      obj.distance = message.distance;
    }
    if (message.continuousCrosstrack !== 0) {
      obj.continuousCrosstrack = message.continuousCrosstrack;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SpatialPathTolerance>, I>>(base?: I): SpatialPathTolerance {
    return SpatialPathTolerance.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SpatialPathTolerance>, I>>(object: I): SpatialPathTolerance {
    const message = createBaseSpatialPathTolerance();
    message.heading = object.heading ?? 0;
    message.crosstrack = object.crosstrack ?? 0;
    message.distance = object.distance ?? 0;
    message.continuousCrosstrack = object.continuousCrosstrack ?? 0;
    return message;
  },
};

function createBaseJob(): Job {
  return {
    id: 0,
    name: "",
    createdAt: undefined,
    startedAt: undefined,
    updatedAt: undefined,
    endedAt: undefined,
    objectives: [],
    state: 0,
    type: 0,
    workOrderId: undefined,
    farmId: "",
    fieldId: "",
    acreage: 0,
    customerId: "",
    priority: 0,
    robotWhitelist: undefined,
    progressPercent: 0,
    estCompletionAt: undefined,
    dryRun: false,
    creationFailed: false,
    creationError: "",
    config: undefined,
    createdBy: "",
    updatedBy: "",
    activityTypes: [],
    pathPlannerSource: undefined,
    pathPlannerVersion: undefined,
  };
}

export const Job: MessageFns<Job> = {
  encode(message: Job, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== 0) {
      writer.uint32(8).uint64(message.id);
    }
    if (message.name !== "") {
      writer.uint32(18).string(message.name);
    }
    if (message.createdAt !== undefined) {
      Timestamp.encode(toTimestamp(message.createdAt), writer.uint32(114).fork()).join();
    }
    if (message.startedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.startedAt), writer.uint32(26).fork()).join();
    }
    if (message.updatedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.updatedAt), writer.uint32(122).fork()).join();
    }
    if (message.endedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.endedAt), writer.uint32(34).fork()).join();
    }
    for (const v of message.objectives) {
      Objective.encode(v!, writer.uint32(42).fork()).join();
    }
    if (message.state !== 0) {
      writer.uint32(48).int32(message.state);
    }
    if (message.type !== 0) {
      writer.uint32(56).int32(message.type);
    }
    if (message.workOrderId !== undefined) {
      writer.uint32(64).uint64(message.workOrderId);
    }
    if (message.farmId !== "") {
      writer.uint32(74).string(message.farmId);
    }
    if (message.fieldId !== "") {
      writer.uint32(82).string(message.fieldId);
    }
    if (message.acreage !== 0) {
      writer.uint32(173).float(message.acreage);
    }
    if (message.customerId !== "") {
      writer.uint32(90).string(message.customerId);
    }
    if (message.priority !== 0) {
      writer.uint32(96).int32(message.priority);
    }
    if (message.robotWhitelist !== undefined) {
      RobotWhitelist.encode(message.robotWhitelist, writer.uint32(106).fork()).join();
    }
    if (message.progressPercent !== 0) {
      writer.uint32(128).int32(message.progressPercent);
    }
    if (message.estCompletionAt !== undefined) {
      Timestamp.encode(toTimestamp(message.estCompletionAt), writer.uint32(178).fork()).join();
    }
    if (message.dryRun !== false) {
      writer.uint32(136).bool(message.dryRun);
    }
    if (message.creationFailed !== false) {
      writer.uint32(144).bool(message.creationFailed);
    }
    if (message.creationError !== "") {
      writer.uint32(154).string(message.creationError);
    }
    if (message.config !== undefined) {
      JobConfiguration.encode(message.config, writer.uint32(162).fork()).join();
    }
    if (message.createdBy !== "") {
      writer.uint32(186).string(message.createdBy);
    }
    if (message.updatedBy !== "") {
      writer.uint32(194).string(message.updatedBy);
    }
    writer.uint32(202).fork();
    for (const v of message.activityTypes) {
      writer.int32(v);
    }
    writer.join();
    if (message.pathPlannerSource !== undefined) {
      writer.uint32(210).string(message.pathPlannerSource);
    }
    if (message.pathPlannerVersion !== undefined) {
      writer.uint32(218).string(message.pathPlannerVersion);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Job {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseJob();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.id = longToNumber(reader.uint64());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 14: {
          if (tag !== 114) {
            break;
          }

          message.createdAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.startedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 15: {
          if (tag !== 122) {
            break;
          }

          message.updatedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.endedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.objectives.push(Objective.decode(reader, reader.uint32()));
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.state = reader.int32() as any;
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.type = reader.int32() as any;
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.workOrderId = longToNumber(reader.uint64());
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.farmId = reader.string();
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.fieldId = reader.string();
          continue;
        }
        case 21: {
          if (tag !== 173) {
            break;
          }

          message.acreage = reader.float();
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.customerId = reader.string();
          continue;
        }
        case 12: {
          if (tag !== 96) {
            break;
          }

          message.priority = reader.int32();
          continue;
        }
        case 13: {
          if (tag !== 106) {
            break;
          }

          message.robotWhitelist = RobotWhitelist.decode(reader, reader.uint32());
          continue;
        }
        case 16: {
          if (tag !== 128) {
            break;
          }

          message.progressPercent = reader.int32();
          continue;
        }
        case 22: {
          if (tag !== 178) {
            break;
          }

          message.estCompletionAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 17: {
          if (tag !== 136) {
            break;
          }

          message.dryRun = reader.bool();
          continue;
        }
        case 18: {
          if (tag !== 144) {
            break;
          }

          message.creationFailed = reader.bool();
          continue;
        }
        case 19: {
          if (tag !== 154) {
            break;
          }

          message.creationError = reader.string();
          continue;
        }
        case 20: {
          if (tag !== 162) {
            break;
          }

          message.config = JobConfiguration.decode(reader, reader.uint32());
          continue;
        }
        case 23: {
          if (tag !== 186) {
            break;
          }

          message.createdBy = reader.string();
          continue;
        }
        case 24: {
          if (tag !== 194) {
            break;
          }

          message.updatedBy = reader.string();
          continue;
        }
        case 25: {
          if (tag === 200) {
            message.activityTypes.push(reader.int32() as any);

            continue;
          }

          if (tag === 202) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.activityTypes.push(reader.int32() as any);
            }

            continue;
          }

          break;
        }
        case 26: {
          if (tag !== 210) {
            break;
          }

          message.pathPlannerSource = reader.string();
          continue;
        }
        case 27: {
          if (tag !== 218) {
            break;
          }

          message.pathPlannerVersion = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Job {
    return {
      id: isSet(object.id) ? globalThis.Number(object.id) : 0,
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      createdAt: isSet(object.createdAt)
        ? globalThis.String(object.createdAt)
        : isSet(object.created_at)
        ? globalThis.String(object.created_at)
        : undefined,
      startedAt: isSet(object.startedAt)
        ? globalThis.String(object.startedAt)
        : isSet(object.started_at)
        ? globalThis.String(object.started_at)
        : undefined,
      updatedAt: isSet(object.updatedAt)
        ? globalThis.String(object.updatedAt)
        : isSet(object.updated_at)
        ? globalThis.String(object.updated_at)
        : undefined,
      endedAt: isSet(object.endedAt)
        ? globalThis.String(object.endedAt)
        : isSet(object.ended_at)
        ? globalThis.String(object.ended_at)
        : undefined,
      objectives: globalThis.Array.isArray(object?.objectives)
        ? object.objectives.map((e: any) => Objective.fromJSON(e))
        : [],
      state: isSet(object.state) ? stateFromJSON(object.state) : 0,
      type: isSet(object.type) ? jobTypeFromJSON(object.type) : 0,
      workOrderId: isSet(object.workOrderId)
        ? globalThis.Number(object.workOrderId)
        : isSet(object.work_order_id)
        ? globalThis.Number(object.work_order_id)
        : undefined,
      farmId: isSet(object.farmId)
        ? globalThis.String(object.farmId)
        : isSet(object.farm_id)
        ? globalThis.String(object.farm_id)
        : "",
      fieldId: isSet(object.fieldId)
        ? globalThis.String(object.fieldId)
        : isSet(object.field_id)
        ? globalThis.String(object.field_id)
        : "",
      acreage: isSet(object.acreage) ? globalThis.Number(object.acreage) : 0,
      customerId: isSet(object.customerId)
        ? globalThis.String(object.customerId)
        : isSet(object.customer_id)
        ? globalThis.String(object.customer_id)
        : "",
      priority: isSet(object.priority) ? globalThis.Number(object.priority) : 0,
      robotWhitelist: isSet(object.robotWhitelist)
        ? RobotWhitelist.fromJSON(object.robotWhitelist)
        : isSet(object.robot_whitelist)
        ? RobotWhitelist.fromJSON(object.robot_whitelist)
        : undefined,
      progressPercent: isSet(object.progressPercent)
        ? globalThis.Number(object.progressPercent)
        : isSet(object.progress_percent)
        ? globalThis.Number(object.progress_percent)
        : 0,
      estCompletionAt: isSet(object.estCompletionAt)
        ? globalThis.String(object.estCompletionAt)
        : isSet(object.est_completion_at)
        ? globalThis.String(object.est_completion_at)
        : undefined,
      dryRun: isSet(object.dryRun)
        ? globalThis.Boolean(object.dryRun)
        : isSet(object.dry_run)
        ? globalThis.Boolean(object.dry_run)
        : false,
      creationFailed: isSet(object.creationFailed)
        ? globalThis.Boolean(object.creationFailed)
        : isSet(object.creation_failed)
        ? globalThis.Boolean(object.creation_failed)
        : false,
      creationError: isSet(object.creationError)
        ? globalThis.String(object.creationError)
        : isSet(object.creation_error)
        ? globalThis.String(object.creation_error)
        : "",
      config: isSet(object.config) ? JobConfiguration.fromJSON(object.config) : undefined,
      createdBy: isSet(object.createdBy)
        ? globalThis.String(object.createdBy)
        : isSet(object.created_by)
        ? globalThis.String(object.created_by)
        : "",
      updatedBy: isSet(object.updatedBy)
        ? globalThis.String(object.updatedBy)
        : isSet(object.updated_by)
        ? globalThis.String(object.updated_by)
        : "",
      activityTypes: globalThis.Array.isArray(object?.activityTypes)
        ? object.activityTypes.map((e: any) => autonomousActivityTypeFromJSON(e))
        : globalThis.Array.isArray(object?.activity_types)
        ? object.activity_types.map((e: any) => autonomousActivityTypeFromJSON(e))
        : [],
      pathPlannerSource: isSet(object.pathPlannerSource)
        ? globalThis.String(object.pathPlannerSource)
        : isSet(object.path_planner_source)
        ? globalThis.String(object.path_planner_source)
        : undefined,
      pathPlannerVersion: isSet(object.pathPlannerVersion)
        ? globalThis.String(object.pathPlannerVersion)
        : isSet(object.path_planner_version)
        ? globalThis.String(object.path_planner_version)
        : undefined,
    };
  },

  toJSON(message: Job): unknown {
    const obj: any = {};
    if (message.id !== 0) {
      obj.id = Math.round(message.id);
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.createdAt !== undefined) {
      obj.createdAt = message.createdAt;
    }
    if (message.startedAt !== undefined) {
      obj.startedAt = message.startedAt;
    }
    if (message.updatedAt !== undefined) {
      obj.updatedAt = message.updatedAt;
    }
    if (message.endedAt !== undefined) {
      obj.endedAt = message.endedAt;
    }
    if (message.objectives?.length) {
      obj.objectives = message.objectives.map((e) => Objective.toJSON(e));
    }
    if (message.state !== 0) {
      obj.state = stateToJSON(message.state);
    }
    if (message.type !== 0) {
      obj.type = jobTypeToJSON(message.type);
    }
    if (message.workOrderId !== undefined) {
      obj.workOrderId = Math.round(message.workOrderId);
    }
    if (message.farmId !== "") {
      obj.farmId = message.farmId;
    }
    if (message.fieldId !== "") {
      obj.fieldId = message.fieldId;
    }
    if (message.acreage !== 0) {
      obj.acreage = message.acreage;
    }
    if (message.customerId !== "") {
      obj.customerId = message.customerId;
    }
    if (message.priority !== 0) {
      obj.priority = Math.round(message.priority);
    }
    if (message.robotWhitelist !== undefined) {
      obj.robotWhitelist = RobotWhitelist.toJSON(message.robotWhitelist);
    }
    if (message.progressPercent !== 0) {
      obj.progressPercent = Math.round(message.progressPercent);
    }
    if (message.estCompletionAt !== undefined) {
      obj.estCompletionAt = message.estCompletionAt;
    }
    if (message.dryRun !== false) {
      obj.dryRun = message.dryRun;
    }
    if (message.creationFailed !== false) {
      obj.creationFailed = message.creationFailed;
    }
    if (message.creationError !== "") {
      obj.creationError = message.creationError;
    }
    if (message.config !== undefined) {
      obj.config = JobConfiguration.toJSON(message.config);
    }
    if (message.createdBy !== "") {
      obj.createdBy = message.createdBy;
    }
    if (message.updatedBy !== "") {
      obj.updatedBy = message.updatedBy;
    }
    if (message.activityTypes?.length) {
      obj.activityTypes = message.activityTypes.map((e) => autonomousActivityTypeToJSON(e));
    }
    if (message.pathPlannerSource !== undefined) {
      obj.pathPlannerSource = message.pathPlannerSource;
    }
    if (message.pathPlannerVersion !== undefined) {
      obj.pathPlannerVersion = message.pathPlannerVersion;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Job>, I>>(base?: I): Job {
    return Job.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Job>, I>>(object: I): Job {
    const message = createBaseJob();
    message.id = object.id ?? 0;
    message.name = object.name ?? "";
    message.createdAt = object.createdAt ?? undefined;
    message.startedAt = object.startedAt ?? undefined;
    message.updatedAt = object.updatedAt ?? undefined;
    message.endedAt = object.endedAt ?? undefined;
    message.objectives = object.objectives?.map((e) => Objective.fromPartial(e)) || [];
    message.state = object.state ?? 0;
    message.type = object.type ?? 0;
    message.workOrderId = object.workOrderId ?? undefined;
    message.farmId = object.farmId ?? "";
    message.fieldId = object.fieldId ?? "";
    message.acreage = object.acreage ?? 0;
    message.customerId = object.customerId ?? "";
    message.priority = object.priority ?? 0;
    message.robotWhitelist = (object.robotWhitelist !== undefined && object.robotWhitelist !== null)
      ? RobotWhitelist.fromPartial(object.robotWhitelist)
      : undefined;
    message.progressPercent = object.progressPercent ?? 0;
    message.estCompletionAt = object.estCompletionAt ?? undefined;
    message.dryRun = object.dryRun ?? false;
    message.creationFailed = object.creationFailed ?? false;
    message.creationError = object.creationError ?? "";
    message.config = (object.config !== undefined && object.config !== null)
      ? JobConfiguration.fromPartial(object.config)
      : undefined;
    message.createdBy = object.createdBy ?? "";
    message.updatedBy = object.updatedBy ?? "";
    message.activityTypes = object.activityTypes?.map((e) => e) || [];
    message.pathPlannerSource = object.pathPlannerSource ?? undefined;
    message.pathPlannerVersion = object.pathPlannerVersion ?? undefined;
    return message;
  },
};

function createBaseJobPathPlannerMetadata(): JobPathPlannerMetadata {
  return { jobId: 0, metadata: undefined, metadataFormat: 0 };
}

export const JobPathPlannerMetadata: MessageFns<JobPathPlannerMetadata> = {
  encode(message: JobPathPlannerMetadata, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.jobId !== 0) {
      writer.uint32(8).uint64(message.jobId);
    }
    if (message.metadata !== undefined) {
      Struct.encode(Struct.wrap(message.metadata), writer.uint32(18).fork()).join();
    }
    if (message.metadataFormat !== 0) {
      writer.uint32(24).int32(message.metadataFormat);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): JobPathPlannerMetadata {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseJobPathPlannerMetadata();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.jobId = longToNumber(reader.uint64());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.metadata = Struct.unwrap(Struct.decode(reader, reader.uint32()));
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.metadataFormat = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): JobPathPlannerMetadata {
    return {
      jobId: isSet(object.jobId)
        ? globalThis.Number(object.jobId)
        : isSet(object.job_id)
        ? globalThis.Number(object.job_id)
        : 0,
      metadata: isObject(object.metadata) ? object.metadata : undefined,
      metadataFormat: isSet(object.metadataFormat)
        ? pathPlannerMetadataFormatFromJSON(object.metadataFormat)
        : isSet(object.metadata_format)
        ? pathPlannerMetadataFormatFromJSON(object.metadata_format)
        : 0,
    };
  },

  toJSON(message: JobPathPlannerMetadata): unknown {
    const obj: any = {};
    if (message.jobId !== 0) {
      obj.jobId = Math.round(message.jobId);
    }
    if (message.metadata !== undefined) {
      obj.metadata = message.metadata;
    }
    if (message.metadataFormat !== 0) {
      obj.metadataFormat = pathPlannerMetadataFormatToJSON(message.metadataFormat);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<JobPathPlannerMetadata>, I>>(base?: I): JobPathPlannerMetadata {
    return JobPathPlannerMetadata.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<JobPathPlannerMetadata>, I>>(object: I): JobPathPlannerMetadata {
    const message = createBaseJobPathPlannerMetadata();
    message.jobId = object.jobId ?? 0;
    message.metadata = object.metadata ?? undefined;
    message.metadataFormat = object.metadataFormat ?? 0;
    return message;
  },
};

function createBaseJobMetrics(): JobMetrics {
  return {
    jobId: 0,
    updatedAt: undefined,
    readyAt: undefined,
    startedAt: undefined,
    endedAt: undefined,
    totalTime: undefined,
    waitingTime: undefined,
    activeTime: undefined,
    numRobots: 0,
    workingTime: undefined,
    workingTimeManual: undefined,
    workingTimeAuto: undefined,
    idleTime: undefined,
    avgWorkingTime: undefined,
    avgWorkingTimeManual: undefined,
    avgWorkingTimeAuto: undefined,
    avgIdleTime: undefined,
    avgWorkingTimePercent: 0,
    avgWorkingTimeManualPercent: 0,
    avgWorkingTimeAutoPercent: 0,
    avgActiveTimeManualPercent: 0,
    avgActiveTimeAutoPercent: 0,
    avgIdleTimePercent: 0,
    totalInterventions: 0,
    ivsPerActiveHour: 0,
    ivsPerAutoHour: 0,
    totalIvTime: undefined,
    ivWaitingTime: undefined,
    ivHandlingTime: undefined,
    avgIvTime: undefined,
    avgIvWaitingTime: undefined,
    avgIvHandlingTime: undefined,
    avgIvTimePercent: 0,
    avgIvWaitingTimePercent: 0,
    avgIvHandlingTimePercent: 0,
    progressPercent: 0,
    totalAcres: 0,
    completedAcres: 0,
    acresPerActiveHour: 0,
    estCompletionAt: undefined,
  };
}

export const JobMetrics: MessageFns<JobMetrics> = {
  encode(message: JobMetrics, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.jobId !== 0) {
      writer.uint32(8).uint64(message.jobId);
    }
    if (message.updatedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.updatedAt), writer.uint32(18).fork()).join();
    }
    if (message.readyAt !== undefined) {
      Timestamp.encode(toTimestamp(message.readyAt), writer.uint32(26).fork()).join();
    }
    if (message.startedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.startedAt), writer.uint32(34).fork()).join();
    }
    if (message.endedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.endedAt), writer.uint32(42).fork()).join();
    }
    if (message.totalTime !== undefined) {
      Duration.encode(message.totalTime, writer.uint32(50).fork()).join();
    }
    if (message.waitingTime !== undefined) {
      Duration.encode(message.waitingTime, writer.uint32(58).fork()).join();
    }
    if (message.activeTime !== undefined) {
      Duration.encode(message.activeTime, writer.uint32(66).fork()).join();
    }
    if (message.numRobots !== 0) {
      writer.uint32(72).uint32(message.numRobots);
    }
    if (message.workingTime !== undefined) {
      Duration.encode(message.workingTime, writer.uint32(82).fork()).join();
    }
    if (message.workingTimeManual !== undefined) {
      Duration.encode(message.workingTimeManual, writer.uint32(90).fork()).join();
    }
    if (message.workingTimeAuto !== undefined) {
      Duration.encode(message.workingTimeAuto, writer.uint32(98).fork()).join();
    }
    if (message.idleTime !== undefined) {
      Duration.encode(message.idleTime, writer.uint32(106).fork()).join();
    }
    if (message.avgWorkingTime !== undefined) {
      Duration.encode(message.avgWorkingTime, writer.uint32(114).fork()).join();
    }
    if (message.avgWorkingTimeManual !== undefined) {
      Duration.encode(message.avgWorkingTimeManual, writer.uint32(122).fork()).join();
    }
    if (message.avgWorkingTimeAuto !== undefined) {
      Duration.encode(message.avgWorkingTimeAuto, writer.uint32(130).fork()).join();
    }
    if (message.avgIdleTime !== undefined) {
      Duration.encode(message.avgIdleTime, writer.uint32(138).fork()).join();
    }
    if (message.avgWorkingTimePercent !== 0) {
      writer.uint32(149).float(message.avgWorkingTimePercent);
    }
    if (message.avgWorkingTimeManualPercent !== 0) {
      writer.uint32(157).float(message.avgWorkingTimeManualPercent);
    }
    if (message.avgWorkingTimeAutoPercent !== 0) {
      writer.uint32(165).float(message.avgWorkingTimeAutoPercent);
    }
    if (message.avgActiveTimeManualPercent !== 0) {
      writer.uint32(173).float(message.avgActiveTimeManualPercent);
    }
    if (message.avgActiveTimeAutoPercent !== 0) {
      writer.uint32(181).float(message.avgActiveTimeAutoPercent);
    }
    if (message.avgIdleTimePercent !== 0) {
      writer.uint32(189).float(message.avgIdleTimePercent);
    }
    if (message.totalInterventions !== 0) {
      writer.uint32(192).uint32(message.totalInterventions);
    }
    if (message.ivsPerActiveHour !== 0) {
      writer.uint32(205).float(message.ivsPerActiveHour);
    }
    if (message.ivsPerAutoHour !== 0) {
      writer.uint32(213).float(message.ivsPerAutoHour);
    }
    if (message.totalIvTime !== undefined) {
      Duration.encode(message.totalIvTime, writer.uint32(218).fork()).join();
    }
    if (message.ivWaitingTime !== undefined) {
      Duration.encode(message.ivWaitingTime, writer.uint32(226).fork()).join();
    }
    if (message.ivHandlingTime !== undefined) {
      Duration.encode(message.ivHandlingTime, writer.uint32(234).fork()).join();
    }
    if (message.avgIvTime !== undefined) {
      Duration.encode(message.avgIvTime, writer.uint32(242).fork()).join();
    }
    if (message.avgIvWaitingTime !== undefined) {
      Duration.encode(message.avgIvWaitingTime, writer.uint32(250).fork()).join();
    }
    if (message.avgIvHandlingTime !== undefined) {
      Duration.encode(message.avgIvHandlingTime, writer.uint32(258).fork()).join();
    }
    if (message.avgIvTimePercent !== 0) {
      writer.uint32(269).float(message.avgIvTimePercent);
    }
    if (message.avgIvWaitingTimePercent !== 0) {
      writer.uint32(277).float(message.avgIvWaitingTimePercent);
    }
    if (message.avgIvHandlingTimePercent !== 0) {
      writer.uint32(285).float(message.avgIvHandlingTimePercent);
    }
    if (message.progressPercent !== 0) {
      writer.uint32(288).uint32(message.progressPercent);
    }
    if (message.totalAcres !== 0) {
      writer.uint32(301).float(message.totalAcres);
    }
    if (message.completedAcres !== 0) {
      writer.uint32(309).float(message.completedAcres);
    }
    if (message.acresPerActiveHour !== 0) {
      writer.uint32(317).float(message.acresPerActiveHour);
    }
    if (message.estCompletionAt !== undefined) {
      Timestamp.encode(toTimestamp(message.estCompletionAt), writer.uint32(322).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): JobMetrics {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseJobMetrics();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.jobId = longToNumber(reader.uint64());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.updatedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.readyAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.startedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.endedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.totalTime = Duration.decode(reader, reader.uint32());
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.waitingTime = Duration.decode(reader, reader.uint32());
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.activeTime = Duration.decode(reader, reader.uint32());
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.numRobots = reader.uint32();
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.workingTime = Duration.decode(reader, reader.uint32());
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.workingTimeManual = Duration.decode(reader, reader.uint32());
          continue;
        }
        case 12: {
          if (tag !== 98) {
            break;
          }

          message.workingTimeAuto = Duration.decode(reader, reader.uint32());
          continue;
        }
        case 13: {
          if (tag !== 106) {
            break;
          }

          message.idleTime = Duration.decode(reader, reader.uint32());
          continue;
        }
        case 14: {
          if (tag !== 114) {
            break;
          }

          message.avgWorkingTime = Duration.decode(reader, reader.uint32());
          continue;
        }
        case 15: {
          if (tag !== 122) {
            break;
          }

          message.avgWorkingTimeManual = Duration.decode(reader, reader.uint32());
          continue;
        }
        case 16: {
          if (tag !== 130) {
            break;
          }

          message.avgWorkingTimeAuto = Duration.decode(reader, reader.uint32());
          continue;
        }
        case 17: {
          if (tag !== 138) {
            break;
          }

          message.avgIdleTime = Duration.decode(reader, reader.uint32());
          continue;
        }
        case 18: {
          if (tag !== 149) {
            break;
          }

          message.avgWorkingTimePercent = reader.float();
          continue;
        }
        case 19: {
          if (tag !== 157) {
            break;
          }

          message.avgWorkingTimeManualPercent = reader.float();
          continue;
        }
        case 20: {
          if (tag !== 165) {
            break;
          }

          message.avgWorkingTimeAutoPercent = reader.float();
          continue;
        }
        case 21: {
          if (tag !== 173) {
            break;
          }

          message.avgActiveTimeManualPercent = reader.float();
          continue;
        }
        case 22: {
          if (tag !== 181) {
            break;
          }

          message.avgActiveTimeAutoPercent = reader.float();
          continue;
        }
        case 23: {
          if (tag !== 189) {
            break;
          }

          message.avgIdleTimePercent = reader.float();
          continue;
        }
        case 24: {
          if (tag !== 192) {
            break;
          }

          message.totalInterventions = reader.uint32();
          continue;
        }
        case 25: {
          if (tag !== 205) {
            break;
          }

          message.ivsPerActiveHour = reader.float();
          continue;
        }
        case 26: {
          if (tag !== 213) {
            break;
          }

          message.ivsPerAutoHour = reader.float();
          continue;
        }
        case 27: {
          if (tag !== 218) {
            break;
          }

          message.totalIvTime = Duration.decode(reader, reader.uint32());
          continue;
        }
        case 28: {
          if (tag !== 226) {
            break;
          }

          message.ivWaitingTime = Duration.decode(reader, reader.uint32());
          continue;
        }
        case 29: {
          if (tag !== 234) {
            break;
          }

          message.ivHandlingTime = Duration.decode(reader, reader.uint32());
          continue;
        }
        case 30: {
          if (tag !== 242) {
            break;
          }

          message.avgIvTime = Duration.decode(reader, reader.uint32());
          continue;
        }
        case 31: {
          if (tag !== 250) {
            break;
          }

          message.avgIvWaitingTime = Duration.decode(reader, reader.uint32());
          continue;
        }
        case 32: {
          if (tag !== 258) {
            break;
          }

          message.avgIvHandlingTime = Duration.decode(reader, reader.uint32());
          continue;
        }
        case 33: {
          if (tag !== 269) {
            break;
          }

          message.avgIvTimePercent = reader.float();
          continue;
        }
        case 34: {
          if (tag !== 277) {
            break;
          }

          message.avgIvWaitingTimePercent = reader.float();
          continue;
        }
        case 35: {
          if (tag !== 285) {
            break;
          }

          message.avgIvHandlingTimePercent = reader.float();
          continue;
        }
        case 36: {
          if (tag !== 288) {
            break;
          }

          message.progressPercent = reader.uint32();
          continue;
        }
        case 37: {
          if (tag !== 301) {
            break;
          }

          message.totalAcres = reader.float();
          continue;
        }
        case 38: {
          if (tag !== 309) {
            break;
          }

          message.completedAcres = reader.float();
          continue;
        }
        case 39: {
          if (tag !== 317) {
            break;
          }

          message.acresPerActiveHour = reader.float();
          continue;
        }
        case 40: {
          if (tag !== 322) {
            break;
          }

          message.estCompletionAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): JobMetrics {
    return {
      jobId: isSet(object.jobId)
        ? globalThis.Number(object.jobId)
        : isSet(object.job_id)
        ? globalThis.Number(object.job_id)
        : 0,
      updatedAt: isSet(object.updatedAt)
        ? globalThis.String(object.updatedAt)
        : isSet(object.updated_at)
        ? globalThis.String(object.updated_at)
        : undefined,
      readyAt: isSet(object.readyAt)
        ? globalThis.String(object.readyAt)
        : isSet(object.ready_at)
        ? globalThis.String(object.ready_at)
        : undefined,
      startedAt: isSet(object.startedAt)
        ? globalThis.String(object.startedAt)
        : isSet(object.started_at)
        ? globalThis.String(object.started_at)
        : undefined,
      endedAt: isSet(object.endedAt)
        ? globalThis.String(object.endedAt)
        : isSet(object.ended_at)
        ? globalThis.String(object.ended_at)
        : undefined,
      totalTime: isSet(object.totalTime)
        ? Duration.fromJSON(object.totalTime)
        : isSet(object.total_time)
        ? Duration.fromJSON(object.total_time)
        : undefined,
      waitingTime: isSet(object.waitingTime)
        ? Duration.fromJSON(object.waitingTime)
        : isSet(object.waiting_time)
        ? Duration.fromJSON(object.waiting_time)
        : undefined,
      activeTime: isSet(object.activeTime)
        ? Duration.fromJSON(object.activeTime)
        : isSet(object.active_time)
        ? Duration.fromJSON(object.active_time)
        : undefined,
      numRobots: isSet(object.numRobots)
        ? globalThis.Number(object.numRobots)
        : isSet(object.num_robots)
        ? globalThis.Number(object.num_robots)
        : 0,
      workingTime: isSet(object.workingTime)
        ? Duration.fromJSON(object.workingTime)
        : isSet(object.working_time)
        ? Duration.fromJSON(object.working_time)
        : undefined,
      workingTimeManual: isSet(object.workingTimeManual)
        ? Duration.fromJSON(object.workingTimeManual)
        : isSet(object.working_time_manual)
        ? Duration.fromJSON(object.working_time_manual)
        : undefined,
      workingTimeAuto: isSet(object.workingTimeAuto)
        ? Duration.fromJSON(object.workingTimeAuto)
        : isSet(object.working_time_auto)
        ? Duration.fromJSON(object.working_time_auto)
        : undefined,
      idleTime: isSet(object.idleTime)
        ? Duration.fromJSON(object.idleTime)
        : isSet(object.idle_time)
        ? Duration.fromJSON(object.idle_time)
        : undefined,
      avgWorkingTime: isSet(object.avgWorkingTime)
        ? Duration.fromJSON(object.avgWorkingTime)
        : isSet(object.avg_working_time)
        ? Duration.fromJSON(object.avg_working_time)
        : undefined,
      avgWorkingTimeManual: isSet(object.avgWorkingTimeManual)
        ? Duration.fromJSON(object.avgWorkingTimeManual)
        : isSet(object.avg_working_time_manual)
        ? Duration.fromJSON(object.avg_working_time_manual)
        : undefined,
      avgWorkingTimeAuto: isSet(object.avgWorkingTimeAuto)
        ? Duration.fromJSON(object.avgWorkingTimeAuto)
        : isSet(object.avg_working_time_auto)
        ? Duration.fromJSON(object.avg_working_time_auto)
        : undefined,
      avgIdleTime: isSet(object.avgIdleTime)
        ? Duration.fromJSON(object.avgIdleTime)
        : isSet(object.avg_idle_time)
        ? Duration.fromJSON(object.avg_idle_time)
        : undefined,
      avgWorkingTimePercent: isSet(object.avgWorkingTimePercent)
        ? globalThis.Number(object.avgWorkingTimePercent)
        : isSet(object.avg_working_time_percent)
        ? globalThis.Number(object.avg_working_time_percent)
        : 0,
      avgWorkingTimeManualPercent: isSet(object.avgWorkingTimeManualPercent)
        ? globalThis.Number(object.avgWorkingTimeManualPercent)
        : isSet(object.avg_working_time_manual_percent)
        ? globalThis.Number(object.avg_working_time_manual_percent)
        : 0,
      avgWorkingTimeAutoPercent: isSet(object.avgWorkingTimeAutoPercent)
        ? globalThis.Number(object.avgWorkingTimeAutoPercent)
        : isSet(object.avg_working_time_auto_percent)
        ? globalThis.Number(object.avg_working_time_auto_percent)
        : 0,
      avgActiveTimeManualPercent: isSet(object.avgActiveTimeManualPercent)
        ? globalThis.Number(object.avgActiveTimeManualPercent)
        : isSet(object.avg_active_time_manual_percent)
        ? globalThis.Number(object.avg_active_time_manual_percent)
        : 0,
      avgActiveTimeAutoPercent: isSet(object.avgActiveTimeAutoPercent)
        ? globalThis.Number(object.avgActiveTimeAutoPercent)
        : isSet(object.avg_active_time_auto_percent)
        ? globalThis.Number(object.avg_active_time_auto_percent)
        : 0,
      avgIdleTimePercent: isSet(object.avgIdleTimePercent)
        ? globalThis.Number(object.avgIdleTimePercent)
        : isSet(object.avg_idle_time_percent)
        ? globalThis.Number(object.avg_idle_time_percent)
        : 0,
      totalInterventions: isSet(object.totalInterventions)
        ? globalThis.Number(object.totalInterventions)
        : isSet(object.total_interventions)
        ? globalThis.Number(object.total_interventions)
        : 0,
      ivsPerActiveHour: isSet(object.ivsPerActiveHour)
        ? globalThis.Number(object.ivsPerActiveHour)
        : isSet(object.ivs_per_active_hour)
        ? globalThis.Number(object.ivs_per_active_hour)
        : 0,
      ivsPerAutoHour: isSet(object.ivsPerAutoHour)
        ? globalThis.Number(object.ivsPerAutoHour)
        : isSet(object.ivs_per_auto_hour)
        ? globalThis.Number(object.ivs_per_auto_hour)
        : 0,
      totalIvTime: isSet(object.totalIvTime)
        ? Duration.fromJSON(object.totalIvTime)
        : isSet(object.total_iv_time)
        ? Duration.fromJSON(object.total_iv_time)
        : undefined,
      ivWaitingTime: isSet(object.ivWaitingTime)
        ? Duration.fromJSON(object.ivWaitingTime)
        : isSet(object.iv_waiting_time)
        ? Duration.fromJSON(object.iv_waiting_time)
        : undefined,
      ivHandlingTime: isSet(object.ivHandlingTime)
        ? Duration.fromJSON(object.ivHandlingTime)
        : isSet(object.iv_handling_time)
        ? Duration.fromJSON(object.iv_handling_time)
        : undefined,
      avgIvTime: isSet(object.avgIvTime)
        ? Duration.fromJSON(object.avgIvTime)
        : isSet(object.avg_iv_time)
        ? Duration.fromJSON(object.avg_iv_time)
        : undefined,
      avgIvWaitingTime: isSet(object.avgIvWaitingTime)
        ? Duration.fromJSON(object.avgIvWaitingTime)
        : isSet(object.avg_iv_waiting_time)
        ? Duration.fromJSON(object.avg_iv_waiting_time)
        : undefined,
      avgIvHandlingTime: isSet(object.avgIvHandlingTime)
        ? Duration.fromJSON(object.avgIvHandlingTime)
        : isSet(object.avg_iv_handling_time)
        ? Duration.fromJSON(object.avg_iv_handling_time)
        : undefined,
      avgIvTimePercent: isSet(object.avgIvTimePercent)
        ? globalThis.Number(object.avgIvTimePercent)
        : isSet(object.avg_iv_time_percent)
        ? globalThis.Number(object.avg_iv_time_percent)
        : 0,
      avgIvWaitingTimePercent: isSet(object.avgIvWaitingTimePercent)
        ? globalThis.Number(object.avgIvWaitingTimePercent)
        : isSet(object.avg_iv_waiting_time_percent)
        ? globalThis.Number(object.avg_iv_waiting_time_percent)
        : 0,
      avgIvHandlingTimePercent: isSet(object.avgIvHandlingTimePercent)
        ? globalThis.Number(object.avgIvHandlingTimePercent)
        : isSet(object.avg_iv_handling_time_percent)
        ? globalThis.Number(object.avg_iv_handling_time_percent)
        : 0,
      progressPercent: isSet(object.progressPercent)
        ? globalThis.Number(object.progressPercent)
        : isSet(object.progress_percent)
        ? globalThis.Number(object.progress_percent)
        : 0,
      totalAcres: isSet(object.totalAcres)
        ? globalThis.Number(object.totalAcres)
        : isSet(object.total_acres)
        ? globalThis.Number(object.total_acres)
        : 0,
      completedAcres: isSet(object.completedAcres)
        ? globalThis.Number(object.completedAcres)
        : isSet(object.completed_acres)
        ? globalThis.Number(object.completed_acres)
        : 0,
      acresPerActiveHour: isSet(object.acresPerActiveHour)
        ? globalThis.Number(object.acresPerActiveHour)
        : isSet(object.acres_per_active_hour)
        ? globalThis.Number(object.acres_per_active_hour)
        : 0,
      estCompletionAt: isSet(object.estCompletionAt)
        ? globalThis.String(object.estCompletionAt)
        : isSet(object.est_completion_at)
        ? globalThis.String(object.est_completion_at)
        : undefined,
    };
  },

  toJSON(message: JobMetrics): unknown {
    const obj: any = {};
    if (message.jobId !== 0) {
      obj.jobId = Math.round(message.jobId);
    }
    if (message.updatedAt !== undefined) {
      obj.updatedAt = message.updatedAt;
    }
    if (message.readyAt !== undefined) {
      obj.readyAt = message.readyAt;
    }
    if (message.startedAt !== undefined) {
      obj.startedAt = message.startedAt;
    }
    if (message.endedAt !== undefined) {
      obj.endedAt = message.endedAt;
    }
    if (message.totalTime !== undefined) {
      obj.totalTime = Duration.toJSON(message.totalTime);
    }
    if (message.waitingTime !== undefined) {
      obj.waitingTime = Duration.toJSON(message.waitingTime);
    }
    if (message.activeTime !== undefined) {
      obj.activeTime = Duration.toJSON(message.activeTime);
    }
    if (message.numRobots !== 0) {
      obj.numRobots = Math.round(message.numRobots);
    }
    if (message.workingTime !== undefined) {
      obj.workingTime = Duration.toJSON(message.workingTime);
    }
    if (message.workingTimeManual !== undefined) {
      obj.workingTimeManual = Duration.toJSON(message.workingTimeManual);
    }
    if (message.workingTimeAuto !== undefined) {
      obj.workingTimeAuto = Duration.toJSON(message.workingTimeAuto);
    }
    if (message.idleTime !== undefined) {
      obj.idleTime = Duration.toJSON(message.idleTime);
    }
    if (message.avgWorkingTime !== undefined) {
      obj.avgWorkingTime = Duration.toJSON(message.avgWorkingTime);
    }
    if (message.avgWorkingTimeManual !== undefined) {
      obj.avgWorkingTimeManual = Duration.toJSON(message.avgWorkingTimeManual);
    }
    if (message.avgWorkingTimeAuto !== undefined) {
      obj.avgWorkingTimeAuto = Duration.toJSON(message.avgWorkingTimeAuto);
    }
    if (message.avgIdleTime !== undefined) {
      obj.avgIdleTime = Duration.toJSON(message.avgIdleTime);
    }
    if (message.avgWorkingTimePercent !== 0) {
      obj.avgWorkingTimePercent = message.avgWorkingTimePercent;
    }
    if (message.avgWorkingTimeManualPercent !== 0) {
      obj.avgWorkingTimeManualPercent = message.avgWorkingTimeManualPercent;
    }
    if (message.avgWorkingTimeAutoPercent !== 0) {
      obj.avgWorkingTimeAutoPercent = message.avgWorkingTimeAutoPercent;
    }
    if (message.avgActiveTimeManualPercent !== 0) {
      obj.avgActiveTimeManualPercent = message.avgActiveTimeManualPercent;
    }
    if (message.avgActiveTimeAutoPercent !== 0) {
      obj.avgActiveTimeAutoPercent = message.avgActiveTimeAutoPercent;
    }
    if (message.avgIdleTimePercent !== 0) {
      obj.avgIdleTimePercent = message.avgIdleTimePercent;
    }
    if (message.totalInterventions !== 0) {
      obj.totalInterventions = Math.round(message.totalInterventions);
    }
    if (message.ivsPerActiveHour !== 0) {
      obj.ivsPerActiveHour = message.ivsPerActiveHour;
    }
    if (message.ivsPerAutoHour !== 0) {
      obj.ivsPerAutoHour = message.ivsPerAutoHour;
    }
    if (message.totalIvTime !== undefined) {
      obj.totalIvTime = Duration.toJSON(message.totalIvTime);
    }
    if (message.ivWaitingTime !== undefined) {
      obj.ivWaitingTime = Duration.toJSON(message.ivWaitingTime);
    }
    if (message.ivHandlingTime !== undefined) {
      obj.ivHandlingTime = Duration.toJSON(message.ivHandlingTime);
    }
    if (message.avgIvTime !== undefined) {
      obj.avgIvTime = Duration.toJSON(message.avgIvTime);
    }
    if (message.avgIvWaitingTime !== undefined) {
      obj.avgIvWaitingTime = Duration.toJSON(message.avgIvWaitingTime);
    }
    if (message.avgIvHandlingTime !== undefined) {
      obj.avgIvHandlingTime = Duration.toJSON(message.avgIvHandlingTime);
    }
    if (message.avgIvTimePercent !== 0) {
      obj.avgIvTimePercent = message.avgIvTimePercent;
    }
    if (message.avgIvWaitingTimePercent !== 0) {
      obj.avgIvWaitingTimePercent = message.avgIvWaitingTimePercent;
    }
    if (message.avgIvHandlingTimePercent !== 0) {
      obj.avgIvHandlingTimePercent = message.avgIvHandlingTimePercent;
    }
    if (message.progressPercent !== 0) {
      obj.progressPercent = Math.round(message.progressPercent);
    }
    if (message.totalAcres !== 0) {
      obj.totalAcres = message.totalAcres;
    }
    if (message.completedAcres !== 0) {
      obj.completedAcres = message.completedAcres;
    }
    if (message.acresPerActiveHour !== 0) {
      obj.acresPerActiveHour = message.acresPerActiveHour;
    }
    if (message.estCompletionAt !== undefined) {
      obj.estCompletionAt = message.estCompletionAt;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<JobMetrics>, I>>(base?: I): JobMetrics {
    return JobMetrics.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<JobMetrics>, I>>(object: I): JobMetrics {
    const message = createBaseJobMetrics();
    message.jobId = object.jobId ?? 0;
    message.updatedAt = object.updatedAt ?? undefined;
    message.readyAt = object.readyAt ?? undefined;
    message.startedAt = object.startedAt ?? undefined;
    message.endedAt = object.endedAt ?? undefined;
    message.totalTime = (object.totalTime !== undefined && object.totalTime !== null)
      ? Duration.fromPartial(object.totalTime)
      : undefined;
    message.waitingTime = (object.waitingTime !== undefined && object.waitingTime !== null)
      ? Duration.fromPartial(object.waitingTime)
      : undefined;
    message.activeTime = (object.activeTime !== undefined && object.activeTime !== null)
      ? Duration.fromPartial(object.activeTime)
      : undefined;
    message.numRobots = object.numRobots ?? 0;
    message.workingTime = (object.workingTime !== undefined && object.workingTime !== null)
      ? Duration.fromPartial(object.workingTime)
      : undefined;
    message.workingTimeManual = (object.workingTimeManual !== undefined && object.workingTimeManual !== null)
      ? Duration.fromPartial(object.workingTimeManual)
      : undefined;
    message.workingTimeAuto = (object.workingTimeAuto !== undefined && object.workingTimeAuto !== null)
      ? Duration.fromPartial(object.workingTimeAuto)
      : undefined;
    message.idleTime = (object.idleTime !== undefined && object.idleTime !== null)
      ? Duration.fromPartial(object.idleTime)
      : undefined;
    message.avgWorkingTime = (object.avgWorkingTime !== undefined && object.avgWorkingTime !== null)
      ? Duration.fromPartial(object.avgWorkingTime)
      : undefined;
    message.avgWorkingTimeManual = (object.avgWorkingTimeManual !== undefined && object.avgWorkingTimeManual !== null)
      ? Duration.fromPartial(object.avgWorkingTimeManual)
      : undefined;
    message.avgWorkingTimeAuto = (object.avgWorkingTimeAuto !== undefined && object.avgWorkingTimeAuto !== null)
      ? Duration.fromPartial(object.avgWorkingTimeAuto)
      : undefined;
    message.avgIdleTime = (object.avgIdleTime !== undefined && object.avgIdleTime !== null)
      ? Duration.fromPartial(object.avgIdleTime)
      : undefined;
    message.avgWorkingTimePercent = object.avgWorkingTimePercent ?? 0;
    message.avgWorkingTimeManualPercent = object.avgWorkingTimeManualPercent ?? 0;
    message.avgWorkingTimeAutoPercent = object.avgWorkingTimeAutoPercent ?? 0;
    message.avgActiveTimeManualPercent = object.avgActiveTimeManualPercent ?? 0;
    message.avgActiveTimeAutoPercent = object.avgActiveTimeAutoPercent ?? 0;
    message.avgIdleTimePercent = object.avgIdleTimePercent ?? 0;
    message.totalInterventions = object.totalInterventions ?? 0;
    message.ivsPerActiveHour = object.ivsPerActiveHour ?? 0;
    message.ivsPerAutoHour = object.ivsPerAutoHour ?? 0;
    message.totalIvTime = (object.totalIvTime !== undefined && object.totalIvTime !== null)
      ? Duration.fromPartial(object.totalIvTime)
      : undefined;
    message.ivWaitingTime = (object.ivWaitingTime !== undefined && object.ivWaitingTime !== null)
      ? Duration.fromPartial(object.ivWaitingTime)
      : undefined;
    message.ivHandlingTime = (object.ivHandlingTime !== undefined && object.ivHandlingTime !== null)
      ? Duration.fromPartial(object.ivHandlingTime)
      : undefined;
    message.avgIvTime = (object.avgIvTime !== undefined && object.avgIvTime !== null)
      ? Duration.fromPartial(object.avgIvTime)
      : undefined;
    message.avgIvWaitingTime = (object.avgIvWaitingTime !== undefined && object.avgIvWaitingTime !== null)
      ? Duration.fromPartial(object.avgIvWaitingTime)
      : undefined;
    message.avgIvHandlingTime = (object.avgIvHandlingTime !== undefined && object.avgIvHandlingTime !== null)
      ? Duration.fromPartial(object.avgIvHandlingTime)
      : undefined;
    message.avgIvTimePercent = object.avgIvTimePercent ?? 0;
    message.avgIvWaitingTimePercent = object.avgIvWaitingTimePercent ?? 0;
    message.avgIvHandlingTimePercent = object.avgIvHandlingTimePercent ?? 0;
    message.progressPercent = object.progressPercent ?? 0;
    message.totalAcres = object.totalAcres ?? 0;
    message.completedAcres = object.completedAcres ?? 0;
    message.acresPerActiveHour = object.acresPerActiveHour ?? 0;
    message.estCompletionAt = object.estCompletionAt ?? undefined;
    return message;
  },
};

function createBaseGroundPrepJobConfiguration(): GroundPrepJobConfiguration {
  return {
    updatedAt: undefined,
    pathPlan: undefined,
    tractorDefinition: undefined,
    implementDefinition: undefined,
    entryPoint: undefined,
    exitPoint: undefined,
    rigId: "",
    rigSnapshotId: "",
    rigChanged: undefined,
    headlandBufferM: undefined,
  };
}

export const GroundPrepJobConfiguration: MessageFns<GroundPrepJobConfiguration> = {
  encode(message: GroundPrepJobConfiguration, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.updatedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.updatedAt), writer.uint32(66).fork()).join();
    }
    if (message.pathPlan !== undefined) {
      PathPlanConfiguration.encode(message.pathPlan, writer.uint32(10).fork()).join();
    }
    if (message.tractorDefinition !== undefined) {
      TractorDefinition.encode(message.tractorDefinition, writer.uint32(18).fork()).join();
    }
    if (message.implementDefinition !== undefined) {
      ImplementDefinition.encode(message.implementDefinition, writer.uint32(26).fork()).join();
    }
    if (message.entryPoint !== undefined) {
      Point.encode(message.entryPoint, writer.uint32(34).fork()).join();
    }
    if (message.exitPoint !== undefined) {
      Point.encode(message.exitPoint, writer.uint32(42).fork()).join();
    }
    if (message.rigId !== "") {
      writer.uint32(58).string(message.rigId);
    }
    if (message.rigSnapshotId !== "") {
      writer.uint32(74).string(message.rigSnapshotId);
    }
    if (message.rigChanged !== undefined) {
      writer.uint32(80).bool(message.rigChanged);
    }
    if (message.headlandBufferM !== undefined) {
      writer.uint32(93).float(message.headlandBufferM);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GroundPrepJobConfiguration {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGroundPrepJobConfiguration();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.updatedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.pathPlan = PathPlanConfiguration.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.tractorDefinition = TractorDefinition.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.implementDefinition = ImplementDefinition.decode(reader, reader.uint32());
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.entryPoint = Point.decode(reader, reader.uint32());
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.exitPoint = Point.decode(reader, reader.uint32());
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.rigId = reader.string();
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.rigSnapshotId = reader.string();
          continue;
        }
        case 10: {
          if (tag !== 80) {
            break;
          }

          message.rigChanged = reader.bool();
          continue;
        }
        case 11: {
          if (tag !== 93) {
            break;
          }

          message.headlandBufferM = reader.float();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GroundPrepJobConfiguration {
    return {
      updatedAt: isSet(object.updatedAt)
        ? globalThis.String(object.updatedAt)
        : isSet(object.updated_at)
        ? globalThis.String(object.updated_at)
        : undefined,
      pathPlan: isSet(object.pathPlan)
        ? PathPlanConfiguration.fromJSON(object.pathPlan)
        : isSet(object.path_plan)
        ? PathPlanConfiguration.fromJSON(object.path_plan)
        : undefined,
      tractorDefinition: isSet(object.tractorDefinition)
        ? TractorDefinition.fromJSON(object.tractorDefinition)
        : isSet(object.tractor_definition)
        ? TractorDefinition.fromJSON(object.tractor_definition)
        : undefined,
      implementDefinition: isSet(object.implementDefinition)
        ? ImplementDefinition.fromJSON(object.implementDefinition)
        : isSet(object.implement_definition)
        ? ImplementDefinition.fromJSON(object.implement_definition)
        : undefined,
      entryPoint: isSet(object.entryPoint)
        ? Point.fromJSON(object.entryPoint)
        : isSet(object.entry_point)
        ? Point.fromJSON(object.entry_point)
        : undefined,
      exitPoint: isSet(object.exitPoint)
        ? Point.fromJSON(object.exitPoint)
        : isSet(object.exit_point)
        ? Point.fromJSON(object.exit_point)
        : undefined,
      rigId: isSet(object.rigId)
        ? globalThis.String(object.rigId)
        : isSet(object.rig_id)
        ? globalThis.String(object.rig_id)
        : "",
      rigSnapshotId: isSet(object.rigSnapshotId)
        ? globalThis.String(object.rigSnapshotId)
        : isSet(object.rig_snapshot_id)
        ? globalThis.String(object.rig_snapshot_id)
        : "",
      rigChanged: isSet(object.rigChanged)
        ? globalThis.Boolean(object.rigChanged)
        : isSet(object.rig_changed)
        ? globalThis.Boolean(object.rig_changed)
        : undefined,
      headlandBufferM: isSet(object.headlandBufferM)
        ? globalThis.Number(object.headlandBufferM)
        : isSet(object.headland_buffer_m)
        ? globalThis.Number(object.headland_buffer_m)
        : undefined,
    };
  },

  toJSON(message: GroundPrepJobConfiguration): unknown {
    const obj: any = {};
    if (message.updatedAt !== undefined) {
      obj.updatedAt = message.updatedAt;
    }
    if (message.pathPlan !== undefined) {
      obj.pathPlan = PathPlanConfiguration.toJSON(message.pathPlan);
    }
    if (message.tractorDefinition !== undefined) {
      obj.tractorDefinition = TractorDefinition.toJSON(message.tractorDefinition);
    }
    if (message.implementDefinition !== undefined) {
      obj.implementDefinition = ImplementDefinition.toJSON(message.implementDefinition);
    }
    if (message.entryPoint !== undefined) {
      obj.entryPoint = Point.toJSON(message.entryPoint);
    }
    if (message.exitPoint !== undefined) {
      obj.exitPoint = Point.toJSON(message.exitPoint);
    }
    if (message.rigId !== "") {
      obj.rigId = message.rigId;
    }
    if (message.rigSnapshotId !== "") {
      obj.rigSnapshotId = message.rigSnapshotId;
    }
    if (message.rigChanged !== undefined) {
      obj.rigChanged = message.rigChanged;
    }
    if (message.headlandBufferM !== undefined) {
      obj.headlandBufferM = message.headlandBufferM;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GroundPrepJobConfiguration>, I>>(base?: I): GroundPrepJobConfiguration {
    return GroundPrepJobConfiguration.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GroundPrepJobConfiguration>, I>>(object: I): GroundPrepJobConfiguration {
    const message = createBaseGroundPrepJobConfiguration();
    message.updatedAt = object.updatedAt ?? undefined;
    message.pathPlan = (object.pathPlan !== undefined && object.pathPlan !== null)
      ? PathPlanConfiguration.fromPartial(object.pathPlan)
      : undefined;
    message.tractorDefinition = (object.tractorDefinition !== undefined && object.tractorDefinition !== null)
      ? TractorDefinition.fromPartial(object.tractorDefinition)
      : undefined;
    message.implementDefinition = (object.implementDefinition !== undefined && object.implementDefinition !== null)
      ? ImplementDefinition.fromPartial(object.implementDefinition)
      : undefined;
    message.entryPoint = (object.entryPoint !== undefined && object.entryPoint !== null)
      ? Point.fromPartial(object.entryPoint)
      : undefined;
    message.exitPoint = (object.exitPoint !== undefined && object.exitPoint !== null)
      ? Point.fromPartial(object.exitPoint)
      : undefined;
    message.rigId = object.rigId ?? "";
    message.rigSnapshotId = object.rigSnapshotId ?? "";
    message.rigChanged = object.rigChanged ?? undefined;
    message.headlandBufferM = object.headlandBufferM ?? undefined;
    return message;
  },
};

function createBaseLaserWeedJobConfiguration(): LaserWeedJobConfiguration {
  return { updatedAt: undefined, rowSpacingM: 0, rowTraversalSpeedMS: undefined, transitionSpeedMS: undefined };
}

export const LaserWeedJobConfiguration: MessageFns<LaserWeedJobConfiguration> = {
  encode(message: LaserWeedJobConfiguration, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.updatedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.updatedAt), writer.uint32(18).fork()).join();
    }
    if (message.rowSpacingM !== 0) {
      writer.uint32(9).double(message.rowSpacingM);
    }
    if (message.rowTraversalSpeedMS !== undefined) {
      writer.uint32(25).double(message.rowTraversalSpeedMS);
    }
    if (message.transitionSpeedMS !== undefined) {
      writer.uint32(33).double(message.transitionSpeedMS);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): LaserWeedJobConfiguration {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseLaserWeedJobConfiguration();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.updatedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 1: {
          if (tag !== 9) {
            break;
          }

          message.rowSpacingM = reader.double();
          continue;
        }
        case 3: {
          if (tag !== 25) {
            break;
          }

          message.rowTraversalSpeedMS = reader.double();
          continue;
        }
        case 4: {
          if (tag !== 33) {
            break;
          }

          message.transitionSpeedMS = reader.double();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): LaserWeedJobConfiguration {
    return {
      updatedAt: isSet(object.updatedAt)
        ? globalThis.String(object.updatedAt)
        : isSet(object.updated_at)
        ? globalThis.String(object.updated_at)
        : undefined,
      rowSpacingM: isSet(object.rowSpacingM)
        ? globalThis.Number(object.rowSpacingM)
        : isSet(object.row_spacing_m)
        ? globalThis.Number(object.row_spacing_m)
        : 0,
      rowTraversalSpeedMS: isSet(object.rowTraversalSpeedMS)
        ? globalThis.Number(object.rowTraversalSpeedMS)
        : isSet(object.row_traversal_speed_m_s)
        ? globalThis.Number(object.row_traversal_speed_m_s)
        : undefined,
      transitionSpeedMS: isSet(object.transitionSpeedMS)
        ? globalThis.Number(object.transitionSpeedMS)
        : isSet(object.transition_speed_m_s)
        ? globalThis.Number(object.transition_speed_m_s)
        : undefined,
    };
  },

  toJSON(message: LaserWeedJobConfiguration): unknown {
    const obj: any = {};
    if (message.updatedAt !== undefined) {
      obj.updatedAt = message.updatedAt;
    }
    if (message.rowSpacingM !== 0) {
      obj.rowSpacingM = message.rowSpacingM;
    }
    if (message.rowTraversalSpeedMS !== undefined) {
      obj.rowTraversalSpeedMS = message.rowTraversalSpeedMS;
    }
    if (message.transitionSpeedMS !== undefined) {
      obj.transitionSpeedMS = message.transitionSpeedMS;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<LaserWeedJobConfiguration>, I>>(base?: I): LaserWeedJobConfiguration {
    return LaserWeedJobConfiguration.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<LaserWeedJobConfiguration>, I>>(object: I): LaserWeedJobConfiguration {
    const message = createBaseLaserWeedJobConfiguration();
    message.updatedAt = object.updatedAt ?? undefined;
    message.rowSpacingM = object.rowSpacingM ?? 0;
    message.rowTraversalSpeedMS = object.rowTraversalSpeedMS ?? undefined;
    message.transitionSpeedMS = object.transitionSpeedMS ?? undefined;
    return message;
  },
};

function createBaseTransportJobConfiguration(): TransportJobConfiguration {
  return { updatedAt: undefined, pathId: "", transportSpeedMS: 0 };
}

export const TransportJobConfiguration: MessageFns<TransportJobConfiguration> = {
  encode(message: TransportJobConfiguration, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.updatedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.updatedAt), writer.uint32(10).fork()).join();
    }
    if (message.pathId !== "") {
      writer.uint32(18).string(message.pathId);
    }
    if (message.transportSpeedMS !== 0) {
      writer.uint32(25).double(message.transportSpeedMS);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TransportJobConfiguration {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTransportJobConfiguration();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.updatedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.pathId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 25) {
            break;
          }

          message.transportSpeedMS = reader.double();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TransportJobConfiguration {
    return {
      updatedAt: isSet(object.updatedAt)
        ? globalThis.String(object.updatedAt)
        : isSet(object.updated_at)
        ? globalThis.String(object.updated_at)
        : undefined,
      pathId: isSet(object.pathId)
        ? globalThis.String(object.pathId)
        : isSet(object.path_id)
        ? globalThis.String(object.path_id)
        : "",
      transportSpeedMS: isSet(object.transportSpeedMS)
        ? globalThis.Number(object.transportSpeedMS)
        : isSet(object.transport_speed_m_s)
        ? globalThis.Number(object.transport_speed_m_s)
        : 0,
    };
  },

  toJSON(message: TransportJobConfiguration): unknown {
    const obj: any = {};
    if (message.updatedAt !== undefined) {
      obj.updatedAt = message.updatedAt;
    }
    if (message.pathId !== "") {
      obj.pathId = message.pathId;
    }
    if (message.transportSpeedMS !== 0) {
      obj.transportSpeedMS = message.transportSpeedMS;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<TransportJobConfiguration>, I>>(base?: I): TransportJobConfiguration {
    return TransportJobConfiguration.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TransportJobConfiguration>, I>>(object: I): TransportJobConfiguration {
    const message = createBaseTransportJobConfiguration();
    message.updatedAt = object.updatedAt ?? undefined;
    message.pathId = object.pathId ?? "";
    message.transportSpeedMS = object.transportSpeedMS ?? 0;
    return message;
  },
};

function createBaseInSeasonJobConfiguration(): InSeasonJobConfiguration {
  return {
    updatedAt: undefined,
    pathId: "",
    rowTraversalSpeedMS: undefined,
    transitionSpeedMS: undefined,
    toolSpeedMS: undefined,
    rowSpacingM: undefined,
  };
}

export const InSeasonJobConfiguration: MessageFns<InSeasonJobConfiguration> = {
  encode(message: InSeasonJobConfiguration, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.updatedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.updatedAt), writer.uint32(10).fork()).join();
    }
    if (message.pathId !== "") {
      writer.uint32(18).string(message.pathId);
    }
    if (message.rowTraversalSpeedMS !== undefined) {
      writer.uint32(25).double(message.rowTraversalSpeedMS);
    }
    if (message.transitionSpeedMS !== undefined) {
      writer.uint32(33).double(message.transitionSpeedMS);
    }
    if (message.toolSpeedMS !== undefined) {
      writer.uint32(41).double(message.toolSpeedMS);
    }
    if (message.rowSpacingM !== undefined) {
      writer.uint32(49).double(message.rowSpacingM);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): InSeasonJobConfiguration {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseInSeasonJobConfiguration();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.updatedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.pathId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 25) {
            break;
          }

          message.rowTraversalSpeedMS = reader.double();
          continue;
        }
        case 4: {
          if (tag !== 33) {
            break;
          }

          message.transitionSpeedMS = reader.double();
          continue;
        }
        case 5: {
          if (tag !== 41) {
            break;
          }

          message.toolSpeedMS = reader.double();
          continue;
        }
        case 6: {
          if (tag !== 49) {
            break;
          }

          message.rowSpacingM = reader.double();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): InSeasonJobConfiguration {
    return {
      updatedAt: isSet(object.updatedAt)
        ? globalThis.String(object.updatedAt)
        : isSet(object.updated_at)
        ? globalThis.String(object.updated_at)
        : undefined,
      pathId: isSet(object.pathId)
        ? globalThis.String(object.pathId)
        : isSet(object.path_id)
        ? globalThis.String(object.path_id)
        : "",
      rowTraversalSpeedMS: isSet(object.rowTraversalSpeedMS)
        ? globalThis.Number(object.rowTraversalSpeedMS)
        : isSet(object.row_traversal_speed_m_s)
        ? globalThis.Number(object.row_traversal_speed_m_s)
        : undefined,
      transitionSpeedMS: isSet(object.transitionSpeedMS)
        ? globalThis.Number(object.transitionSpeedMS)
        : isSet(object.transition_speed_m_s)
        ? globalThis.Number(object.transition_speed_m_s)
        : undefined,
      toolSpeedMS: isSet(object.toolSpeedMS)
        ? globalThis.Number(object.toolSpeedMS)
        : isSet(object.tool_speed_m_s)
        ? globalThis.Number(object.tool_speed_m_s)
        : undefined,
      rowSpacingM: isSet(object.rowSpacingM)
        ? globalThis.Number(object.rowSpacingM)
        : isSet(object.row_spacing_m)
        ? globalThis.Number(object.row_spacing_m)
        : undefined,
    };
  },

  toJSON(message: InSeasonJobConfiguration): unknown {
    const obj: any = {};
    if (message.updatedAt !== undefined) {
      obj.updatedAt = message.updatedAt;
    }
    if (message.pathId !== "") {
      obj.pathId = message.pathId;
    }
    if (message.rowTraversalSpeedMS !== undefined) {
      obj.rowTraversalSpeedMS = message.rowTraversalSpeedMS;
    }
    if (message.transitionSpeedMS !== undefined) {
      obj.transitionSpeedMS = message.transitionSpeedMS;
    }
    if (message.toolSpeedMS !== undefined) {
      obj.toolSpeedMS = message.toolSpeedMS;
    }
    if (message.rowSpacingM !== undefined) {
      obj.rowSpacingM = message.rowSpacingM;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<InSeasonJobConfiguration>, I>>(base?: I): InSeasonJobConfiguration {
    return InSeasonJobConfiguration.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<InSeasonJobConfiguration>, I>>(object: I): InSeasonJobConfiguration {
    const message = createBaseInSeasonJobConfiguration();
    message.updatedAt = object.updatedAt ?? undefined;
    message.pathId = object.pathId ?? "";
    message.rowTraversalSpeedMS = object.rowTraversalSpeedMS ?? undefined;
    message.transitionSpeedMS = object.transitionSpeedMS ?? undefined;
    message.toolSpeedMS = object.toolSpeedMS ?? undefined;
    message.rowSpacingM = object.rowSpacingM ?? undefined;
    return message;
  },
};

function createBaseJobConfiguration(): JobConfiguration {
  return { jobId: 0, groundPrep: undefined, laserWeed: undefined, transport: undefined, inSeason: undefined };
}

export const JobConfiguration: MessageFns<JobConfiguration> = {
  encode(message: JobConfiguration, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.jobId !== 0) {
      writer.uint32(32).uint64(message.jobId);
    }
    if (message.groundPrep !== undefined) {
      GroundPrepJobConfiguration.encode(message.groundPrep, writer.uint32(10).fork()).join();
    }
    if (message.laserWeed !== undefined) {
      LaserWeedJobConfiguration.encode(message.laserWeed, writer.uint32(18).fork()).join();
    }
    if (message.transport !== undefined) {
      TransportJobConfiguration.encode(message.transport, writer.uint32(26).fork()).join();
    }
    if (message.inSeason !== undefined) {
      InSeasonJobConfiguration.encode(message.inSeason, writer.uint32(42).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): JobConfiguration {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseJobConfiguration();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.jobId = longToNumber(reader.uint64());
          continue;
        }
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.groundPrep = GroundPrepJobConfiguration.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.laserWeed = LaserWeedJobConfiguration.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.transport = TransportJobConfiguration.decode(reader, reader.uint32());
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.inSeason = InSeasonJobConfiguration.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): JobConfiguration {
    return {
      jobId: isSet(object.jobId)
        ? globalThis.Number(object.jobId)
        : isSet(object.job_id)
        ? globalThis.Number(object.job_id)
        : 0,
      groundPrep: isSet(object.groundPrep)
        ? GroundPrepJobConfiguration.fromJSON(object.groundPrep)
        : isSet(object.ground_prep)
        ? GroundPrepJobConfiguration.fromJSON(object.ground_prep)
        : undefined,
      laserWeed: isSet(object.laserWeed)
        ? LaserWeedJobConfiguration.fromJSON(object.laserWeed)
        : isSet(object.laser_weed)
        ? LaserWeedJobConfiguration.fromJSON(object.laser_weed)
        : undefined,
      transport: isSet(object.transport) ? TransportJobConfiguration.fromJSON(object.transport) : undefined,
      inSeason: isSet(object.inSeason)
        ? InSeasonJobConfiguration.fromJSON(object.inSeason)
        : isSet(object.in_season)
        ? InSeasonJobConfiguration.fromJSON(object.in_season)
        : undefined,
    };
  },

  toJSON(message: JobConfiguration): unknown {
    const obj: any = {};
    if (message.jobId !== 0) {
      obj.jobId = Math.round(message.jobId);
    }
    if (message.groundPrep !== undefined) {
      obj.groundPrep = GroundPrepJobConfiguration.toJSON(message.groundPrep);
    }
    if (message.laserWeed !== undefined) {
      obj.laserWeed = LaserWeedJobConfiguration.toJSON(message.laserWeed);
    }
    if (message.transport !== undefined) {
      obj.transport = TransportJobConfiguration.toJSON(message.transport);
    }
    if (message.inSeason !== undefined) {
      obj.inSeason = InSeasonJobConfiguration.toJSON(message.inSeason);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<JobConfiguration>, I>>(base?: I): JobConfiguration {
    return JobConfiguration.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<JobConfiguration>, I>>(object: I): JobConfiguration {
    const message = createBaseJobConfiguration();
    message.jobId = object.jobId ?? 0;
    message.groundPrep = (object.groundPrep !== undefined && object.groundPrep !== null)
      ? GroundPrepJobConfiguration.fromPartial(object.groundPrep)
      : undefined;
    message.laserWeed = (object.laserWeed !== undefined && object.laserWeed !== null)
      ? LaserWeedJobConfiguration.fromPartial(object.laserWeed)
      : undefined;
    message.transport = (object.transport !== undefined && object.transport !== null)
      ? TransportJobConfiguration.fromPartial(object.transport)
      : undefined;
    message.inSeason = (object.inSeason !== undefined && object.inSeason !== null)
      ? InSeasonJobConfiguration.fromPartial(object.inSeason)
      : undefined;
    return message;
  },
};

function createBaseGetNextJobConfigurationRequest(): GetNextJobConfigurationRequest {
  return { jobId: 0, updatedAt: undefined };
}

export const GetNextJobConfigurationRequest: MessageFns<GetNextJobConfigurationRequest> = {
  encode(message: GetNextJobConfigurationRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.jobId !== 0) {
      writer.uint32(8).uint64(message.jobId);
    }
    if (message.updatedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.updatedAt), writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetNextJobConfigurationRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetNextJobConfigurationRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.jobId = longToNumber(reader.uint64());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.updatedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetNextJobConfigurationRequest {
    return {
      jobId: isSet(object.jobId)
        ? globalThis.Number(object.jobId)
        : isSet(object.job_id)
        ? globalThis.Number(object.job_id)
        : 0,
      updatedAt: isSet(object.updatedAt)
        ? globalThis.String(object.updatedAt)
        : isSet(object.updated_at)
        ? globalThis.String(object.updated_at)
        : undefined,
    };
  },

  toJSON(message: GetNextJobConfigurationRequest): unknown {
    const obj: any = {};
    if (message.jobId !== 0) {
      obj.jobId = Math.round(message.jobId);
    }
    if (message.updatedAt !== undefined) {
      obj.updatedAt = message.updatedAt;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetNextJobConfigurationRequest>, I>>(base?: I): GetNextJobConfigurationRequest {
    return GetNextJobConfigurationRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetNextJobConfigurationRequest>, I>>(
    object: I,
  ): GetNextJobConfigurationRequest {
    const message = createBaseGetNextJobConfigurationRequest();
    message.jobId = object.jobId ?? 0;
    message.updatedAt = object.updatedAt ?? undefined;
    return message;
  },
};

function createBaseGetNextJobConfigurationResponse(): GetNextJobConfigurationResponse {
  return { configuration: undefined };
}

export const GetNextJobConfigurationResponse: MessageFns<GetNextJobConfigurationResponse> = {
  encode(message: GetNextJobConfigurationResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.configuration !== undefined) {
      JobConfiguration.encode(message.configuration, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetNextJobConfigurationResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetNextJobConfigurationResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.configuration = JobConfiguration.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetNextJobConfigurationResponse {
    return { configuration: isSet(object.configuration) ? JobConfiguration.fromJSON(object.configuration) : undefined };
  },

  toJSON(message: GetNextJobConfigurationResponse): unknown {
    const obj: any = {};
    if (message.configuration !== undefined) {
      obj.configuration = JobConfiguration.toJSON(message.configuration);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetNextJobConfigurationResponse>, I>>(base?: I): GetNextJobConfigurationResponse {
    return GetNextJobConfigurationResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetNextJobConfigurationResponse>, I>>(
    object: I,
  ): GetNextJobConfigurationResponse {
    const message = createBaseGetNextJobConfigurationResponse();
    message.configuration = (object.configuration !== undefined && object.configuration !== null)
      ? JobConfiguration.fromPartial(object.configuration)
      : undefined;
    return message;
  },
};

function createBaseCreateJobRequest(): CreateJobRequest {
  return {
    type: 0,
    name: "",
    farmId: "",
    fieldId: "",
    customerId: "",
    priority: 0,
    generateObjectives: false,
    dryRun: false,
    groundPrep: undefined,
    laserWeed: undefined,
    transport: undefined,
    inSeason: undefined,
  };
}

export const CreateJobRequest: MessageFns<CreateJobRequest> = {
  encode(message: CreateJobRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.type !== 0) {
      writer.uint32(8).int32(message.type);
    }
    if (message.name !== "") {
      writer.uint32(18).string(message.name);
    }
    if (message.farmId !== "") {
      writer.uint32(34).string(message.farmId);
    }
    if (message.fieldId !== "") {
      writer.uint32(42).string(message.fieldId);
    }
    if (message.customerId !== "") {
      writer.uint32(50).string(message.customerId);
    }
    if (message.priority !== 0) {
      writer.uint32(56).int32(message.priority);
    }
    if (message.generateObjectives !== false) {
      writer.uint32(64).bool(message.generateObjectives);
    }
    if (message.dryRun !== false) {
      writer.uint32(88).bool(message.dryRun);
    }
    if (message.groundPrep !== undefined) {
      GroundPrepJobConfiguration.encode(message.groundPrep, writer.uint32(74).fork()).join();
    }
    if (message.laserWeed !== undefined) {
      LaserWeedJobConfiguration.encode(message.laserWeed, writer.uint32(82).fork()).join();
    }
    if (message.transport !== undefined) {
      TransportJobConfiguration.encode(message.transport, writer.uint32(98).fork()).join();
    }
    if (message.inSeason !== undefined) {
      InSeasonJobConfiguration.encode(message.inSeason, writer.uint32(106).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CreateJobRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCreateJobRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.type = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.farmId = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.fieldId = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.customerId = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.priority = reader.int32();
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.generateObjectives = reader.bool();
          continue;
        }
        case 11: {
          if (tag !== 88) {
            break;
          }

          message.dryRun = reader.bool();
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.groundPrep = GroundPrepJobConfiguration.decode(reader, reader.uint32());
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.laserWeed = LaserWeedJobConfiguration.decode(reader, reader.uint32());
          continue;
        }
        case 12: {
          if (tag !== 98) {
            break;
          }

          message.transport = TransportJobConfiguration.decode(reader, reader.uint32());
          continue;
        }
        case 13: {
          if (tag !== 106) {
            break;
          }

          message.inSeason = InSeasonJobConfiguration.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CreateJobRequest {
    return {
      type: isSet(object.type) ? jobTypeFromJSON(object.type) : 0,
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      farmId: isSet(object.farmId)
        ? globalThis.String(object.farmId)
        : isSet(object.farm_id)
        ? globalThis.String(object.farm_id)
        : "",
      fieldId: isSet(object.fieldId)
        ? globalThis.String(object.fieldId)
        : isSet(object.field_id)
        ? globalThis.String(object.field_id)
        : "",
      customerId: isSet(object.customerId)
        ? globalThis.String(object.customerId)
        : isSet(object.customer_id)
        ? globalThis.String(object.customer_id)
        : "",
      priority: isSet(object.priority) ? globalThis.Number(object.priority) : 0,
      generateObjectives: isSet(object.generateObjectives)
        ? globalThis.Boolean(object.generateObjectives)
        : isSet(object.generate_objectives)
        ? globalThis.Boolean(object.generate_objectives)
        : false,
      dryRun: isSet(object.dryRun)
        ? globalThis.Boolean(object.dryRun)
        : isSet(object.dry_run)
        ? globalThis.Boolean(object.dry_run)
        : false,
      groundPrep: isSet(object.groundPrep)
        ? GroundPrepJobConfiguration.fromJSON(object.groundPrep)
        : isSet(object.ground_prep)
        ? GroundPrepJobConfiguration.fromJSON(object.ground_prep)
        : undefined,
      laserWeed: isSet(object.laserWeed)
        ? LaserWeedJobConfiguration.fromJSON(object.laserWeed)
        : isSet(object.laser_weed)
        ? LaserWeedJobConfiguration.fromJSON(object.laser_weed)
        : undefined,
      transport: isSet(object.transport) ? TransportJobConfiguration.fromJSON(object.transport) : undefined,
      inSeason: isSet(object.inSeason)
        ? InSeasonJobConfiguration.fromJSON(object.inSeason)
        : isSet(object.in_season)
        ? InSeasonJobConfiguration.fromJSON(object.in_season)
        : undefined,
    };
  },

  toJSON(message: CreateJobRequest): unknown {
    const obj: any = {};
    if (message.type !== 0) {
      obj.type = jobTypeToJSON(message.type);
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.farmId !== "") {
      obj.farmId = message.farmId;
    }
    if (message.fieldId !== "") {
      obj.fieldId = message.fieldId;
    }
    if (message.customerId !== "") {
      obj.customerId = message.customerId;
    }
    if (message.priority !== 0) {
      obj.priority = Math.round(message.priority);
    }
    if (message.generateObjectives !== false) {
      obj.generateObjectives = message.generateObjectives;
    }
    if (message.dryRun !== false) {
      obj.dryRun = message.dryRun;
    }
    if (message.groundPrep !== undefined) {
      obj.groundPrep = GroundPrepJobConfiguration.toJSON(message.groundPrep);
    }
    if (message.laserWeed !== undefined) {
      obj.laserWeed = LaserWeedJobConfiguration.toJSON(message.laserWeed);
    }
    if (message.transport !== undefined) {
      obj.transport = TransportJobConfiguration.toJSON(message.transport);
    }
    if (message.inSeason !== undefined) {
      obj.inSeason = InSeasonJobConfiguration.toJSON(message.inSeason);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CreateJobRequest>, I>>(base?: I): CreateJobRequest {
    return CreateJobRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CreateJobRequest>, I>>(object: I): CreateJobRequest {
    const message = createBaseCreateJobRequest();
    message.type = object.type ?? 0;
    message.name = object.name ?? "";
    message.farmId = object.farmId ?? "";
    message.fieldId = object.fieldId ?? "";
    message.customerId = object.customerId ?? "";
    message.priority = object.priority ?? 0;
    message.generateObjectives = object.generateObjectives ?? false;
    message.dryRun = object.dryRun ?? false;
    message.groundPrep = (object.groundPrep !== undefined && object.groundPrep !== null)
      ? GroundPrepJobConfiguration.fromPartial(object.groundPrep)
      : undefined;
    message.laserWeed = (object.laserWeed !== undefined && object.laserWeed !== null)
      ? LaserWeedJobConfiguration.fromPartial(object.laserWeed)
      : undefined;
    message.transport = (object.transport !== undefined && object.transport !== null)
      ? TransportJobConfiguration.fromPartial(object.transport)
      : undefined;
    message.inSeason = (object.inSeason !== undefined && object.inSeason !== null)
      ? InSeasonJobConfiguration.fromPartial(object.inSeason)
      : undefined;
    return message;
  },
};

function createBaseCreateJobsRequest(): CreateJobsRequest {
  return { jobRequests: [] };
}

export const CreateJobsRequest: MessageFns<CreateJobsRequest> = {
  encode(message: CreateJobsRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.jobRequests) {
      CreateJobRequest.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CreateJobsRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCreateJobsRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.jobRequests.push(CreateJobRequest.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CreateJobsRequest {
    return {
      jobRequests: globalThis.Array.isArray(object?.jobRequests)
        ? object.jobRequests.map((e: any) => CreateJobRequest.fromJSON(e))
        : globalThis.Array.isArray(object?.job_requests)
        ? object.job_requests.map((e: any) => CreateJobRequest.fromJSON(e))
        : [],
    };
  },

  toJSON(message: CreateJobsRequest): unknown {
    const obj: any = {};
    if (message.jobRequests?.length) {
      obj.jobRequests = message.jobRequests.map((e) => CreateJobRequest.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CreateJobsRequest>, I>>(base?: I): CreateJobsRequest {
    return CreateJobsRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CreateJobsRequest>, I>>(object: I): CreateJobsRequest {
    const message = createBaseCreateJobsRequest();
    message.jobRequests = object.jobRequests?.map((e) => CreateJobRequest.fromPartial(e)) || [];
    return message;
  },
};

function createBaseCloneJobRequest(): CloneJobRequest {
  return { name: "" };
}

export const CloneJobRequest: MessageFns<CloneJobRequest> = {
  encode(message: CloneJobRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.name !== "") {
      writer.uint32(10).string(message.name);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CloneJobRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCloneJobRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.name = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CloneJobRequest {
    return { name: isSet(object.name) ? globalThis.String(object.name) : "" };
  },

  toJSON(message: CloneJobRequest): unknown {
    const obj: any = {};
    if (message.name !== "") {
      obj.name = message.name;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CloneJobRequest>, I>>(base?: I): CloneJobRequest {
    return CloneJobRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CloneJobRequest>, I>>(object: I): CloneJobRequest {
    const message = createBaseCloneJobRequest();
    message.name = object.name ?? "";
    return message;
  },
};

function createBaseCloneJobResponse(): CloneJobResponse {
  return { job: undefined };
}

export const CloneJobResponse: MessageFns<CloneJobResponse> = {
  encode(message: CloneJobResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.job !== undefined) {
      Job.encode(message.job, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CloneJobResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCloneJobResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.job = Job.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CloneJobResponse {
    return { job: isSet(object.job) ? Job.fromJSON(object.job) : undefined };
  },

  toJSON(message: CloneJobResponse): unknown {
    const obj: any = {};
    if (message.job !== undefined) {
      obj.job = Job.toJSON(message.job);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CloneJobResponse>, I>>(base?: I): CloneJobResponse {
    return CloneJobResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CloneJobResponse>, I>>(object: I): CloneJobResponse {
    const message = createBaseCloneJobResponse();
    message.job = (object.job !== undefined && object.job !== null) ? Job.fromPartial(object.job) : undefined;
    return message;
  },
};

function createBaseJobList(): JobList {
  return { jobs: [] };
}

export const JobList: MessageFns<JobList> = {
  encode(message: JobList, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.jobs) {
      Job.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): JobList {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseJobList();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.jobs.push(Job.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): JobList {
    return { jobs: globalThis.Array.isArray(object?.jobs) ? object.jobs.map((e: any) => Job.fromJSON(e)) : [] };
  },

  toJSON(message: JobList): unknown {
    const obj: any = {};
    if (message.jobs?.length) {
      obj.jobs = message.jobs.map((e) => Job.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<JobList>, I>>(base?: I): JobList {
    return JobList.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<JobList>, I>>(object: I): JobList {
    const message = createBaseJobList();
    message.jobs = object.jobs?.map((e) => Job.fromPartial(e)) || [];
    return message;
  },
};

function createBaseListJobsResponse(): ListJobsResponse {
  return { pageToken: "", jobs: [] };
}

export const ListJobsResponse: MessageFns<ListJobsResponse> = {
  encode(message: ListJobsResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.pageToken !== "") {
      writer.uint32(10).string(message.pageToken);
    }
    for (const v of message.jobs) {
      Job.encode(v!, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ListJobsResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseListJobsResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.pageToken = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.jobs.push(Job.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ListJobsResponse {
    return {
      pageToken: isSet(object.pageToken)
        ? globalThis.String(object.pageToken)
        : isSet(object.page_token)
        ? globalThis.String(object.page_token)
        : "",
      jobs: globalThis.Array.isArray(object?.jobs) ? object.jobs.map((e: any) => Job.fromJSON(e)) : [],
    };
  },

  toJSON(message: ListJobsResponse): unknown {
    const obj: any = {};
    if (message.pageToken !== "") {
      obj.pageToken = message.pageToken;
    }
    if (message.jobs?.length) {
      obj.jobs = message.jobs.map((e) => Job.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ListJobsResponse>, I>>(base?: I): ListJobsResponse {
    return ListJobsResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ListJobsResponse>, I>>(object: I): ListJobsResponse {
    const message = createBaseListJobsResponse();
    message.pageToken = object.pageToken ?? "";
    message.jobs = object.jobs?.map((e) => Job.fromPartial(e)) || [];
    return message;
  },
};

function createBaseJobState(): JobState {
  return { state: 0 };
}

export const JobState: MessageFns<JobState> = {
  encode(message: JobState, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.state !== 0) {
      writer.uint32(8).int32(message.state);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): JobState {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseJobState();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.state = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): JobState {
    return { state: isSet(object.state) ? stateFromJSON(object.state) : 0 };
  },

  toJSON(message: JobState): unknown {
    const obj: any = {};
    if (message.state !== 0) {
      obj.state = stateToJSON(message.state);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<JobState>, I>>(base?: I): JobState {
    return JobState.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<JobState>, I>>(object: I): JobState {
    const message = createBaseJobState();
    message.state = object.state ?? 0;
    return message;
  },
};

function createBaseRobotJobAssignment(): RobotJobAssignment {
  return { jobId: 0 };
}

export const RobotJobAssignment: MessageFns<RobotJobAssignment> = {
  encode(message: RobotJobAssignment, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.jobId !== 0) {
      writer.uint32(8).uint64(message.jobId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RobotJobAssignment {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRobotJobAssignment();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.jobId = longToNumber(reader.uint64());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RobotJobAssignment {
    return {
      jobId: isSet(object.jobId)
        ? globalThis.Number(object.jobId)
        : isSet(object.job_id)
        ? globalThis.Number(object.job_id)
        : 0,
    };
  },

  toJSON(message: RobotJobAssignment): unknown {
    const obj: any = {};
    if (message.jobId !== 0) {
      obj.jobId = Math.round(message.jobId);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<RobotJobAssignment>, I>>(base?: I): RobotJobAssignment {
    return RobotJobAssignment.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<RobotJobAssignment>, I>>(object: I): RobotJobAssignment {
    const message = createBaseRobotJobAssignment();
    message.jobId = object.jobId ?? 0;
    return message;
  },
};

function createBaseJobRobot(): JobRobot {
  return { robotSerial: "", createdAt: undefined, updatedAt: undefined, lastSeen: undefined, objectiveId: 0, jobId: 0 };
}

export const JobRobot: MessageFns<JobRobot> = {
  encode(message: JobRobot, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.robotSerial !== "") {
      writer.uint32(10).string(message.robotSerial);
    }
    if (message.createdAt !== undefined) {
      Timestamp.encode(toTimestamp(message.createdAt), writer.uint32(18).fork()).join();
    }
    if (message.updatedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.updatedAt), writer.uint32(26).fork()).join();
    }
    if (message.lastSeen !== undefined) {
      Timestamp.encode(toTimestamp(message.lastSeen), writer.uint32(34).fork()).join();
    }
    if (message.objectiveId !== 0) {
      writer.uint32(40).uint64(message.objectiveId);
    }
    if (message.jobId !== 0) {
      writer.uint32(48).uint64(message.jobId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): JobRobot {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseJobRobot();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.robotSerial = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.createdAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.updatedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.lastSeen = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.objectiveId = longToNumber(reader.uint64());
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.jobId = longToNumber(reader.uint64());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): JobRobot {
    return {
      robotSerial: isSet(object.robotSerial)
        ? globalThis.String(object.robotSerial)
        : isSet(object.robot_serial)
        ? globalThis.String(object.robot_serial)
        : "",
      createdAt: isSet(object.createdAt)
        ? globalThis.String(object.createdAt)
        : isSet(object.created_at)
        ? globalThis.String(object.created_at)
        : undefined,
      updatedAt: isSet(object.updatedAt)
        ? globalThis.String(object.updatedAt)
        : isSet(object.updated_at)
        ? globalThis.String(object.updated_at)
        : undefined,
      lastSeen: isSet(object.lastSeen)
        ? globalThis.String(object.lastSeen)
        : isSet(object.last_seen)
        ? globalThis.String(object.last_seen)
        : undefined,
      objectiveId: isSet(object.objectiveId)
        ? globalThis.Number(object.objectiveId)
        : isSet(object.objective_id)
        ? globalThis.Number(object.objective_id)
        : 0,
      jobId: isSet(object.jobId)
        ? globalThis.Number(object.jobId)
        : isSet(object.job_id)
        ? globalThis.Number(object.job_id)
        : 0,
    };
  },

  toJSON(message: JobRobot): unknown {
    const obj: any = {};
    if (message.robotSerial !== "") {
      obj.robotSerial = message.robotSerial;
    }
    if (message.createdAt !== undefined) {
      obj.createdAt = message.createdAt;
    }
    if (message.updatedAt !== undefined) {
      obj.updatedAt = message.updatedAt;
    }
    if (message.lastSeen !== undefined) {
      obj.lastSeen = message.lastSeen;
    }
    if (message.objectiveId !== 0) {
      obj.objectiveId = Math.round(message.objectiveId);
    }
    if (message.jobId !== 0) {
      obj.jobId = Math.round(message.jobId);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<JobRobot>, I>>(base?: I): JobRobot {
    return JobRobot.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<JobRobot>, I>>(object: I): JobRobot {
    const message = createBaseJobRobot();
    message.robotSerial = object.robotSerial ?? "";
    message.createdAt = object.createdAt ?? undefined;
    message.updatedAt = object.updatedAt ?? undefined;
    message.lastSeen = object.lastSeen ?? undefined;
    message.objectiveId = object.objectiveId ?? 0;
    message.jobId = object.jobId ?? 0;
    return message;
  },
};

function createBaseListJobRobotsResponse(): ListJobRobotsResponse {
  return { pageToken: "", robots: [] };
}

export const ListJobRobotsResponse: MessageFns<ListJobRobotsResponse> = {
  encode(message: ListJobRobotsResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.pageToken !== "") {
      writer.uint32(10).string(message.pageToken);
    }
    for (const v of message.robots) {
      JobRobot.encode(v!, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ListJobRobotsResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseListJobRobotsResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.pageToken = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.robots.push(JobRobot.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ListJobRobotsResponse {
    return {
      pageToken: isSet(object.pageToken)
        ? globalThis.String(object.pageToken)
        : isSet(object.page_token)
        ? globalThis.String(object.page_token)
        : "",
      robots: globalThis.Array.isArray(object?.robots) ? object.robots.map((e: any) => JobRobot.fromJSON(e)) : [],
    };
  },

  toJSON(message: ListJobRobotsResponse): unknown {
    const obj: any = {};
    if (message.pageToken !== "") {
      obj.pageToken = message.pageToken;
    }
    if (message.robots?.length) {
      obj.robots = message.robots.map((e) => JobRobot.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ListJobRobotsResponse>, I>>(base?: I): ListJobRobotsResponse {
    return ListJobRobotsResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ListJobRobotsResponse>, I>>(object: I): ListJobRobotsResponse {
    const message = createBaseListJobRobotsResponse();
    message.pageToken = object.pageToken ?? "";
    message.robots = object.robots?.map((e) => JobRobot.fromPartial(e)) || [];
    return message;
  },
};

function createBaseWorkOrder(): WorkOrder {
  return { id: 0, name: "", scheduledAt: undefined, durationMinutes: 0, jobs: [], state: 0 };
}

export const WorkOrder: MessageFns<WorkOrder> = {
  encode(message: WorkOrder, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== 0) {
      writer.uint32(8).uint64(message.id);
    }
    if (message.name !== "") {
      writer.uint32(18).string(message.name);
    }
    if (message.scheduledAt !== undefined) {
      Timestamp.encode(toTimestamp(message.scheduledAt), writer.uint32(26).fork()).join();
    }
    if (message.durationMinutes !== 0) {
      writer.uint32(32).int32(message.durationMinutes);
    }
    for (const v of message.jobs) {
      Job.encode(v!, writer.uint32(42).fork()).join();
    }
    if (message.state !== 0) {
      writer.uint32(48).int32(message.state);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): WorkOrder {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseWorkOrder();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.id = longToNumber(reader.uint64());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.scheduledAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.durationMinutes = reader.int32();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.jobs.push(Job.decode(reader, reader.uint32()));
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.state = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): WorkOrder {
    return {
      id: isSet(object.id) ? globalThis.Number(object.id) : 0,
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      scheduledAt: isSet(object.scheduledAt)
        ? globalThis.String(object.scheduledAt)
        : isSet(object.scheduled_at)
        ? globalThis.String(object.scheduled_at)
        : undefined,
      durationMinutes: isSet(object.durationMinutes)
        ? globalThis.Number(object.durationMinutes)
        : isSet(object.duration_minutes)
        ? globalThis.Number(object.duration_minutes)
        : 0,
      jobs: globalThis.Array.isArray(object?.jobs) ? object.jobs.map((e: any) => Job.fromJSON(e)) : [],
      state: isSet(object.state) ? stateFromJSON(object.state) : 0,
    };
  },

  toJSON(message: WorkOrder): unknown {
    const obj: any = {};
    if (message.id !== 0) {
      obj.id = Math.round(message.id);
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.scheduledAt !== undefined) {
      obj.scheduledAt = message.scheduledAt;
    }
    if (message.durationMinutes !== 0) {
      obj.durationMinutes = Math.round(message.durationMinutes);
    }
    if (message.jobs?.length) {
      obj.jobs = message.jobs.map((e) => Job.toJSON(e));
    }
    if (message.state !== 0) {
      obj.state = stateToJSON(message.state);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<WorkOrder>, I>>(base?: I): WorkOrder {
    return WorkOrder.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<WorkOrder>, I>>(object: I): WorkOrder {
    const message = createBaseWorkOrder();
    message.id = object.id ?? 0;
    message.name = object.name ?? "";
    message.scheduledAt = object.scheduledAt ?? undefined;
    message.durationMinutes = object.durationMinutes ?? 0;
    message.jobs = object.jobs?.map((e) => Job.fromPartial(e)) || [];
    message.state = object.state ?? 0;
    return message;
  },
};

function createBaseWorkOrderList(): WorkOrderList {
  return { workOrders: [] };
}

export const WorkOrderList: MessageFns<WorkOrderList> = {
  encode(message: WorkOrderList, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.workOrders) {
      WorkOrder.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): WorkOrderList {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseWorkOrderList();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.workOrders.push(WorkOrder.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): WorkOrderList {
    return {
      workOrders: globalThis.Array.isArray(object?.workOrders)
        ? object.workOrders.map((e: any) => WorkOrder.fromJSON(e))
        : globalThis.Array.isArray(object?.work_orders)
        ? object.work_orders.map((e: any) => WorkOrder.fromJSON(e))
        : [],
    };
  },

  toJSON(message: WorkOrderList): unknown {
    const obj: any = {};
    if (message.workOrders?.length) {
      obj.workOrders = message.workOrders.map((e) => WorkOrder.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<WorkOrderList>, I>>(base?: I): WorkOrderList {
    return WorkOrderList.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<WorkOrderList>, I>>(object: I): WorkOrderList {
    const message = createBaseWorkOrderList();
    message.workOrders = object.workOrders?.map((e) => WorkOrder.fromPartial(e)) || [];
    return message;
  },
};

function createBaseListWorkOrdersResponse(): ListWorkOrdersResponse {
  return { pageToken: "", workOrders: [] };
}

export const ListWorkOrdersResponse: MessageFns<ListWorkOrdersResponse> = {
  encode(message: ListWorkOrdersResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.pageToken !== "") {
      writer.uint32(10).string(message.pageToken);
    }
    for (const v of message.workOrders) {
      WorkOrder.encode(v!, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ListWorkOrdersResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseListWorkOrdersResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.pageToken = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.workOrders.push(WorkOrder.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ListWorkOrdersResponse {
    return {
      pageToken: isSet(object.pageToken)
        ? globalThis.String(object.pageToken)
        : isSet(object.page_token)
        ? globalThis.String(object.page_token)
        : "",
      workOrders: globalThis.Array.isArray(object?.workOrders)
        ? object.workOrders.map((e: any) => WorkOrder.fromJSON(e))
        : globalThis.Array.isArray(object?.work_orders)
        ? object.work_orders.map((e: any) => WorkOrder.fromJSON(e))
        : [],
    };
  },

  toJSON(message: ListWorkOrdersResponse): unknown {
    const obj: any = {};
    if (message.pageToken !== "") {
      obj.pageToken = message.pageToken;
    }
    if (message.workOrders?.length) {
      obj.workOrders = message.workOrders.map((e) => WorkOrder.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ListWorkOrdersResponse>, I>>(base?: I): ListWorkOrdersResponse {
    return ListWorkOrdersResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ListWorkOrdersResponse>, I>>(object: I): ListWorkOrdersResponse {
    const message = createBaseListWorkOrdersResponse();
    message.pageToken = object.pageToken ?? "";
    message.workOrders = object.workOrders?.map((e) => WorkOrder.fromPartial(e)) || [];
    return message;
  },
};

function createBaseChecklistDefinition(): ChecklistDefinition {
  return { id: 0, createdAt: undefined, updatedAt: undefined, content: undefined, items: [] };
}

export const ChecklistDefinition: MessageFns<ChecklistDefinition> = {
  encode(message: ChecklistDefinition, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== 0) {
      writer.uint32(8).uint64(message.id);
    }
    if (message.createdAt !== undefined) {
      Timestamp.encode(toTimestamp(message.createdAt), writer.uint32(18).fork()).join();
    }
    if (message.updatedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.updatedAt), writer.uint32(26).fork()).join();
    }
    if (message.content !== undefined) {
      ChecklistContent.encode(message.content, writer.uint32(34).fork()).join();
    }
    for (const v of message.items) {
      ChecklistItemDefinition.encode(v!, writer.uint32(42).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ChecklistDefinition {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseChecklistDefinition();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.id = longToNumber(reader.uint64());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.createdAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.updatedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.content = ChecklistContent.decode(reader, reader.uint32());
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.items.push(ChecklistItemDefinition.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ChecklistDefinition {
    return {
      id: isSet(object.id) ? globalThis.Number(object.id) : 0,
      createdAt: isSet(object.createdAt)
        ? globalThis.String(object.createdAt)
        : isSet(object.created_at)
        ? globalThis.String(object.created_at)
        : undefined,
      updatedAt: isSet(object.updatedAt)
        ? globalThis.String(object.updatedAt)
        : isSet(object.updated_at)
        ? globalThis.String(object.updated_at)
        : undefined,
      content: isSet(object.content) ? ChecklistContent.fromJSON(object.content) : undefined,
      items: globalThis.Array.isArray(object?.items)
        ? object.items.map((e: any) => ChecklistItemDefinition.fromJSON(e))
        : [],
    };
  },

  toJSON(message: ChecklistDefinition): unknown {
    const obj: any = {};
    if (message.id !== 0) {
      obj.id = Math.round(message.id);
    }
    if (message.createdAt !== undefined) {
      obj.createdAt = message.createdAt;
    }
    if (message.updatedAt !== undefined) {
      obj.updatedAt = message.updatedAt;
    }
    if (message.content !== undefined) {
      obj.content = ChecklistContent.toJSON(message.content);
    }
    if (message.items?.length) {
      obj.items = message.items.map((e) => ChecklistItemDefinition.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ChecklistDefinition>, I>>(base?: I): ChecklistDefinition {
    return ChecklistDefinition.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ChecklistDefinition>, I>>(object: I): ChecklistDefinition {
    const message = createBaseChecklistDefinition();
    message.id = object.id ?? 0;
    message.createdAt = object.createdAt ?? undefined;
    message.updatedAt = object.updatedAt ?? undefined;
    message.content = (object.content !== undefined && object.content !== null)
      ? ChecklistContent.fromPartial(object.content)
      : undefined;
    message.items = object.items?.map((e) => ChecklistItemDefinition.fromPartial(e)) || [];
    return message;
  },
};

function createBaseChecklistContent(): ChecklistContent {
  return { name: "", description: "" };
}

export const ChecklistContent: MessageFns<ChecklistContent> = {
  encode(message: ChecklistContent, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.name !== "") {
      writer.uint32(10).string(message.name);
    }
    if (message.description !== "") {
      writer.uint32(18).string(message.description);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ChecklistContent {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseChecklistContent();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.description = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ChecklistContent {
    return {
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      description: isSet(object.description) ? globalThis.String(object.description) : "",
    };
  },

  toJSON(message: ChecklistContent): unknown {
    const obj: any = {};
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.description !== "") {
      obj.description = message.description;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ChecklistContent>, I>>(base?: I): ChecklistContent {
    return ChecklistContent.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ChecklistContent>, I>>(object: I): ChecklistContent {
    const message = createBaseChecklistContent();
    message.name = object.name ?? "";
    message.description = object.description ?? "";
    return message;
  },
};

function createBaseChecklistDefinitionList(): ChecklistDefinitionList {
  return { checklistDefinitions: [] };
}

export const ChecklistDefinitionList: MessageFns<ChecklistDefinitionList> = {
  encode(message: ChecklistDefinitionList, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.checklistDefinitions) {
      ChecklistDefinition.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ChecklistDefinitionList {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseChecklistDefinitionList();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.checklistDefinitions.push(ChecklistDefinition.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ChecklistDefinitionList {
    return {
      checklistDefinitions: globalThis.Array.isArray(object?.checklistDefinitions)
        ? object.checklistDefinitions.map((e: any) => ChecklistDefinition.fromJSON(e))
        : globalThis.Array.isArray(object?.checklist_definitions)
        ? object.checklist_definitions.map((e: any) => ChecklistDefinition.fromJSON(e))
        : [],
    };
  },

  toJSON(message: ChecklistDefinitionList): unknown {
    const obj: any = {};
    if (message.checklistDefinitions?.length) {
      obj.checklistDefinitions = message.checklistDefinitions.map((e) => ChecklistDefinition.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ChecklistDefinitionList>, I>>(base?: I): ChecklistDefinitionList {
    return ChecklistDefinitionList.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ChecklistDefinitionList>, I>>(object: I): ChecklistDefinitionList {
    const message = createBaseChecklistDefinitionList();
    message.checklistDefinitions = object.checklistDefinitions?.map((e) => ChecklistDefinition.fromPartial(e)) || [];
    return message;
  },
};

function createBaseListChecklistDefinitionsResponse(): ListChecklistDefinitionsResponse {
  return { pageToken: "", checklistDefinitions: [] };
}

export const ListChecklistDefinitionsResponse: MessageFns<ListChecklistDefinitionsResponse> = {
  encode(message: ListChecklistDefinitionsResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.pageToken !== "") {
      writer.uint32(10).string(message.pageToken);
    }
    for (const v of message.checklistDefinitions) {
      ChecklistDefinition.encode(v!, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ListChecklistDefinitionsResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseListChecklistDefinitionsResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.pageToken = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.checklistDefinitions.push(ChecklistDefinition.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ListChecklistDefinitionsResponse {
    return {
      pageToken: isSet(object.pageToken)
        ? globalThis.String(object.pageToken)
        : isSet(object.page_token)
        ? globalThis.String(object.page_token)
        : "",
      checklistDefinitions: globalThis.Array.isArray(object?.checklistDefinitions)
        ? object.checklistDefinitions.map((e: any) => ChecklistDefinition.fromJSON(e))
        : globalThis.Array.isArray(object?.checklist_definitions)
        ? object.checklist_definitions.map((e: any) => ChecklistDefinition.fromJSON(e))
        : [],
    };
  },

  toJSON(message: ListChecklistDefinitionsResponse): unknown {
    const obj: any = {};
    if (message.pageToken !== "") {
      obj.pageToken = message.pageToken;
    }
    if (message.checklistDefinitions?.length) {
      obj.checklistDefinitions = message.checklistDefinitions.map((e) => ChecklistDefinition.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ListChecklistDefinitionsResponse>, I>>(
    base?: I,
  ): ListChecklistDefinitionsResponse {
    return ListChecklistDefinitionsResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ListChecklistDefinitionsResponse>, I>>(
    object: I,
  ): ListChecklistDefinitionsResponse {
    const message = createBaseListChecklistDefinitionsResponse();
    message.pageToken = object.pageToken ?? "";
    message.checklistDefinitions = object.checklistDefinitions?.map((e) => ChecklistDefinition.fromPartial(e)) || [];
    return message;
  },
};

function createBaseChecklistItemDefinition(): ChecklistItemDefinition {
  return { id: 0, createdAt: undefined, updatedAt: undefined, checklistDefinitionId: 0, content: undefined };
}

export const ChecklistItemDefinition: MessageFns<ChecklistItemDefinition> = {
  encode(message: ChecklistItemDefinition, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== 0) {
      writer.uint32(8).uint64(message.id);
    }
    if (message.createdAt !== undefined) {
      Timestamp.encode(toTimestamp(message.createdAt), writer.uint32(18).fork()).join();
    }
    if (message.updatedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.updatedAt), writer.uint32(26).fork()).join();
    }
    if (message.checklistDefinitionId !== 0) {
      writer.uint32(32).uint64(message.checklistDefinitionId);
    }
    if (message.content !== undefined) {
      ChecklistItemContent.encode(message.content, writer.uint32(42).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ChecklistItemDefinition {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseChecklistItemDefinition();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.id = longToNumber(reader.uint64());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.createdAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.updatedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.checklistDefinitionId = longToNumber(reader.uint64());
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.content = ChecklistItemContent.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ChecklistItemDefinition {
    return {
      id: isSet(object.id) ? globalThis.Number(object.id) : 0,
      createdAt: isSet(object.createdAt)
        ? globalThis.String(object.createdAt)
        : isSet(object.created_at)
        ? globalThis.String(object.created_at)
        : undefined,
      updatedAt: isSet(object.updatedAt)
        ? globalThis.String(object.updatedAt)
        : isSet(object.updated_at)
        ? globalThis.String(object.updated_at)
        : undefined,
      checklistDefinitionId: isSet(object.checklistDefinitionId)
        ? globalThis.Number(object.checklistDefinitionId)
        : isSet(object.checklist_definition_id)
        ? globalThis.Number(object.checklist_definition_id)
        : 0,
      content: isSet(object.content) ? ChecklistItemContent.fromJSON(object.content) : undefined,
    };
  },

  toJSON(message: ChecklistItemDefinition): unknown {
    const obj: any = {};
    if (message.id !== 0) {
      obj.id = Math.round(message.id);
    }
    if (message.createdAt !== undefined) {
      obj.createdAt = message.createdAt;
    }
    if (message.updatedAt !== undefined) {
      obj.updatedAt = message.updatedAt;
    }
    if (message.checklistDefinitionId !== 0) {
      obj.checklistDefinitionId = Math.round(message.checklistDefinitionId);
    }
    if (message.content !== undefined) {
      obj.content = ChecklistItemContent.toJSON(message.content);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ChecklistItemDefinition>, I>>(base?: I): ChecklistItemDefinition {
    return ChecklistItemDefinition.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ChecklistItemDefinition>, I>>(object: I): ChecklistItemDefinition {
    const message = createBaseChecklistItemDefinition();
    message.id = object.id ?? 0;
    message.createdAt = object.createdAt ?? undefined;
    message.updatedAt = object.updatedAt ?? undefined;
    message.checklistDefinitionId = object.checklistDefinitionId ?? 0;
    message.content = (object.content !== undefined && object.content !== null)
      ? ChecklistItemContent.fromPartial(object.content)
      : undefined;
    return message;
  },
};

function createBaseChecklistItemContent(): ChecklistItemContent {
  return { translationKey: "", label: "", automationCode: 0, position: 0 };
}

export const ChecklistItemContent: MessageFns<ChecklistItemContent> = {
  encode(message: ChecklistItemContent, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.translationKey !== "") {
      writer.uint32(10).string(message.translationKey);
    }
    if (message.label !== "") {
      writer.uint32(18).string(message.label);
    }
    if (message.automationCode !== 0) {
      writer.uint32(24).int32(message.automationCode);
    }
    if (message.position !== 0) {
      writer.uint32(37).float(message.position);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ChecklistItemContent {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseChecklistItemContent();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.translationKey = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.label = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.automationCode = reader.int32() as any;
          continue;
        }
        case 4: {
          if (tag !== 37) {
            break;
          }

          message.position = reader.float();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ChecklistItemContent {
    return {
      translationKey: isSet(object.translationKey)
        ? globalThis.String(object.translationKey)
        : isSet(object.translation_key)
        ? globalThis.String(object.translation_key)
        : "",
      label: isSet(object.label) ? globalThis.String(object.label) : "",
      automationCode: isSet(object.automationCode)
        ? checklistAutomationCodeFromJSON(object.automationCode)
        : isSet(object.automation_code)
        ? checklistAutomationCodeFromJSON(object.automation_code)
        : 0,
      position: isSet(object.position) ? globalThis.Number(object.position) : 0,
    };
  },

  toJSON(message: ChecklistItemContent): unknown {
    const obj: any = {};
    if (message.translationKey !== "") {
      obj.translationKey = message.translationKey;
    }
    if (message.label !== "") {
      obj.label = message.label;
    }
    if (message.automationCode !== 0) {
      obj.automationCode = checklistAutomationCodeToJSON(message.automationCode);
    }
    if (message.position !== 0) {
      obj.position = message.position;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ChecklistItemContent>, I>>(base?: I): ChecklistItemContent {
    return ChecklistItemContent.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ChecklistItemContent>, I>>(object: I): ChecklistItemContent {
    const message = createBaseChecklistItemContent();
    message.translationKey = object.translationKey ?? "";
    message.label = object.label ?? "";
    message.automationCode = object.automationCode ?? 0;
    message.position = object.position ?? 0;
    return message;
  },
};

function createBaseChecklistItemDefinitionList(): ChecklistItemDefinitionList {
  return { itemDefinitions: [] };
}

export const ChecklistItemDefinitionList: MessageFns<ChecklistItemDefinitionList> = {
  encode(message: ChecklistItemDefinitionList, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.itemDefinitions) {
      ChecklistItemDefinition.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ChecklistItemDefinitionList {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseChecklistItemDefinitionList();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.itemDefinitions.push(ChecklistItemDefinition.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ChecklistItemDefinitionList {
    return {
      itemDefinitions: globalThis.Array.isArray(object?.itemDefinitions)
        ? object.itemDefinitions.map((e: any) => ChecklistItemDefinition.fromJSON(e))
        : globalThis.Array.isArray(object?.item_definitions)
        ? object.item_definitions.map((e: any) => ChecklistItemDefinition.fromJSON(e))
        : [],
    };
  },

  toJSON(message: ChecklistItemDefinitionList): unknown {
    const obj: any = {};
    if (message.itemDefinitions?.length) {
      obj.itemDefinitions = message.itemDefinitions.map((e) => ChecklistItemDefinition.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ChecklistItemDefinitionList>, I>>(base?: I): ChecklistItemDefinitionList {
    return ChecklistItemDefinitionList.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ChecklistItemDefinitionList>, I>>(object: I): ChecklistItemDefinitionList {
    const message = createBaseChecklistItemDefinitionList();
    message.itemDefinitions = object.itemDefinitions?.map((e) => ChecklistItemDefinition.fromPartial(e)) || [];
    return message;
  },
};

function createBaseChecklist(): Checklist {
  return {
    id: 0,
    robotSerial: "",
    createdAt: undefined,
    updatedAt: undefined,
    content: undefined,
    completedAt: undefined,
    completedBy: "",
    items: [],
    fieldId: "",
    validDuration: undefined,
    expiresAt: undefined,
    valid: false,
    createdBy: "",
  };
}

export const Checklist: MessageFns<Checklist> = {
  encode(message: Checklist, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== 0) {
      writer.uint32(8).uint64(message.id);
    }
    if (message.robotSerial !== "") {
      writer.uint32(18).string(message.robotSerial);
    }
    if (message.createdAt !== undefined) {
      Timestamp.encode(toTimestamp(message.createdAt), writer.uint32(26).fork()).join();
    }
    if (message.updatedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.updatedAt), writer.uint32(34).fork()).join();
    }
    if (message.content !== undefined) {
      ChecklistContent.encode(message.content, writer.uint32(42).fork()).join();
    }
    if (message.completedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.completedAt), writer.uint32(50).fork()).join();
    }
    if (message.completedBy !== "") {
      writer.uint32(58).string(message.completedBy);
    }
    for (const v of message.items) {
      ChecklistItem.encode(v!, writer.uint32(66).fork()).join();
    }
    if (message.fieldId !== "") {
      writer.uint32(74).string(message.fieldId);
    }
    if (message.validDuration !== undefined) {
      Duration.encode(message.validDuration, writer.uint32(82).fork()).join();
    }
    if (message.expiresAt !== undefined) {
      Timestamp.encode(toTimestamp(message.expiresAt), writer.uint32(90).fork()).join();
    }
    if (message.valid !== false) {
      writer.uint32(96).bool(message.valid);
    }
    if (message.createdBy !== "") {
      writer.uint32(106).string(message.createdBy);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Checklist {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseChecklist();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.id = longToNumber(reader.uint64());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.robotSerial = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.createdAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.updatedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.content = ChecklistContent.decode(reader, reader.uint32());
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.completedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.completedBy = reader.string();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.items.push(ChecklistItem.decode(reader, reader.uint32()));
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.fieldId = reader.string();
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.validDuration = Duration.decode(reader, reader.uint32());
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.expiresAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 12: {
          if (tag !== 96) {
            break;
          }

          message.valid = reader.bool();
          continue;
        }
        case 13: {
          if (tag !== 106) {
            break;
          }

          message.createdBy = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Checklist {
    return {
      id: isSet(object.id) ? globalThis.Number(object.id) : 0,
      robotSerial: isSet(object.robotSerial)
        ? globalThis.String(object.robotSerial)
        : isSet(object.robot_serial)
        ? globalThis.String(object.robot_serial)
        : "",
      createdAt: isSet(object.createdAt)
        ? globalThis.String(object.createdAt)
        : isSet(object.created_at)
        ? globalThis.String(object.created_at)
        : undefined,
      updatedAt: isSet(object.updatedAt)
        ? globalThis.String(object.updatedAt)
        : isSet(object.updated_at)
        ? globalThis.String(object.updated_at)
        : undefined,
      content: isSet(object.content) ? ChecklistContent.fromJSON(object.content) : undefined,
      completedAt: isSet(object.completedAt)
        ? globalThis.String(object.completedAt)
        : isSet(object.completed_at)
        ? globalThis.String(object.completed_at)
        : undefined,
      completedBy: isSet(object.completedBy)
        ? globalThis.String(object.completedBy)
        : isSet(object.completed_by)
        ? globalThis.String(object.completed_by)
        : "",
      items: globalThis.Array.isArray(object?.items)
        ? object.items.map((e: any) => ChecklistItem.fromJSON(e))
        : [],
      fieldId: isSet(object.fieldId)
        ? globalThis.String(object.fieldId)
        : isSet(object.field_id)
        ? globalThis.String(object.field_id)
        : "",
      validDuration: isSet(object.validDuration)
        ? Duration.fromJSON(object.validDuration)
        : isSet(object.valid_duration)
        ? Duration.fromJSON(object.valid_duration)
        : undefined,
      expiresAt: isSet(object.expiresAt)
        ? globalThis.String(object.expiresAt)
        : isSet(object.expires_at)
        ? globalThis.String(object.expires_at)
        : undefined,
      valid: isSet(object.valid) ? globalThis.Boolean(object.valid) : false,
      createdBy: isSet(object.createdBy)
        ? globalThis.String(object.createdBy)
        : isSet(object.created_by)
        ? globalThis.String(object.created_by)
        : "",
    };
  },

  toJSON(message: Checklist): unknown {
    const obj: any = {};
    if (message.id !== 0) {
      obj.id = Math.round(message.id);
    }
    if (message.robotSerial !== "") {
      obj.robotSerial = message.robotSerial;
    }
    if (message.createdAt !== undefined) {
      obj.createdAt = message.createdAt;
    }
    if (message.updatedAt !== undefined) {
      obj.updatedAt = message.updatedAt;
    }
    if (message.content !== undefined) {
      obj.content = ChecklistContent.toJSON(message.content);
    }
    if (message.completedAt !== undefined) {
      obj.completedAt = message.completedAt;
    }
    if (message.completedBy !== "") {
      obj.completedBy = message.completedBy;
    }
    if (message.items?.length) {
      obj.items = message.items.map((e) => ChecklistItem.toJSON(e));
    }
    if (message.fieldId !== "") {
      obj.fieldId = message.fieldId;
    }
    if (message.validDuration !== undefined) {
      obj.validDuration = Duration.toJSON(message.validDuration);
    }
    if (message.expiresAt !== undefined) {
      obj.expiresAt = message.expiresAt;
    }
    if (message.valid !== false) {
      obj.valid = message.valid;
    }
    if (message.createdBy !== "") {
      obj.createdBy = message.createdBy;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Checklist>, I>>(base?: I): Checklist {
    return Checklist.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Checklist>, I>>(object: I): Checklist {
    const message = createBaseChecklist();
    message.id = object.id ?? 0;
    message.robotSerial = object.robotSerial ?? "";
    message.createdAt = object.createdAt ?? undefined;
    message.updatedAt = object.updatedAt ?? undefined;
    message.content = (object.content !== undefined && object.content !== null)
      ? ChecklistContent.fromPartial(object.content)
      : undefined;
    message.completedAt = object.completedAt ?? undefined;
    message.completedBy = object.completedBy ?? "";
    message.items = object.items?.map((e) => ChecklistItem.fromPartial(e)) || [];
    message.fieldId = object.fieldId ?? "";
    message.validDuration = (object.validDuration !== undefined && object.validDuration !== null)
      ? Duration.fromPartial(object.validDuration)
      : undefined;
    message.expiresAt = object.expiresAt ?? undefined;
    message.valid = object.valid ?? false;
    message.createdBy = object.createdBy ?? "";
    return message;
  },
};

function createBaseCreateChecklistRequest(): CreateChecklistRequest {
  return { checklistDefinitionId: 0, robotSerial: "", fieldId: "", validDuration: undefined };
}

export const CreateChecklistRequest: MessageFns<CreateChecklistRequest> = {
  encode(message: CreateChecklistRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.checklistDefinitionId !== 0) {
      writer.uint32(8).uint64(message.checklistDefinitionId);
    }
    if (message.robotSerial !== "") {
      writer.uint32(18).string(message.robotSerial);
    }
    if (message.fieldId !== "") {
      writer.uint32(26).string(message.fieldId);
    }
    if (message.validDuration !== undefined) {
      Duration.encode(message.validDuration, writer.uint32(34).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CreateChecklistRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCreateChecklistRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.checklistDefinitionId = longToNumber(reader.uint64());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.robotSerial = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.fieldId = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.validDuration = Duration.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CreateChecklistRequest {
    return {
      checklistDefinitionId: isSet(object.checklistDefinitionId)
        ? globalThis.Number(object.checklistDefinitionId)
        : isSet(object.checklist_definition_id)
        ? globalThis.Number(object.checklist_definition_id)
        : 0,
      robotSerial: isSet(object.robotSerial)
        ? globalThis.String(object.robotSerial)
        : isSet(object.robot_serial)
        ? globalThis.String(object.robot_serial)
        : "",
      fieldId: isSet(object.fieldId)
        ? globalThis.String(object.fieldId)
        : isSet(object.field_id)
        ? globalThis.String(object.field_id)
        : "",
      validDuration: isSet(object.validDuration)
        ? Duration.fromJSON(object.validDuration)
        : isSet(object.valid_duration)
        ? Duration.fromJSON(object.valid_duration)
        : undefined,
    };
  },

  toJSON(message: CreateChecklistRequest): unknown {
    const obj: any = {};
    if (message.checklistDefinitionId !== 0) {
      obj.checklistDefinitionId = Math.round(message.checklistDefinitionId);
    }
    if (message.robotSerial !== "") {
      obj.robotSerial = message.robotSerial;
    }
    if (message.fieldId !== "") {
      obj.fieldId = message.fieldId;
    }
    if (message.validDuration !== undefined) {
      obj.validDuration = Duration.toJSON(message.validDuration);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CreateChecklistRequest>, I>>(base?: I): CreateChecklistRequest {
    return CreateChecklistRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CreateChecklistRequest>, I>>(object: I): CreateChecklistRequest {
    const message = createBaseCreateChecklistRequest();
    message.checklistDefinitionId = object.checklistDefinitionId ?? 0;
    message.robotSerial = object.robotSerial ?? "";
    message.fieldId = object.fieldId ?? "";
    message.validDuration = (object.validDuration !== undefined && object.validDuration !== null)
      ? Duration.fromPartial(object.validDuration)
      : undefined;
    return message;
  },
};

function createBaseChecklistList(): ChecklistList {
  return { checklists: [] };
}

export const ChecklistList: MessageFns<ChecklistList> = {
  encode(message: ChecklistList, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.checklists) {
      Checklist.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ChecklistList {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseChecklistList();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.checklists.push(Checklist.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ChecklistList {
    return {
      checklists: globalThis.Array.isArray(object?.checklists)
        ? object.checklists.map((e: any) => Checklist.fromJSON(e))
        : [],
    };
  },

  toJSON(message: ChecklistList): unknown {
    const obj: any = {};
    if (message.checklists?.length) {
      obj.checklists = message.checklists.map((e) => Checklist.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ChecklistList>, I>>(base?: I): ChecklistList {
    return ChecklistList.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ChecklistList>, I>>(object: I): ChecklistList {
    const message = createBaseChecklistList();
    message.checklists = object.checklists?.map((e) => Checklist.fromPartial(e)) || [];
    return message;
  },
};

function createBaseListChecklistsResponse(): ListChecklistsResponse {
  return { pageToken: "", checklists: [] };
}

export const ListChecklistsResponse: MessageFns<ListChecklistsResponse> = {
  encode(message: ListChecklistsResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.pageToken !== "") {
      writer.uint32(10).string(message.pageToken);
    }
    for (const v of message.checklists) {
      Checklist.encode(v!, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ListChecklistsResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseListChecklistsResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.pageToken = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.checklists.push(Checklist.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ListChecklistsResponse {
    return {
      pageToken: isSet(object.pageToken)
        ? globalThis.String(object.pageToken)
        : isSet(object.page_token)
        ? globalThis.String(object.page_token)
        : "",
      checklists: globalThis.Array.isArray(object?.checklists)
        ? object.checklists.map((e: any) => Checklist.fromJSON(e))
        : [],
    };
  },

  toJSON(message: ListChecklistsResponse): unknown {
    const obj: any = {};
    if (message.pageToken !== "") {
      obj.pageToken = message.pageToken;
    }
    if (message.checklists?.length) {
      obj.checklists = message.checklists.map((e) => Checklist.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ListChecklistsResponse>, I>>(base?: I): ListChecklistsResponse {
    return ListChecklistsResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ListChecklistsResponse>, I>>(object: I): ListChecklistsResponse {
    const message = createBaseListChecklistsResponse();
    message.pageToken = object.pageToken ?? "";
    message.checklists = object.checklists?.map((e) => Checklist.fromPartial(e)) || [];
    return message;
  },
};

function createBaseChecklistItem(): ChecklistItem {
  return {
    id: 0,
    checklistId: 0,
    createdAt: undefined,
    updatedAt: undefined,
    content: undefined,
    checkedAt: undefined,
    checkedBy: "",
    checked: false,
  };
}

export const ChecklistItem: MessageFns<ChecklistItem> = {
  encode(message: ChecklistItem, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== 0) {
      writer.uint32(8).uint64(message.id);
    }
    if (message.checklistId !== 0) {
      writer.uint32(16).uint64(message.checklistId);
    }
    if (message.createdAt !== undefined) {
      Timestamp.encode(toTimestamp(message.createdAt), writer.uint32(26).fork()).join();
    }
    if (message.updatedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.updatedAt), writer.uint32(34).fork()).join();
    }
    if (message.content !== undefined) {
      ChecklistItemContent.encode(message.content, writer.uint32(42).fork()).join();
    }
    if (message.checkedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.checkedAt), writer.uint32(50).fork()).join();
    }
    if (message.checkedBy !== "") {
      writer.uint32(58).string(message.checkedBy);
    }
    if (message.checked !== false) {
      writer.uint32(64).bool(message.checked);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ChecklistItem {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseChecklistItem();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.id = longToNumber(reader.uint64());
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.checklistId = longToNumber(reader.uint64());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.createdAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.updatedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.content = ChecklistItemContent.decode(reader, reader.uint32());
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.checkedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.checkedBy = reader.string();
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.checked = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ChecklistItem {
    return {
      id: isSet(object.id) ? globalThis.Number(object.id) : 0,
      checklistId: isSet(object.checklistId)
        ? globalThis.Number(object.checklistId)
        : isSet(object.checklist_id)
        ? globalThis.Number(object.checklist_id)
        : 0,
      createdAt: isSet(object.createdAt)
        ? globalThis.String(object.createdAt)
        : isSet(object.created_at)
        ? globalThis.String(object.created_at)
        : undefined,
      updatedAt: isSet(object.updatedAt)
        ? globalThis.String(object.updatedAt)
        : isSet(object.updated_at)
        ? globalThis.String(object.updated_at)
        : undefined,
      content: isSet(object.content) ? ChecklistItemContent.fromJSON(object.content) : undefined,
      checkedAt: isSet(object.checkedAt)
        ? globalThis.String(object.checkedAt)
        : isSet(object.checked_at)
        ? globalThis.String(object.checked_at)
        : undefined,
      checkedBy: isSet(object.checkedBy)
        ? globalThis.String(object.checkedBy)
        : isSet(object.checked_by)
        ? globalThis.String(object.checked_by)
        : "",
      checked: isSet(object.checked) ? globalThis.Boolean(object.checked) : false,
    };
  },

  toJSON(message: ChecklistItem): unknown {
    const obj: any = {};
    if (message.id !== 0) {
      obj.id = Math.round(message.id);
    }
    if (message.checklistId !== 0) {
      obj.checklistId = Math.round(message.checklistId);
    }
    if (message.createdAt !== undefined) {
      obj.createdAt = message.createdAt;
    }
    if (message.updatedAt !== undefined) {
      obj.updatedAt = message.updatedAt;
    }
    if (message.content !== undefined) {
      obj.content = ChecklistItemContent.toJSON(message.content);
    }
    if (message.checkedAt !== undefined) {
      obj.checkedAt = message.checkedAt;
    }
    if (message.checkedBy !== "") {
      obj.checkedBy = message.checkedBy;
    }
    if (message.checked !== false) {
      obj.checked = message.checked;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ChecklistItem>, I>>(base?: I): ChecklistItem {
    return ChecklistItem.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ChecklistItem>, I>>(object: I): ChecklistItem {
    const message = createBaseChecklistItem();
    message.id = object.id ?? 0;
    message.checklistId = object.checklistId ?? 0;
    message.createdAt = object.createdAt ?? undefined;
    message.updatedAt = object.updatedAt ?? undefined;
    message.content = (object.content !== undefined && object.content !== null)
      ? ChecklistItemContent.fromPartial(object.content)
      : undefined;
    message.checkedAt = object.checkedAt ?? undefined;
    message.checkedBy = object.checkedBy ?? "";
    message.checked = object.checked ?? false;
    return message;
  },
};

function createBaseCreateChecklistExemptionRequest(): CreateChecklistExemptionRequest {
  return { fieldId: "", validDuration: undefined };
}

export const CreateChecklistExemptionRequest: MessageFns<CreateChecklistExemptionRequest> = {
  encode(message: CreateChecklistExemptionRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fieldId !== "") {
      writer.uint32(10).string(message.fieldId);
    }
    if (message.validDuration !== undefined) {
      Duration.encode(message.validDuration, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CreateChecklistExemptionRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCreateChecklistExemptionRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.fieldId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.validDuration = Duration.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CreateChecklistExemptionRequest {
    return {
      fieldId: isSet(object.fieldId)
        ? globalThis.String(object.fieldId)
        : isSet(object.field_id)
        ? globalThis.String(object.field_id)
        : "",
      validDuration: isSet(object.validDuration)
        ? Duration.fromJSON(object.validDuration)
        : isSet(object.valid_duration)
        ? Duration.fromJSON(object.valid_duration)
        : undefined,
    };
  },

  toJSON(message: CreateChecklistExemptionRequest): unknown {
    const obj: any = {};
    if (message.fieldId !== "") {
      obj.fieldId = message.fieldId;
    }
    if (message.validDuration !== undefined) {
      obj.validDuration = Duration.toJSON(message.validDuration);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CreateChecklistExemptionRequest>, I>>(base?: I): CreateChecklistExemptionRequest {
    return CreateChecklistExemptionRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CreateChecklistExemptionRequest>, I>>(
    object: I,
  ): CreateChecklistExemptionRequest {
    const message = createBaseCreateChecklistExemptionRequest();
    message.fieldId = object.fieldId ?? "";
    message.validDuration = (object.validDuration !== undefined && object.validDuration !== null)
      ? Duration.fromPartial(object.validDuration)
      : undefined;
    return message;
  },
};

function createBaseChecklistExemption(): ChecklistExemption {
  return {
    robotSerial: "",
    fieldId: "",
    validDuration: undefined,
    createdAt: undefined,
    createdBy: "",
    expiresAt: undefined,
    valid: false,
  };
}

export const ChecklistExemption: MessageFns<ChecklistExemption> = {
  encode(message: ChecklistExemption, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.robotSerial !== "") {
      writer.uint32(10).string(message.robotSerial);
    }
    if (message.fieldId !== "") {
      writer.uint32(18).string(message.fieldId);
    }
    if (message.validDuration !== undefined) {
      Duration.encode(message.validDuration, writer.uint32(26).fork()).join();
    }
    if (message.createdAt !== undefined) {
      Timestamp.encode(toTimestamp(message.createdAt), writer.uint32(34).fork()).join();
    }
    if (message.createdBy !== "") {
      writer.uint32(42).string(message.createdBy);
    }
    if (message.expiresAt !== undefined) {
      Timestamp.encode(toTimestamp(message.expiresAt), writer.uint32(50).fork()).join();
    }
    if (message.valid !== false) {
      writer.uint32(56).bool(message.valid);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ChecklistExemption {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseChecklistExemption();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.robotSerial = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.fieldId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.validDuration = Duration.decode(reader, reader.uint32());
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.createdAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.createdBy = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.expiresAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.valid = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ChecklistExemption {
    return {
      robotSerial: isSet(object.robotSerial)
        ? globalThis.String(object.robotSerial)
        : isSet(object.robot_serial)
        ? globalThis.String(object.robot_serial)
        : "",
      fieldId: isSet(object.fieldId)
        ? globalThis.String(object.fieldId)
        : isSet(object.field_id)
        ? globalThis.String(object.field_id)
        : "",
      validDuration: isSet(object.validDuration)
        ? Duration.fromJSON(object.validDuration)
        : isSet(object.valid_duration)
        ? Duration.fromJSON(object.valid_duration)
        : undefined,
      createdAt: isSet(object.createdAt)
        ? globalThis.String(object.createdAt)
        : isSet(object.created_at)
        ? globalThis.String(object.created_at)
        : undefined,
      createdBy: isSet(object.createdBy)
        ? globalThis.String(object.createdBy)
        : isSet(object.created_by)
        ? globalThis.String(object.created_by)
        : "",
      expiresAt: isSet(object.expiresAt)
        ? globalThis.String(object.expiresAt)
        : isSet(object.expires_at)
        ? globalThis.String(object.expires_at)
        : undefined,
      valid: isSet(object.valid) ? globalThis.Boolean(object.valid) : false,
    };
  },

  toJSON(message: ChecklistExemption): unknown {
    const obj: any = {};
    if (message.robotSerial !== "") {
      obj.robotSerial = message.robotSerial;
    }
    if (message.fieldId !== "") {
      obj.fieldId = message.fieldId;
    }
    if (message.validDuration !== undefined) {
      obj.validDuration = Duration.toJSON(message.validDuration);
    }
    if (message.createdAt !== undefined) {
      obj.createdAt = message.createdAt;
    }
    if (message.createdBy !== "") {
      obj.createdBy = message.createdBy;
    }
    if (message.expiresAt !== undefined) {
      obj.expiresAt = message.expiresAt;
    }
    if (message.valid !== false) {
      obj.valid = message.valid;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ChecklistExemption>, I>>(base?: I): ChecklistExemption {
    return ChecklistExemption.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ChecklistExemption>, I>>(object: I): ChecklistExemption {
    const message = createBaseChecklistExemption();
    message.robotSerial = object.robotSerial ?? "";
    message.fieldId = object.fieldId ?? "";
    message.validDuration = (object.validDuration !== undefined && object.validDuration !== null)
      ? Duration.fromPartial(object.validDuration)
      : undefined;
    message.createdAt = object.createdAt ?? undefined;
    message.createdBy = object.createdBy ?? "";
    message.expiresAt = object.expiresAt ?? undefined;
    message.valid = object.valid ?? false;
    return message;
  },
};

function createBaseIntervention(): Intervention {
  return {
    id: 0,
    taskId: 0,
    qualification: "",
    description: "",
    state: 0,
    robotSerial: "",
    jobId: 0,
    cause: 0,
    priority: 0,
    assignment: undefined,
    createdAt: undefined,
    updatedAt: undefined,
    diagnosticMessage: "",
  };
}

export const Intervention: MessageFns<Intervention> = {
  encode(message: Intervention, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== 0) {
      writer.uint32(8).uint64(message.id);
    }
    if (message.taskId !== 0) {
      writer.uint32(16).uint64(message.taskId);
    }
    if (message.qualification !== "") {
      writer.uint32(26).string(message.qualification);
    }
    if (message.description !== "") {
      writer.uint32(34).string(message.description);
    }
    if (message.state !== 0) {
      writer.uint32(40).int32(message.state);
    }
    if (message.robotSerial !== "") {
      writer.uint32(50).string(message.robotSerial);
    }
    if (message.jobId !== 0) {
      writer.uint32(56).uint64(message.jobId);
    }
    if (message.cause !== 0) {
      writer.uint32(64).int32(message.cause);
    }
    if (message.priority !== 0) {
      writer.uint32(72).int32(message.priority);
    }
    if (message.assignment !== undefined) {
      InterventionAssignment.encode(message.assignment, writer.uint32(82).fork()).join();
    }
    if (message.createdAt !== undefined) {
      Timestamp.encode(toTimestamp(message.createdAt), writer.uint32(90).fork()).join();
    }
    if (message.updatedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.updatedAt), writer.uint32(98).fork()).join();
    }
    if (message.diagnosticMessage !== "") {
      writer.uint32(106).string(message.diagnosticMessage);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Intervention {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseIntervention();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.id = longToNumber(reader.uint64());
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.taskId = longToNumber(reader.uint64());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.qualification = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.description = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.state = reader.int32() as any;
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.robotSerial = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.jobId = longToNumber(reader.uint64());
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.cause = reader.int32() as any;
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.priority = reader.int32();
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.assignment = InterventionAssignment.decode(reader, reader.uint32());
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.createdAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 12: {
          if (tag !== 98) {
            break;
          }

          message.updatedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 13: {
          if (tag !== 106) {
            break;
          }

          message.diagnosticMessage = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Intervention {
    return {
      id: isSet(object.id) ? globalThis.Number(object.id) : 0,
      taskId: isSet(object.taskId)
        ? globalThis.Number(object.taskId)
        : isSet(object.task_id)
        ? globalThis.Number(object.task_id)
        : 0,
      qualification: isSet(object.qualification) ? globalThis.String(object.qualification) : "",
      description: isSet(object.description) ? globalThis.String(object.description) : "",
      state: isSet(object.state) ? stateFromJSON(object.state) : 0,
      robotSerial: isSet(object.robotSerial)
        ? globalThis.String(object.robotSerial)
        : isSet(object.robot_serial)
        ? globalThis.String(object.robot_serial)
        : "",
      jobId: isSet(object.jobId)
        ? globalThis.Number(object.jobId)
        : isSet(object.job_id)
        ? globalThis.Number(object.job_id)
        : 0,
      cause: isSet(object.cause) ? interventionCauseFromJSON(object.cause) : 0,
      priority: isSet(object.priority) ? globalThis.Number(object.priority) : 0,
      assignment: isSet(object.assignment) ? InterventionAssignment.fromJSON(object.assignment) : undefined,
      createdAt: isSet(object.createdAt)
        ? globalThis.String(object.createdAt)
        : isSet(object.created_at)
        ? globalThis.String(object.created_at)
        : undefined,
      updatedAt: isSet(object.updatedAt)
        ? globalThis.String(object.updatedAt)
        : isSet(object.updated_at)
        ? globalThis.String(object.updated_at)
        : undefined,
      diagnosticMessage: isSet(object.diagnosticMessage)
        ? globalThis.String(object.diagnosticMessage)
        : isSet(object.diagnostic_message)
        ? globalThis.String(object.diagnostic_message)
        : "",
    };
  },

  toJSON(message: Intervention): unknown {
    const obj: any = {};
    if (message.id !== 0) {
      obj.id = Math.round(message.id);
    }
    if (message.taskId !== 0) {
      obj.taskId = Math.round(message.taskId);
    }
    if (message.qualification !== "") {
      obj.qualification = message.qualification;
    }
    if (message.description !== "") {
      obj.description = message.description;
    }
    if (message.state !== 0) {
      obj.state = stateToJSON(message.state);
    }
    if (message.robotSerial !== "") {
      obj.robotSerial = message.robotSerial;
    }
    if (message.jobId !== 0) {
      obj.jobId = Math.round(message.jobId);
    }
    if (message.cause !== 0) {
      obj.cause = interventionCauseToJSON(message.cause);
    }
    if (message.priority !== 0) {
      obj.priority = Math.round(message.priority);
    }
    if (message.assignment !== undefined) {
      obj.assignment = InterventionAssignment.toJSON(message.assignment);
    }
    if (message.createdAt !== undefined) {
      obj.createdAt = message.createdAt;
    }
    if (message.updatedAt !== undefined) {
      obj.updatedAt = message.updatedAt;
    }
    if (message.diagnosticMessage !== "") {
      obj.diagnosticMessage = message.diagnosticMessage;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Intervention>, I>>(base?: I): Intervention {
    return Intervention.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Intervention>, I>>(object: I): Intervention {
    const message = createBaseIntervention();
    message.id = object.id ?? 0;
    message.taskId = object.taskId ?? 0;
    message.qualification = object.qualification ?? "";
    message.description = object.description ?? "";
    message.state = object.state ?? 0;
    message.robotSerial = object.robotSerial ?? "";
    message.jobId = object.jobId ?? 0;
    message.cause = object.cause ?? 0;
    message.priority = object.priority ?? 0;
    message.assignment = (object.assignment !== undefined && object.assignment !== null)
      ? InterventionAssignment.fromPartial(object.assignment)
      : undefined;
    message.createdAt = object.createdAt ?? undefined;
    message.updatedAt = object.updatedAt ?? undefined;
    message.diagnosticMessage = object.diagnosticMessage ?? "";
    return message;
  },
};

function createBaseInterventionList(): InterventionList {
  return { intervention: [] };
}

export const InterventionList: MessageFns<InterventionList> = {
  encode(message: InterventionList, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.intervention) {
      Intervention.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): InterventionList {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseInterventionList();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.intervention.push(Intervention.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): InterventionList {
    return {
      intervention: globalThis.Array.isArray(object?.intervention)
        ? object.intervention.map((e: any) => Intervention.fromJSON(e))
        : [],
    };
  },

  toJSON(message: InterventionList): unknown {
    const obj: any = {};
    if (message.intervention?.length) {
      obj.intervention = message.intervention.map((e) => Intervention.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<InterventionList>, I>>(base?: I): InterventionList {
    return InterventionList.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<InterventionList>, I>>(object: I): InterventionList {
    const message = createBaseInterventionList();
    message.intervention = object.intervention?.map((e) => Intervention.fromPartial(e)) || [];
    return message;
  },
};

function createBaseInterventionAssignment(): InterventionAssignment {
  return { userId: "", assignedAt: undefined };
}

export const InterventionAssignment: MessageFns<InterventionAssignment> = {
  encode(message: InterventionAssignment, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.userId !== "") {
      writer.uint32(10).string(message.userId);
    }
    if (message.assignedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.assignedAt), writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): InterventionAssignment {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseInterventionAssignment();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.userId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.assignedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): InterventionAssignment {
    return {
      userId: isSet(object.userId)
        ? globalThis.String(object.userId)
        : isSet(object.user_id)
        ? globalThis.String(object.user_id)
        : "",
      assignedAt: isSet(object.assignedAt)
        ? globalThis.String(object.assignedAt)
        : isSet(object.assigned_at)
        ? globalThis.String(object.assigned_at)
        : undefined,
    };
  },

  toJSON(message: InterventionAssignment): unknown {
    const obj: any = {};
    if (message.userId !== "") {
      obj.userId = message.userId;
    }
    if (message.assignedAt !== undefined) {
      obj.assignedAt = message.assignedAt;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<InterventionAssignment>, I>>(base?: I): InterventionAssignment {
    return InterventionAssignment.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<InterventionAssignment>, I>>(object: I): InterventionAssignment {
    const message = createBaseInterventionAssignment();
    message.userId = object.userId ?? "";
    message.assignedAt = object.assignedAt ?? undefined;
    return message;
  },
};

function createBaseListInterventionsRequest(): ListInterventionsRequest {
  return {
    pageSize: 0,
    pageToken: "",
    robotSerials: "",
    assigedUserIds: "",
    assigned: false,
    taskIds: "",
    jobIds: "",
    causes: "",
    states: "",
  };
}

export const ListInterventionsRequest: MessageFns<ListInterventionsRequest> = {
  encode(message: ListInterventionsRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.pageSize !== 0) {
      writer.uint32(8).int32(message.pageSize);
    }
    if (message.pageToken !== "") {
      writer.uint32(18).string(message.pageToken);
    }
    if (message.robotSerials !== "") {
      writer.uint32(26).string(message.robotSerials);
    }
    if (message.assigedUserIds !== "") {
      writer.uint32(34).string(message.assigedUserIds);
    }
    if (message.assigned !== false) {
      writer.uint32(40).bool(message.assigned);
    }
    if (message.taskIds !== "") {
      writer.uint32(50).string(message.taskIds);
    }
    if (message.jobIds !== "") {
      writer.uint32(58).string(message.jobIds);
    }
    if (message.causes !== "") {
      writer.uint32(66).string(message.causes);
    }
    if (message.states !== "") {
      writer.uint32(74).string(message.states);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ListInterventionsRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseListInterventionsRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.pageSize = reader.int32();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.pageToken = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.robotSerials = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.assigedUserIds = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.assigned = reader.bool();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.taskIds = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.jobIds = reader.string();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.causes = reader.string();
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.states = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ListInterventionsRequest {
    return {
      pageSize: isSet(object.pageSize)
        ? globalThis.Number(object.pageSize)
        : isSet(object.page_size)
        ? globalThis.Number(object.page_size)
        : 0,
      pageToken: isSet(object.pageToken)
        ? globalThis.String(object.pageToken)
        : isSet(object.page_token)
        ? globalThis.String(object.page_token)
        : "",
      robotSerials: isSet(object.robotSerials)
        ? globalThis.String(object.robotSerials)
        : isSet(object.robot_serials)
        ? globalThis.String(object.robot_serials)
        : "",
      assigedUserIds: isSet(object.assigedUserIds)
        ? globalThis.String(object.assigedUserIds)
        : isSet(object.assiged_user_ids)
        ? globalThis.String(object.assiged_user_ids)
        : "",
      assigned: isSet(object.assigned) ? globalThis.Boolean(object.assigned) : false,
      taskIds: isSet(object.taskIds)
        ? globalThis.String(object.taskIds)
        : isSet(object.task_ids)
        ? globalThis.String(object.task_ids)
        : "",
      jobIds: isSet(object.jobIds)
        ? globalThis.String(object.jobIds)
        : isSet(object.job_ids)
        ? globalThis.String(object.job_ids)
        : "",
      causes: isSet(object.causes) ? globalThis.String(object.causes) : "",
      states: isSet(object.states) ? globalThis.String(object.states) : "",
    };
  },

  toJSON(message: ListInterventionsRequest): unknown {
    const obj: any = {};
    if (message.pageSize !== 0) {
      obj.pageSize = Math.round(message.pageSize);
    }
    if (message.pageToken !== "") {
      obj.pageToken = message.pageToken;
    }
    if (message.robotSerials !== "") {
      obj.robotSerials = message.robotSerials;
    }
    if (message.assigedUserIds !== "") {
      obj.assigedUserIds = message.assigedUserIds;
    }
    if (message.assigned !== false) {
      obj.assigned = message.assigned;
    }
    if (message.taskIds !== "") {
      obj.taskIds = message.taskIds;
    }
    if (message.jobIds !== "") {
      obj.jobIds = message.jobIds;
    }
    if (message.causes !== "") {
      obj.causes = message.causes;
    }
    if (message.states !== "") {
      obj.states = message.states;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ListInterventionsRequest>, I>>(base?: I): ListInterventionsRequest {
    return ListInterventionsRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ListInterventionsRequest>, I>>(object: I): ListInterventionsRequest {
    const message = createBaseListInterventionsRequest();
    message.pageSize = object.pageSize ?? 0;
    message.pageToken = object.pageToken ?? "";
    message.robotSerials = object.robotSerials ?? "";
    message.assigedUserIds = object.assigedUserIds ?? "";
    message.assigned = object.assigned ?? false;
    message.taskIds = object.taskIds ?? "";
    message.jobIds = object.jobIds ?? "";
    message.causes = object.causes ?? "";
    message.states = object.states ?? "";
    return message;
  },
};

function createBaseListInterventionsResponse(): ListInterventionsResponse {
  return { pageToken: "", interventions: [] };
}

export const ListInterventionsResponse: MessageFns<ListInterventionsResponse> = {
  encode(message: ListInterventionsResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.pageToken !== "") {
      writer.uint32(10).string(message.pageToken);
    }
    for (const v of message.interventions) {
      Intervention.encode(v!, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ListInterventionsResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseListInterventionsResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.pageToken = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.interventions.push(Intervention.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ListInterventionsResponse {
    return {
      pageToken: isSet(object.pageToken)
        ? globalThis.String(object.pageToken)
        : isSet(object.page_token)
        ? globalThis.String(object.page_token)
        : "",
      interventions: globalThis.Array.isArray(object?.interventions)
        ? object.interventions.map((e: any) => Intervention.fromJSON(e))
        : [],
    };
  },

  toJSON(message: ListInterventionsResponse): unknown {
    const obj: any = {};
    if (message.pageToken !== "") {
      obj.pageToken = message.pageToken;
    }
    if (message.interventions?.length) {
      obj.interventions = message.interventions.map((e) => Intervention.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ListInterventionsResponse>, I>>(base?: I): ListInterventionsResponse {
    return ListInterventionsResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ListInterventionsResponse>, I>>(object: I): ListInterventionsResponse {
    const message = createBaseListInterventionsResponse();
    message.pageToken = object.pageToken ?? "";
    message.interventions = object.interventions?.map((e) => Intervention.fromPartial(e)) || [];
    return message;
  },
};

function createBaseCreateInterventionRequest(): CreateInterventionRequest {
  return { intervention: undefined };
}

export const CreateInterventionRequest: MessageFns<CreateInterventionRequest> = {
  encode(message: CreateInterventionRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.intervention !== undefined) {
      Intervention.encode(message.intervention, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CreateInterventionRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCreateInterventionRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.intervention = Intervention.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CreateInterventionRequest {
    return { intervention: isSet(object.intervention) ? Intervention.fromJSON(object.intervention) : undefined };
  },

  toJSON(message: CreateInterventionRequest): unknown {
    const obj: any = {};
    if (message.intervention !== undefined) {
      obj.intervention = Intervention.toJSON(message.intervention);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CreateInterventionRequest>, I>>(base?: I): CreateInterventionRequest {
    return CreateInterventionRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CreateInterventionRequest>, I>>(object: I): CreateInterventionRequest {
    const message = createBaseCreateInterventionRequest();
    message.intervention = (object.intervention !== undefined && object.intervention !== null)
      ? Intervention.fromPartial(object.intervention)
      : undefined;
    return message;
  },
};

function createBaseCreateInterventionResponse(): CreateInterventionResponse {
  return { intervention: undefined };
}

export const CreateInterventionResponse: MessageFns<CreateInterventionResponse> = {
  encode(message: CreateInterventionResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.intervention !== undefined) {
      Intervention.encode(message.intervention, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CreateInterventionResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCreateInterventionResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.intervention = Intervention.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CreateInterventionResponse {
    return { intervention: isSet(object.intervention) ? Intervention.fromJSON(object.intervention) : undefined };
  },

  toJSON(message: CreateInterventionResponse): unknown {
    const obj: any = {};
    if (message.intervention !== undefined) {
      obj.intervention = Intervention.toJSON(message.intervention);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CreateInterventionResponse>, I>>(base?: I): CreateInterventionResponse {
    return CreateInterventionResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CreateInterventionResponse>, I>>(object: I): CreateInterventionResponse {
    const message = createBaseCreateInterventionResponse();
    message.intervention = (object.intervention !== undefined && object.intervention !== null)
      ? Intervention.fromPartial(object.intervention)
      : undefined;
    return message;
  },
};

function createBaseGetActiveTaskRequest(): GetActiveTaskRequest {
  return { currentLocation: undefined };
}

export const GetActiveTaskRequest: MessageFns<GetActiveTaskRequest> = {
  encode(message: GetActiveTaskRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.currentLocation !== undefined) {
      Point.encode(message.currentLocation, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetActiveTaskRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetActiveTaskRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.currentLocation = Point.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetActiveTaskRequest {
    return {
      currentLocation: isSet(object.currentLocation)
        ? Point.fromJSON(object.currentLocation)
        : isSet(object.current_location)
        ? Point.fromJSON(object.current_location)
        : undefined,
    };
  },

  toJSON(message: GetActiveTaskRequest): unknown {
    const obj: any = {};
    if (message.currentLocation !== undefined) {
      obj.currentLocation = Point.toJSON(message.currentLocation);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetActiveTaskRequest>, I>>(base?: I): GetActiveTaskRequest {
    return GetActiveTaskRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetActiveTaskRequest>, I>>(object: I): GetActiveTaskRequest {
    const message = createBaseGetActiveTaskRequest();
    message.currentLocation = (object.currentLocation !== undefined && object.currentLocation !== null)
      ? Point.fromPartial(object.currentLocation)
      : undefined;
    return message;
  },
};

function createBaseGetActiveTaskResponse(): GetActiveTaskResponse {
  return { task: undefined };
}

export const GetActiveTaskResponse: MessageFns<GetActiveTaskResponse> = {
  encode(message: GetActiveTaskResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.task !== undefined) {
      Task.encode(message.task, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetActiveTaskResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetActiveTaskResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.task = Task.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetActiveTaskResponse {
    return { task: isSet(object.task) ? Task.fromJSON(object.task) : undefined };
  },

  toJSON(message: GetActiveTaskResponse): unknown {
    const obj: any = {};
    if (message.task !== undefined) {
      obj.task = Task.toJSON(message.task);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetActiveTaskResponse>, I>>(base?: I): GetActiveTaskResponse {
    return GetActiveTaskResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetActiveTaskResponse>, I>>(object: I): GetActiveTaskResponse {
    const message = createBaseGetActiveTaskResponse();
    message.task = (object.task !== undefined && object.task !== null) ? Task.fromPartial(object.task) : undefined;
    return message;
  },
};

function createBaseGetTaskRequest(): GetTaskRequest {
  return { taskId: 0 };
}

export const GetTaskRequest: MessageFns<GetTaskRequest> = {
  encode(message: GetTaskRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.taskId !== 0) {
      writer.uint32(8).uint64(message.taskId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetTaskRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetTaskRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.taskId = longToNumber(reader.uint64());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetTaskRequest {
    return {
      taskId: isSet(object.taskId)
        ? globalThis.Number(object.taskId)
        : isSet(object.task_id)
        ? globalThis.Number(object.task_id)
        : 0,
    };
  },

  toJSON(message: GetTaskRequest): unknown {
    const obj: any = {};
    if (message.taskId !== 0) {
      obj.taskId = Math.round(message.taskId);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetTaskRequest>, I>>(base?: I): GetTaskRequest {
    return GetTaskRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetTaskRequest>, I>>(object: I): GetTaskRequest {
    const message = createBaseGetTaskRequest();
    message.taskId = object.taskId ?? 0;
    return message;
  },
};

function createBaseGetTaskResponse(): GetTaskResponse {
  return { task: undefined };
}

export const GetTaskResponse: MessageFns<GetTaskResponse> = {
  encode(message: GetTaskResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.task !== undefined) {
      Task.encode(message.task, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetTaskResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetTaskResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.task = Task.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetTaskResponse {
    return { task: isSet(object.task) ? Task.fromJSON(object.task) : undefined };
  },

  toJSON(message: GetTaskResponse): unknown {
    const obj: any = {};
    if (message.task !== undefined) {
      obj.task = Task.toJSON(message.task);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetTaskResponse>, I>>(base?: I): GetTaskResponse {
    return GetTaskResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetTaskResponse>, I>>(object: I): GetTaskResponse {
    const message = createBaseGetTaskResponse();
    message.task = (object.task !== undefined && object.task !== null) ? Task.fromPartial(object.task) : undefined;
    return message;
  },
};

function createBaseRigPointLocation(): RigPointLocation {
  return { rigPoint: 0, location: undefined };
}

export const RigPointLocation: MessageFns<RigPointLocation> = {
  encode(message: RigPointLocation, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.rigPoint !== 0) {
      writer.uint32(8).int32(message.rigPoint);
    }
    if (message.location !== undefined) {
      Point.encode(message.location, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RigPointLocation {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRigPointLocation();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.rigPoint = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.location = Point.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RigPointLocation {
    return {
      rigPoint: isSet(object.rigPoint)
        ? rigPointFromJSON(object.rigPoint)
        : isSet(object.rig_point)
        ? rigPointFromJSON(object.rig_point)
        : 0,
      location: isSet(object.location) ? Point.fromJSON(object.location) : undefined,
    };
  },

  toJSON(message: RigPointLocation): unknown {
    const obj: any = {};
    if (message.rigPoint !== 0) {
      obj.rigPoint = rigPointToJSON(message.rigPoint);
    }
    if (message.location !== undefined) {
      obj.location = Point.toJSON(message.location);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<RigPointLocation>, I>>(base?: I): RigPointLocation {
    return RigPointLocation.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<RigPointLocation>, I>>(object: I): RigPointLocation {
    const message = createBaseRigPointLocation();
    message.rigPoint = object.rigPoint ?? 0;
    message.location = (object.location !== undefined && object.location !== null)
      ? Point.fromPartial(object.location)
      : undefined;
    return message;
  },
};

function createBaseRigPointPath(): RigPointPath {
  return { rigPoint: 0, path: undefined };
}

export const RigPointPath: MessageFns<RigPointPath> = {
  encode(message: RigPointPath, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.rigPoint !== 0) {
      writer.uint32(8).int32(message.rigPoint);
    }
    if (message.path !== undefined) {
      LineString.encode(message.path, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RigPointPath {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRigPointPath();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.rigPoint = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.path = LineString.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RigPointPath {
    return {
      rigPoint: isSet(object.rigPoint)
        ? rigPointFromJSON(object.rigPoint)
        : isSet(object.rig_point)
        ? rigPointFromJSON(object.rig_point)
        : 0,
      path: isSet(object.path) ? LineString.fromJSON(object.path) : undefined,
    };
  },

  toJSON(message: RigPointPath): unknown {
    const obj: any = {};
    if (message.rigPoint !== 0) {
      obj.rigPoint = rigPointToJSON(message.rigPoint);
    }
    if (message.path !== undefined) {
      obj.path = LineString.toJSON(message.path);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<RigPointPath>, I>>(base?: I): RigPointPath {
    return RigPointPath.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<RigPointPath>, I>>(object: I): RigPointPath {
    const message = createBaseRigPointPath();
    message.rigPoint = object.rigPoint ?? 0;
    message.path = (object.path !== undefined && object.path !== null)
      ? LineString.fromPartial(object.path)
      : undefined;
    return message;
  },
};

function createBaseUpdateTaskRequest(): UpdateTaskRequest {
  return {
    taskId: 0,
    state: undefined,
    startedAt: undefined,
    startLocation: undefined,
    startHeading: undefined,
    endedAt: undefined,
    endLocation: undefined,
    endHeading: undefined,
    statusInfo: undefined,
    progressUpdatedAt: undefined,
    progressLocation: undefined,
    progressHeading: undefined,
    progressLocations: [],
    startLocations: [],
    endLocations: [],
  };
}

export const UpdateTaskRequest: MessageFns<UpdateTaskRequest> = {
  encode(message: UpdateTaskRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.taskId !== 0) {
      writer.uint32(8).uint64(message.taskId);
    }
    if (message.state !== undefined) {
      writer.uint32(16).int32(message.state);
    }
    if (message.startedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.startedAt), writer.uint32(26).fork()).join();
    }
    if (message.startLocation !== undefined) {
      Point.encode(message.startLocation, writer.uint32(34).fork()).join();
    }
    if (message.startHeading !== undefined) {
      writer.uint32(41).double(message.startHeading);
    }
    if (message.endedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.endedAt), writer.uint32(50).fork()).join();
    }
    if (message.endLocation !== undefined) {
      Point.encode(message.endLocation, writer.uint32(58).fork()).join();
    }
    if (message.endHeading !== undefined) {
      writer.uint32(65).double(message.endHeading);
    }
    if (message.statusInfo !== undefined) {
      writer.uint32(74).string(message.statusInfo);
    }
    if (message.progressUpdatedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.progressUpdatedAt), writer.uint32(82).fork()).join();
    }
    if (message.progressLocation !== undefined) {
      Point.encode(message.progressLocation, writer.uint32(90).fork()).join();
    }
    if (message.progressHeading !== undefined) {
      writer.uint32(97).double(message.progressHeading);
    }
    for (const v of message.progressLocations) {
      RigPointLocation.encode(v!, writer.uint32(106).fork()).join();
    }
    for (const v of message.startLocations) {
      RigPointLocation.encode(v!, writer.uint32(114).fork()).join();
    }
    for (const v of message.endLocations) {
      RigPointLocation.encode(v!, writer.uint32(122).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UpdateTaskRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUpdateTaskRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.taskId = longToNumber(reader.uint64());
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.state = reader.int32() as any;
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.startedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.startLocation = Point.decode(reader, reader.uint32());
          continue;
        }
        case 5: {
          if (tag !== 41) {
            break;
          }

          message.startHeading = reader.double();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.endedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.endLocation = Point.decode(reader, reader.uint32());
          continue;
        }
        case 8: {
          if (tag !== 65) {
            break;
          }

          message.endHeading = reader.double();
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.statusInfo = reader.string();
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.progressUpdatedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.progressLocation = Point.decode(reader, reader.uint32());
          continue;
        }
        case 12: {
          if (tag !== 97) {
            break;
          }

          message.progressHeading = reader.double();
          continue;
        }
        case 13: {
          if (tag !== 106) {
            break;
          }

          message.progressLocations.push(RigPointLocation.decode(reader, reader.uint32()));
          continue;
        }
        case 14: {
          if (tag !== 114) {
            break;
          }

          message.startLocations.push(RigPointLocation.decode(reader, reader.uint32()));
          continue;
        }
        case 15: {
          if (tag !== 122) {
            break;
          }

          message.endLocations.push(RigPointLocation.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UpdateTaskRequest {
    return {
      taskId: isSet(object.taskId)
        ? globalThis.Number(object.taskId)
        : isSet(object.task_id)
        ? globalThis.Number(object.task_id)
        : 0,
      state: isSet(object.state) ? stateFromJSON(object.state) : undefined,
      startedAt: isSet(object.startedAt)
        ? globalThis.String(object.startedAt)
        : isSet(object.started_at)
        ? globalThis.String(object.started_at)
        : undefined,
      startLocation: isSet(object.startLocation)
        ? Point.fromJSON(object.startLocation)
        : isSet(object.start_location)
        ? Point.fromJSON(object.start_location)
        : undefined,
      startHeading: isSet(object.startHeading)
        ? globalThis.Number(object.startHeading)
        : isSet(object.start_heading)
        ? globalThis.Number(object.start_heading)
        : undefined,
      endedAt: isSet(object.endedAt)
        ? globalThis.String(object.endedAt)
        : isSet(object.ended_at)
        ? globalThis.String(object.ended_at)
        : undefined,
      endLocation: isSet(object.endLocation)
        ? Point.fromJSON(object.endLocation)
        : isSet(object.end_location)
        ? Point.fromJSON(object.end_location)
        : undefined,
      endHeading: isSet(object.endHeading)
        ? globalThis.Number(object.endHeading)
        : isSet(object.end_heading)
        ? globalThis.Number(object.end_heading)
        : undefined,
      statusInfo: isSet(object.statusInfo)
        ? globalThis.String(object.statusInfo)
        : isSet(object.status_info)
        ? globalThis.String(object.status_info)
        : undefined,
      progressUpdatedAt: isSet(object.progressUpdatedAt)
        ? globalThis.String(object.progressUpdatedAt)
        : isSet(object.progress_updated_at)
        ? globalThis.String(object.progress_updated_at)
        : undefined,
      progressLocation: isSet(object.progressLocation)
        ? Point.fromJSON(object.progressLocation)
        : isSet(object.progress_location)
        ? Point.fromJSON(object.progress_location)
        : undefined,
      progressHeading: isSet(object.progressHeading)
        ? globalThis.Number(object.progressHeading)
        : isSet(object.progress_heading)
        ? globalThis.Number(object.progress_heading)
        : undefined,
      progressLocations: globalThis.Array.isArray(object?.progressLocations)
        ? object.progressLocations.map((e: any) => RigPointLocation.fromJSON(e))
        : globalThis.Array.isArray(object?.progress_locations)
        ? object.progress_locations.map((e: any) => RigPointLocation.fromJSON(e))
        : [],
      startLocations: globalThis.Array.isArray(object?.startLocations)
        ? object.startLocations.map((e: any) => RigPointLocation.fromJSON(e))
        : globalThis.Array.isArray(object?.start_locations)
        ? object.start_locations.map((e: any) => RigPointLocation.fromJSON(e))
        : [],
      endLocations: globalThis.Array.isArray(object?.endLocations)
        ? object.endLocations.map((e: any) => RigPointLocation.fromJSON(e))
        : globalThis.Array.isArray(object?.end_locations)
        ? object.end_locations.map((e: any) => RigPointLocation.fromJSON(e))
        : [],
    };
  },

  toJSON(message: UpdateTaskRequest): unknown {
    const obj: any = {};
    if (message.taskId !== 0) {
      obj.taskId = Math.round(message.taskId);
    }
    if (message.state !== undefined) {
      obj.state = stateToJSON(message.state);
    }
    if (message.startedAt !== undefined) {
      obj.startedAt = message.startedAt;
    }
    if (message.startLocation !== undefined) {
      obj.startLocation = Point.toJSON(message.startLocation);
    }
    if (message.startHeading !== undefined) {
      obj.startHeading = message.startHeading;
    }
    if (message.endedAt !== undefined) {
      obj.endedAt = message.endedAt;
    }
    if (message.endLocation !== undefined) {
      obj.endLocation = Point.toJSON(message.endLocation);
    }
    if (message.endHeading !== undefined) {
      obj.endHeading = message.endHeading;
    }
    if (message.statusInfo !== undefined) {
      obj.statusInfo = message.statusInfo;
    }
    if (message.progressUpdatedAt !== undefined) {
      obj.progressUpdatedAt = message.progressUpdatedAt;
    }
    if (message.progressLocation !== undefined) {
      obj.progressLocation = Point.toJSON(message.progressLocation);
    }
    if (message.progressHeading !== undefined) {
      obj.progressHeading = message.progressHeading;
    }
    if (message.progressLocations?.length) {
      obj.progressLocations = message.progressLocations.map((e) => RigPointLocation.toJSON(e));
    }
    if (message.startLocations?.length) {
      obj.startLocations = message.startLocations.map((e) => RigPointLocation.toJSON(e));
    }
    if (message.endLocations?.length) {
      obj.endLocations = message.endLocations.map((e) => RigPointLocation.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<UpdateTaskRequest>, I>>(base?: I): UpdateTaskRequest {
    return UpdateTaskRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UpdateTaskRequest>, I>>(object: I): UpdateTaskRequest {
    const message = createBaseUpdateTaskRequest();
    message.taskId = object.taskId ?? 0;
    message.state = object.state ?? undefined;
    message.startedAt = object.startedAt ?? undefined;
    message.startLocation = (object.startLocation !== undefined && object.startLocation !== null)
      ? Point.fromPartial(object.startLocation)
      : undefined;
    message.startHeading = object.startHeading ?? undefined;
    message.endedAt = object.endedAt ?? undefined;
    message.endLocation = (object.endLocation !== undefined && object.endLocation !== null)
      ? Point.fromPartial(object.endLocation)
      : undefined;
    message.endHeading = object.endHeading ?? undefined;
    message.statusInfo = object.statusInfo ?? undefined;
    message.progressUpdatedAt = object.progressUpdatedAt ?? undefined;
    message.progressLocation = (object.progressLocation !== undefined && object.progressLocation !== null)
      ? Point.fromPartial(object.progressLocation)
      : undefined;
    message.progressHeading = object.progressHeading ?? undefined;
    message.progressLocations = object.progressLocations?.map((e) => RigPointLocation.fromPartial(e)) || [];
    message.startLocations = object.startLocations?.map((e) => RigPointLocation.fromPartial(e)) || [];
    message.endLocations = object.endLocations?.map((e) => RigPointLocation.fromPartial(e)) || [];
    return message;
  },
};

function createBaseUpdateTaskResponse(): UpdateTaskResponse {
  return { task: undefined };
}

export const UpdateTaskResponse: MessageFns<UpdateTaskResponse> = {
  encode(message: UpdateTaskResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.task !== undefined) {
      Task.encode(message.task, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UpdateTaskResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUpdateTaskResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.task = Task.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UpdateTaskResponse {
    return { task: isSet(object.task) ? Task.fromJSON(object.task) : undefined };
  },

  toJSON(message: UpdateTaskResponse): unknown {
    const obj: any = {};
    if (message.task !== undefined) {
      obj.task = Task.toJSON(message.task);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<UpdateTaskResponse>, I>>(base?: I): UpdateTaskResponse {
    return UpdateTaskResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UpdateTaskResponse>, I>>(object: I): UpdateTaskResponse {
    const message = createBaseUpdateTaskResponse();
    message.task = (object.task !== undefined && object.task !== null) ? Task.fromPartial(object.task) : undefined;
    return message;
  },
};

function createBaseTaskState(): TaskState {
  return { state: 0 };
}

export const TaskState: MessageFns<TaskState> = {
  encode(message: TaskState, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.state !== 0) {
      writer.uint32(8).int32(message.state);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TaskState {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTaskState();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.state = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TaskState {
    return { state: isSet(object.state) ? stateFromJSON(object.state) : 0 };
  },

  toJSON(message: TaskState): unknown {
    const obj: any = {};
    if (message.state !== 0) {
      obj.state = stateToJSON(message.state);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<TaskState>, I>>(base?: I): TaskState {
    return TaskState.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TaskState>, I>>(object: I): TaskState {
    const message = createBaseTaskState();
    message.state = object.state ?? 0;
    return message;
  },
};

function createBaseStartManualTaskRequest(): StartManualTaskRequest {
  return { startLocation: undefined, startHeading: undefined };
}

export const StartManualTaskRequest: MessageFns<StartManualTaskRequest> = {
  encode(message: StartManualTaskRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.startLocation !== undefined) {
      Point.encode(message.startLocation, writer.uint32(10).fork()).join();
    }
    if (message.startHeading !== undefined) {
      writer.uint32(17).double(message.startHeading);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StartManualTaskRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStartManualTaskRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.startLocation = Point.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 17) {
            break;
          }

          message.startHeading = reader.double();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StartManualTaskRequest {
    return {
      startLocation: isSet(object.startLocation)
        ? Point.fromJSON(object.startLocation)
        : isSet(object.start_location)
        ? Point.fromJSON(object.start_location)
        : undefined,
      startHeading: isSet(object.startHeading)
        ? globalThis.Number(object.startHeading)
        : isSet(object.start_heading)
        ? globalThis.Number(object.start_heading)
        : undefined,
    };
  },

  toJSON(message: StartManualTaskRequest): unknown {
    const obj: any = {};
    if (message.startLocation !== undefined) {
      obj.startLocation = Point.toJSON(message.startLocation);
    }
    if (message.startHeading !== undefined) {
      obj.startHeading = message.startHeading;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<StartManualTaskRequest>, I>>(base?: I): StartManualTaskRequest {
    return StartManualTaskRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<StartManualTaskRequest>, I>>(object: I): StartManualTaskRequest {
    const message = createBaseStartManualTaskRequest();
    message.startLocation = (object.startLocation !== undefined && object.startLocation !== null)
      ? Point.fromPartial(object.startLocation)
      : undefined;
    message.startHeading = object.startHeading ?? undefined;
    return message;
  },
};

function createBaseStopManualTaskRequest(): StopManualTaskRequest {
  return { endLocation: undefined, endHeading: undefined };
}

export const StopManualTaskRequest: MessageFns<StopManualTaskRequest> = {
  encode(message: StopManualTaskRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.endLocation !== undefined) {
      Point.encode(message.endLocation, writer.uint32(10).fork()).join();
    }
    if (message.endHeading !== undefined) {
      writer.uint32(17).double(message.endHeading);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StopManualTaskRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStopManualTaskRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.endLocation = Point.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 17) {
            break;
          }

          message.endHeading = reader.double();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StopManualTaskRequest {
    return {
      endLocation: isSet(object.endLocation)
        ? Point.fromJSON(object.endLocation)
        : isSet(object.end_location)
        ? Point.fromJSON(object.end_location)
        : undefined,
      endHeading: isSet(object.endHeading)
        ? globalThis.Number(object.endHeading)
        : isSet(object.end_heading)
        ? globalThis.Number(object.end_heading)
        : undefined,
    };
  },

  toJSON(message: StopManualTaskRequest): unknown {
    const obj: any = {};
    if (message.endLocation !== undefined) {
      obj.endLocation = Point.toJSON(message.endLocation);
    }
    if (message.endHeading !== undefined) {
      obj.endHeading = message.endHeading;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<StopManualTaskRequest>, I>>(base?: I): StopManualTaskRequest {
    return StopManualTaskRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<StopManualTaskRequest>, I>>(object: I): StopManualTaskRequest {
    const message = createBaseStopManualTaskRequest();
    message.endLocation = (object.endLocation !== undefined && object.endLocation !== null)
      ? Point.fromPartial(object.endLocation)
      : undefined;
    message.endHeading = object.endHeading ?? undefined;
    return message;
  },
};

function createBaseCreateEnterRowTaskRequest(): CreateEnterRowTaskRequest {
  return { tractorLocation: undefined, tractorHeading: 0 };
}

export const CreateEnterRowTaskRequest: MessageFns<CreateEnterRowTaskRequest> = {
  encode(message: CreateEnterRowTaskRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.tractorLocation !== undefined) {
      Point.encode(message.tractorLocation, writer.uint32(10).fork()).join();
    }
    if (message.tractorHeading !== 0) {
      writer.uint32(17).double(message.tractorHeading);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CreateEnterRowTaskRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCreateEnterRowTaskRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.tractorLocation = Point.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 17) {
            break;
          }

          message.tractorHeading = reader.double();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CreateEnterRowTaskRequest {
    return {
      tractorLocation: isSet(object.tractorLocation)
        ? Point.fromJSON(object.tractorLocation)
        : isSet(object.tractor_location)
        ? Point.fromJSON(object.tractor_location)
        : undefined,
      tractorHeading: isSet(object.tractorHeading)
        ? globalThis.Number(object.tractorHeading)
        : isSet(object.tractor_heading)
        ? globalThis.Number(object.tractor_heading)
        : 0,
    };
  },

  toJSON(message: CreateEnterRowTaskRequest): unknown {
    const obj: any = {};
    if (message.tractorLocation !== undefined) {
      obj.tractorLocation = Point.toJSON(message.tractorLocation);
    }
    if (message.tractorHeading !== 0) {
      obj.tractorHeading = message.tractorHeading;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CreateEnterRowTaskRequest>, I>>(base?: I): CreateEnterRowTaskRequest {
    return CreateEnterRowTaskRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CreateEnterRowTaskRequest>, I>>(object: I): CreateEnterRowTaskRequest {
    const message = createBaseCreateEnterRowTaskRequest();
    message.tractorLocation = (object.tractorLocation !== undefined && object.tractorLocation !== null)
      ? Point.fromPartial(object.tractorLocation)
      : undefined;
    message.tractorHeading = object.tractorHeading ?? 0;
    return message;
  },
};

function createBaseCreateExitRowTaskRequest(): CreateExitRowTaskRequest {
  return { tractorLocation: undefined, tractorHeading: 0 };
}

export const CreateExitRowTaskRequest: MessageFns<CreateExitRowTaskRequest> = {
  encode(message: CreateExitRowTaskRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.tractorLocation !== undefined) {
      Point.encode(message.tractorLocation, writer.uint32(10).fork()).join();
    }
    if (message.tractorHeading !== 0) {
      writer.uint32(17).double(message.tractorHeading);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CreateExitRowTaskRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCreateExitRowTaskRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.tractorLocation = Point.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 17) {
            break;
          }

          message.tractorHeading = reader.double();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CreateExitRowTaskRequest {
    return {
      tractorLocation: isSet(object.tractorLocation)
        ? Point.fromJSON(object.tractorLocation)
        : isSet(object.tractor_location)
        ? Point.fromJSON(object.tractor_location)
        : undefined,
      tractorHeading: isSet(object.tractorHeading)
        ? globalThis.Number(object.tractorHeading)
        : isSet(object.tractor_heading)
        ? globalThis.Number(object.tractor_heading)
        : 0,
    };
  },

  toJSON(message: CreateExitRowTaskRequest): unknown {
    const obj: any = {};
    if (message.tractorLocation !== undefined) {
      obj.tractorLocation = Point.toJSON(message.tractorLocation);
    }
    if (message.tractorHeading !== 0) {
      obj.tractorHeading = message.tractorHeading;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CreateExitRowTaskRequest>, I>>(base?: I): CreateExitRowTaskRequest {
    return CreateExitRowTaskRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CreateExitRowTaskRequest>, I>>(object: I): CreateExitRowTaskRequest {
    const message = createBaseCreateExitRowTaskRequest();
    message.tractorLocation = (object.tractorLocation !== undefined && object.tractorLocation !== null)
      ? Point.fromPartial(object.tractorLocation)
      : undefined;
    message.tractorHeading = object.tractorHeading ?? 0;
    return message;
  },
};

function createBaseCreateFollowPathTaskRequest(): CreateFollowPathTaskRequest {
  return { robotSerial: "", path: undefined, speedMS: 0 };
}

export const CreateFollowPathTaskRequest: MessageFns<CreateFollowPathTaskRequest> = {
  encode(message: CreateFollowPathTaskRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.robotSerial !== "") {
      writer.uint32(10).string(message.robotSerial);
    }
    if (message.path !== undefined) {
      LineString.encode(message.path, writer.uint32(18).fork()).join();
    }
    if (message.speedMS !== 0) {
      writer.uint32(25).double(message.speedMS);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CreateFollowPathTaskRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCreateFollowPathTaskRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.robotSerial = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.path = LineString.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 25) {
            break;
          }

          message.speedMS = reader.double();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CreateFollowPathTaskRequest {
    return {
      robotSerial: isSet(object.robotSerial)
        ? globalThis.String(object.robotSerial)
        : isSet(object.robot_serial)
        ? globalThis.String(object.robot_serial)
        : "",
      path: isSet(object.path) ? LineString.fromJSON(object.path) : undefined,
      speedMS: isSet(object.speedMS)
        ? globalThis.Number(object.speedMS)
        : isSet(object.speed_m_s)
        ? globalThis.Number(object.speed_m_s)
        : 0,
    };
  },

  toJSON(message: CreateFollowPathTaskRequest): unknown {
    const obj: any = {};
    if (message.robotSerial !== "") {
      obj.robotSerial = message.robotSerial;
    }
    if (message.path !== undefined) {
      obj.path = LineString.toJSON(message.path);
    }
    if (message.speedMS !== 0) {
      obj.speedMS = message.speedMS;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CreateFollowPathTaskRequest>, I>>(base?: I): CreateFollowPathTaskRequest {
    return CreateFollowPathTaskRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CreateFollowPathTaskRequest>, I>>(object: I): CreateFollowPathTaskRequest {
    const message = createBaseCreateFollowPathTaskRequest();
    message.robotSerial = object.robotSerial ?? "";
    message.path = (object.path !== undefined && object.path !== null)
      ? LineString.fromPartial(object.path)
      : undefined;
    message.speedMS = object.speedMS ?? 0;
    return message;
  },
};

function createBaseCalibrateLaserWeedObjectiveRequest(): CalibrateLaserWeedObjectiveRequest {
  return { shiftM: undefined, robotSerial: undefined };
}

export const CalibrateLaserWeedObjectiveRequest: MessageFns<CalibrateLaserWeedObjectiveRequest> = {
  encode(message: CalibrateLaserWeedObjectiveRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.shiftM !== undefined) {
      writer.uint32(17).double(message.shiftM);
    }
    if (message.robotSerial !== undefined) {
      writer.uint32(26).string(message.robotSerial);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CalibrateLaserWeedObjectiveRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCalibrateLaserWeedObjectiveRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 17) {
            break;
          }

          message.shiftM = reader.double();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.robotSerial = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CalibrateLaserWeedObjectiveRequest {
    return {
      shiftM: isSet(object.shiftM)
        ? globalThis.Number(object.shiftM)
        : isSet(object.shift_m)
        ? globalThis.Number(object.shift_m)
        : undefined,
      robotSerial: isSet(object.robotSerial)
        ? globalThis.String(object.robotSerial)
        : isSet(object.robot_serial)
        ? globalThis.String(object.robot_serial)
        : undefined,
    };
  },

  toJSON(message: CalibrateLaserWeedObjectiveRequest): unknown {
    const obj: any = {};
    if (message.shiftM !== undefined) {
      obj.shiftM = message.shiftM;
    }
    if (message.robotSerial !== undefined) {
      obj.robotSerial = message.robotSerial;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CalibrateLaserWeedObjectiveRequest>, I>>(
    base?: I,
  ): CalibrateLaserWeedObjectiveRequest {
    return CalibrateLaserWeedObjectiveRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CalibrateLaserWeedObjectiveRequest>, I>>(
    object: I,
  ): CalibrateLaserWeedObjectiveRequest {
    const message = createBaseCalibrateLaserWeedObjectiveRequest();
    message.shiftM = object.shiftM ?? undefined;
    message.robotSerial = object.robotSerial ?? undefined;
    return message;
  },
};

function createBaseCalibrateLaserWeedJobRequest(): CalibrateLaserWeedJobRequest {
  return { objectiveId: 0, shiftM: undefined, robotSerial: undefined, updatePlantingHeading: false };
}

export const CalibrateLaserWeedJobRequest: MessageFns<CalibrateLaserWeedJobRequest> = {
  encode(message: CalibrateLaserWeedJobRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.objectiveId !== 0) {
      writer.uint32(8).uint64(message.objectiveId);
    }
    if (message.shiftM !== undefined) {
      writer.uint32(17).double(message.shiftM);
    }
    if (message.robotSerial !== undefined) {
      writer.uint32(26).string(message.robotSerial);
    }
    if (message.updatePlantingHeading !== false) {
      writer.uint32(32).bool(message.updatePlantingHeading);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CalibrateLaserWeedJobRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCalibrateLaserWeedJobRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.objectiveId = longToNumber(reader.uint64());
          continue;
        }
        case 2: {
          if (tag !== 17) {
            break;
          }

          message.shiftM = reader.double();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.robotSerial = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.updatePlantingHeading = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CalibrateLaserWeedJobRequest {
    return {
      objectiveId: isSet(object.objectiveId)
        ? globalThis.Number(object.objectiveId)
        : isSet(object.objective_id)
        ? globalThis.Number(object.objective_id)
        : 0,
      shiftM: isSet(object.shiftM)
        ? globalThis.Number(object.shiftM)
        : isSet(object.shift_m)
        ? globalThis.Number(object.shift_m)
        : undefined,
      robotSerial: isSet(object.robotSerial)
        ? globalThis.String(object.robotSerial)
        : isSet(object.robot_serial)
        ? globalThis.String(object.robot_serial)
        : undefined,
      updatePlantingHeading: isSet(object.updatePlantingHeading)
        ? globalThis.Boolean(object.updatePlantingHeading)
        : isSet(object.update_planting_heading)
        ? globalThis.Boolean(object.update_planting_heading)
        : false,
    };
  },

  toJSON(message: CalibrateLaserWeedJobRequest): unknown {
    const obj: any = {};
    if (message.objectiveId !== 0) {
      obj.objectiveId = Math.round(message.objectiveId);
    }
    if (message.shiftM !== undefined) {
      obj.shiftM = message.shiftM;
    }
    if (message.robotSerial !== undefined) {
      obj.robotSerial = message.robotSerial;
    }
    if (message.updatePlantingHeading !== false) {
      obj.updatePlantingHeading = message.updatePlantingHeading;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CalibrateLaserWeedJobRequest>, I>>(base?: I): CalibrateLaserWeedJobRequest {
    return CalibrateLaserWeedJobRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CalibrateLaserWeedJobRequest>, I>>(object: I): CalibrateLaserWeedJobRequest {
    const message = createBaseCalibrateLaserWeedJobRequest();
    message.objectiveId = object.objectiveId ?? 0;
    message.shiftM = object.shiftM ?? undefined;
    message.robotSerial = object.robotSerial ?? undefined;
    message.updatePlantingHeading = object.updatePlantingHeading ?? false;
    return message;
  },
};

function createBaseChecklistInvalidationRequest(): ChecklistInvalidationRequest {
  return {};
}

export const ChecklistInvalidationRequest: MessageFns<ChecklistInvalidationRequest> = {
  encode(_: ChecklistInvalidationRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ChecklistInvalidationRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseChecklistInvalidationRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): ChecklistInvalidationRequest {
    return {};
  },

  toJSON(_: ChecklistInvalidationRequest): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<ChecklistInvalidationRequest>, I>>(base?: I): ChecklistInvalidationRequest {
    return ChecklistInvalidationRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ChecklistInvalidationRequest>, I>>(_: I): ChecklistInvalidationRequest {
    const message = createBaseChecklistInvalidationRequest();
    return message;
  },
};

function createBaseChecklistInvalidationResponse(): ChecklistInvalidationResponse {
  return {};
}

export const ChecklistInvalidationResponse: MessageFns<ChecklistInvalidationResponse> = {
  encode(_: ChecklistInvalidationResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ChecklistInvalidationResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseChecklistInvalidationResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): ChecklistInvalidationResponse {
    return {};
  },

  toJSON(_: ChecklistInvalidationResponse): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<ChecklistInvalidationResponse>, I>>(base?: I): ChecklistInvalidationResponse {
    return ChecklistInvalidationResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ChecklistInvalidationResponse>, I>>(_: I): ChecklistInvalidationResponse {
    const message = createBaseChecklistInvalidationResponse();
    return message;
  },
};

function createBaseCreatePlannedJobRequest(): CreatePlannedJobRequest {
  return {
    job: undefined,
    sequences: [],
    pathPlannerSource: undefined,
    pathPlannerVersion: undefined,
    pathPlannerMetadata: undefined,
    pathPlannerMetadataFormat: 0,
  };
}

export const CreatePlannedJobRequest: MessageFns<CreatePlannedJobRequest> = {
  encode(message: CreatePlannedJobRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.job !== undefined) {
      CreateJobRequest.encode(message.job, writer.uint32(10).fork()).join();
    }
    for (const v of message.sequences) {
      SequenceTask.encode(v!, writer.uint32(18).fork()).join();
    }
    if (message.pathPlannerSource !== undefined) {
      writer.uint32(26).string(message.pathPlannerSource);
    }
    if (message.pathPlannerVersion !== undefined) {
      writer.uint32(34).string(message.pathPlannerVersion);
    }
    if (message.pathPlannerMetadata !== undefined) {
      Struct.encode(Struct.wrap(message.pathPlannerMetadata), writer.uint32(42).fork()).join();
    }
    if (message.pathPlannerMetadataFormat !== 0) {
      writer.uint32(48).int32(message.pathPlannerMetadataFormat);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CreatePlannedJobRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCreatePlannedJobRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.job = CreateJobRequest.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.sequences.push(SequenceTask.decode(reader, reader.uint32()));
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.pathPlannerSource = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.pathPlannerVersion = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.pathPlannerMetadata = Struct.unwrap(Struct.decode(reader, reader.uint32()));
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.pathPlannerMetadataFormat = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CreatePlannedJobRequest {
    return {
      job: isSet(object.job) ? CreateJobRequest.fromJSON(object.job) : undefined,
      sequences: globalThis.Array.isArray(object?.sequences)
        ? object.sequences.map((e: any) => SequenceTask.fromJSON(e))
        : [],
      pathPlannerSource: isSet(object.pathPlannerSource)
        ? globalThis.String(object.pathPlannerSource)
        : isSet(object.path_planner_source)
        ? globalThis.String(object.path_planner_source)
        : undefined,
      pathPlannerVersion: isSet(object.pathPlannerVersion)
        ? globalThis.String(object.pathPlannerVersion)
        : isSet(object.path_planner_version)
        ? globalThis.String(object.path_planner_version)
        : undefined,
      pathPlannerMetadata: isObject(object.pathPlannerMetadata)
        ? object.pathPlannerMetadata
        : isObject(object.path_planner_metadata)
        ? object.path_planner_metadata
        : undefined,
      pathPlannerMetadataFormat: isSet(object.pathPlannerMetadataFormat)
        ? pathPlannerMetadataFormatFromJSON(object.pathPlannerMetadataFormat)
        : isSet(object.path_planner_metadata_format)
        ? pathPlannerMetadataFormatFromJSON(object.path_planner_metadata_format)
        : 0,
    };
  },

  toJSON(message: CreatePlannedJobRequest): unknown {
    const obj: any = {};
    if (message.job !== undefined) {
      obj.job = CreateJobRequest.toJSON(message.job);
    }
    if (message.sequences?.length) {
      obj.sequences = message.sequences.map((e) => SequenceTask.toJSON(e));
    }
    if (message.pathPlannerSource !== undefined) {
      obj.pathPlannerSource = message.pathPlannerSource;
    }
    if (message.pathPlannerVersion !== undefined) {
      obj.pathPlannerVersion = message.pathPlannerVersion;
    }
    if (message.pathPlannerMetadata !== undefined) {
      obj.pathPlannerMetadata = message.pathPlannerMetadata;
    }
    if (message.pathPlannerMetadataFormat !== 0) {
      obj.pathPlannerMetadataFormat = pathPlannerMetadataFormatToJSON(message.pathPlannerMetadataFormat);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CreatePlannedJobRequest>, I>>(base?: I): CreatePlannedJobRequest {
    return CreatePlannedJobRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CreatePlannedJobRequest>, I>>(object: I): CreatePlannedJobRequest {
    const message = createBaseCreatePlannedJobRequest();
    message.job = (object.job !== undefined && object.job !== null)
      ? CreateJobRequest.fromPartial(object.job)
      : undefined;
    message.sequences = object.sequences?.map((e) => SequenceTask.fromPartial(e)) || [];
    message.pathPlannerSource = object.pathPlannerSource ?? undefined;
    message.pathPlannerVersion = object.pathPlannerVersion ?? undefined;
    message.pathPlannerMetadata = object.pathPlannerMetadata ?? undefined;
    message.pathPlannerMetadataFormat = object.pathPlannerMetadataFormat ?? 0;
    return message;
  },
};

function createBaseUpdatePlannedJobRequest(): UpdatePlannedJobRequest {
  return {
    sequences: [],
    pathPlannerSource: undefined,
    pathPlannerVersion: undefined,
    pathPlannerMetadata: undefined,
    pathPlannerMetadataFormat: 0,
  };
}

export const UpdatePlannedJobRequest: MessageFns<UpdatePlannedJobRequest> = {
  encode(message: UpdatePlannedJobRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.sequences) {
      SequenceTask.encode(v!, writer.uint32(10).fork()).join();
    }
    if (message.pathPlannerSource !== undefined) {
      writer.uint32(18).string(message.pathPlannerSource);
    }
    if (message.pathPlannerVersion !== undefined) {
      writer.uint32(26).string(message.pathPlannerVersion);
    }
    if (message.pathPlannerMetadata !== undefined) {
      Struct.encode(Struct.wrap(message.pathPlannerMetadata), writer.uint32(34).fork()).join();
    }
    if (message.pathPlannerMetadataFormat !== 0) {
      writer.uint32(40).int32(message.pathPlannerMetadataFormat);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UpdatePlannedJobRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUpdatePlannedJobRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.sequences.push(SequenceTask.decode(reader, reader.uint32()));
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.pathPlannerSource = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.pathPlannerVersion = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.pathPlannerMetadata = Struct.unwrap(Struct.decode(reader, reader.uint32()));
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.pathPlannerMetadataFormat = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UpdatePlannedJobRequest {
    return {
      sequences: globalThis.Array.isArray(object?.sequences)
        ? object.sequences.map((e: any) => SequenceTask.fromJSON(e))
        : [],
      pathPlannerSource: isSet(object.pathPlannerSource)
        ? globalThis.String(object.pathPlannerSource)
        : isSet(object.path_planner_source)
        ? globalThis.String(object.path_planner_source)
        : undefined,
      pathPlannerVersion: isSet(object.pathPlannerVersion)
        ? globalThis.String(object.pathPlannerVersion)
        : isSet(object.path_planner_version)
        ? globalThis.String(object.path_planner_version)
        : undefined,
      pathPlannerMetadata: isObject(object.pathPlannerMetadata)
        ? object.pathPlannerMetadata
        : isObject(object.path_planner_metadata)
        ? object.path_planner_metadata
        : undefined,
      pathPlannerMetadataFormat: isSet(object.pathPlannerMetadataFormat)
        ? pathPlannerMetadataFormatFromJSON(object.pathPlannerMetadataFormat)
        : isSet(object.path_planner_metadata_format)
        ? pathPlannerMetadataFormatFromJSON(object.path_planner_metadata_format)
        : 0,
    };
  },

  toJSON(message: UpdatePlannedJobRequest): unknown {
    const obj: any = {};
    if (message.sequences?.length) {
      obj.sequences = message.sequences.map((e) => SequenceTask.toJSON(e));
    }
    if (message.pathPlannerSource !== undefined) {
      obj.pathPlannerSource = message.pathPlannerSource;
    }
    if (message.pathPlannerVersion !== undefined) {
      obj.pathPlannerVersion = message.pathPlannerVersion;
    }
    if (message.pathPlannerMetadata !== undefined) {
      obj.pathPlannerMetadata = message.pathPlannerMetadata;
    }
    if (message.pathPlannerMetadataFormat !== 0) {
      obj.pathPlannerMetadataFormat = pathPlannerMetadataFormatToJSON(message.pathPlannerMetadataFormat);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<UpdatePlannedJobRequest>, I>>(base?: I): UpdatePlannedJobRequest {
    return UpdatePlannedJobRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UpdatePlannedJobRequest>, I>>(object: I): UpdatePlannedJobRequest {
    const message = createBaseUpdatePlannedJobRequest();
    message.sequences = object.sequences?.map((e) => SequenceTask.fromPartial(e)) || [];
    message.pathPlannerSource = object.pathPlannerSource ?? undefined;
    message.pathPlannerVersion = object.pathPlannerVersion ?? undefined;
    message.pathPlannerMetadata = object.pathPlannerMetadata ?? undefined;
    message.pathPlannerMetadataFormat = object.pathPlannerMetadataFormat ?? 0;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function toTimestamp(dateStr: string): Timestamp {
  const date = new globalThis.Date(dateStr);
  const seconds = Math.trunc(date.getTime() / 1_000);
  const nanos = (date.getTime() % 1_000) * 1_000_000;
  return { seconds, nanos };
}

function fromTimestamp(t: Timestamp): string {
  let millis = (t.seconds || 0) * 1_000;
  millis += (t.nanos || 0) / 1_000_000;
  return new globalThis.Date(millis).toISOString();
}

function longToNumber(int64: { toString(): string }): number {
  const num = globalThis.Number(int64.toString());
  if (num > globalThis.Number.MAX_SAFE_INTEGER) {
    throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
  }
  if (num < globalThis.Number.MIN_SAFE_INTEGER) {
    throw new globalThis.Error("Value is smaller than Number.MIN_SAFE_INTEGER");
  }
  return num;
}

function isObject(value: any): boolean {
  return typeof value === "object" && value !== null;
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
